import {
    ligainicial
} from "./rutainicial.js";

const ligabase = ligainicial + "2024/Lic/C";

export const licitaciones2024 = [
    {
        // CONVOCATORIA NUM# 030
            'numConvocatoria' : 'Convocatoria No. 030/2024.',
            'idConvocatoria' : 'Convocatoria30',
            'procedimientos' : [
        // Licitación N341
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N341-2024.',
                    'vigencia' : 'Vigencia de venta de bases: del 2 al 9 de diciembre de 2024',
                    'descripcionProcedimiento' : 'Estudios de prefactibilidad para la construcción de las obras de protección margen izquierda del Río de las Avenidas, tramo ubicado dentro del Parque Industrial Platah; ubicado en la localidad de PLATAH (Parque Industrial), Municipio de Villa de Tezontepec, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }30/N341/N341.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }30/N341/JAN341.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }30/N341/APN341.pdf`,
                       },
                    //    {
                    //        'resultado' : 'Fallo',
                    //        'urlresultado' : `${ ligabase }30/N341/FAN341.pdf`,
                    //    },
                    ],
                },
        // Licitación N340
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N340-2024.',
                    'vigencia' : 'Vigencia de venta de bases: del 2 al 9 de diciembre de 2024.',
                    'descripcionProcedimiento' : 'Blvd. E.C. Tolcayuca-Villa de Tezontepec-Téllez con una sección propuesta de vialidad de 30.00 m para la construcción del Boulevard de acceso Tolcayuca-Villa de Tezontepec-Téllez; ubicado en la localidad de Tezontepec, Municipio de Villa de Tezontepec, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }30/N340/N340.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }30/N340/JAN340.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }30/N340/APN340.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }30/N340/FAN340.pdf`,
                       },
                    ],
                },
        // Licitación N339
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N339-2024.',
                    'vigencia' : 'Vigencia de venta de bases: del 2 al 9 de diciembre de 2024.',
                    'descripcionProcedimiento' : 'Estudio y proyecto para la línea de conducción marginal, tramo Acopinalco – Ciudad Sahagún, incluye proyecto ejecutivo, estudio hidrológico, delimitación de zona federal para su ocupación, con base en el trámite CONAGUA-02-002, manifiesto de impacto ambiental y análisis costo beneficio; ubicado en varias localidades de Cobertura Regional.',
                    'urlAnexos' : `${ ligabase }30/N339/N339.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }30/N339/JAN339.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }30/N339/APN339.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }30/N339/FAN339.pdf`,
                       },
                    ],
                },
        // Licitación N338
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N338-2024.',
                    'vigencia' : 'Vigencia de venta de bases: del 2 al 9 de diciembre de 2024.',
                    'descripcionProcedimiento' : 'Estudio y proyecto de reutilización del agua tratada para abastecer a la Zona Industrial de Emiliano Zapata (Región Altiplano); de Cobertura Estatal.',
                    'urlAnexos' : `${ ligabase }30/N338/N338.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }30/N338/JAN338.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }30/N338/APN338.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }30/N338/FAN338.pdf`,
                       },
                    ],
                },
        // Licitación N337
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N337-2024.',
                    'vigencia' : 'Vigencia de venta de bases: del 2 al 9 de diciembre de 2024.',
                    'descripcionProcedimiento' : 'Rehabilitación de planta de tratamiento de aguas residuales en Tolcayuca.; ubicada en la localidad y Municipio de Tolcayuca, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }30/N337/N337.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }30/N337/JAN337.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }30/N337/APN337.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }30/N337/FAN337.pdf`,
                       },
                    ],
                },
        // Licitación N336
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N336-2024.',
                    'vigencia' : 'Vigencia de venta de bases: del 2 al 9 de diciembre de 2024.',
                    'descripcionProcedimiento' : 'Rehabilitación de planta de tratamiento de aguas residuales en la cabecera municipal de Emiliano Zapata.; ubicada en la localidad y Municipio de Emiliano Zapata, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }30/N336/N336.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }30/N336/JAN336.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }30/N336/APN336.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }30/N336/FAN336.pdf`,
                       },
                    ],
                },
        // Licitación N335
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N335-2024.',
                    'vigencia' : 'Vigencia de venta de bases: del 2 al 9 de diciembre de 2024.',
                    'descripcionProcedimiento' : 'Rehabilitación del Camino a Pachiquitla a entronque ramal a Xochiatipan, municipio de Xochiatipan.; ubicada en la localidad de Pachiquita, Municipio de Xochiatipan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }30/N335/N335.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }30/N335/JAN335.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }30/N335/APN335.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }30/N335/FAN335.pdf`,
                       },
                    ],
                },
        // Licitación N334
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N334-2024.',
                    'vigencia' : 'Vigencia de venta de bases: del 2 al 9 de diciembre de 2024.',
                    'descripcionProcedimiento' : 'Trabajos complementarios para la Unidad Básica de Rehabilitación (UBR) de Tulancingo de Bravo.; ubicada en la localidad de Santiago Caltengo, Municipio de Tulancingo de Bravo, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }30/N334/N334.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }30/N334/JAN334.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }30/N334/APN334.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }30/N334/FAN334.pdf`,
                       },
                    ],
                },
        // Licitación N333
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N333-2024.',
                    'vigencia' : 'Vigencia de venta de bases: del 2 al 6 de diciembre de 2024.',
                    'descripcionProcedimiento' : 'Construcción de la casa de la mujer indígena 1er etapa en el municipio de Atlapexco; ubicada en la localidad y Municipio de Atlapexco, Estado de Hidalgo.(Segundo procedimiento)',
                    'urlAnexos' : `${ ligabase }30/N333/N333.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }30/N333/JAN333.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }30/N333/APN333.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }30/N333/FAN333.pdf`,
                       },
                    ],
                },
        // Licitación N332
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N332-2024.',
                    'vigencia' : 'Vigencia de venta de bases: del 2 al 6 de diciembre de 2024.',
                    'descripcionProcedimiento' : 'Segunda etapa del Centro Cultural Regional de la Sierra Otomí Tepehua; ubicada en la localidad y Municipio de Tenango de Doria, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }30/N332/N332.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }30/N332/JAN332.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }30/N332/APN332.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }30/N332/FAN332.pdf`,
                       },
                    ],
                },
        // Licitación N331
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N331-2024.',
                    'vigencia' : 'Vigencia de venta de bases: del 2 al 6 de diciembre de 2024.',
                    'descripcionProcedimiento' : 'Mantenimiento del Centro Cultural Regional Zacualtipán; ubicada en la localidad de Zacualtipán, Municipio de Zacualtipán de Ángeles, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }30/N331/N331.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }30/N331/JAN331.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }30/N331/APN331.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }30/N331/FAN331.pdf`,
                       },
                    ],
                },
        // Licitación N330
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N330-2024.',
                    'vigencia' : 'Vigencia de venta de bases: del 2 al 6 de diciembre de 2024.',
                    'descripcionProcedimiento' : 'Construcción de Sistema Integral de Abastecimiento de Agua Potable en la cabecera municipal de Chapulhuacan (2da Etapa).; ubicada en la localidad y Municipio de Chapulhuacán, Estado de Hidalgo. (Segundo procedimiento)',
                    'urlAnexos' : `${ ligabase }30/N330/N330.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }30/N330/JAN330.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }30/N330/APN330.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }30/N330/FAN330.pdf`,
                       },
                    ],
                },
        // Licitación N329
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N329-2024.',
                    'vigencia' : 'Vigencia de venta de bases: del 2 al 6 de diciembre de 2024.',
                    'descripcionProcedimiento' : 'Pavimentación del acceso a la Col. La Peña, en la comunidad de El Jardin, municipio de Progreso de Obregón.; ubicada en la localidad de El Jardín (Colonia), Municipio de Progreso de Obregón, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }30/N329/N329.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }30/N329/JAN329.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }30/N329/APN329.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }30/N329/FAN329.pdf`,
                       },
                    ],
                },
        // Licitación N328
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N328-2024.',
                    'vigencia' : 'Vigencia de venta de bases: del 2 al 6 de diciembre de 2024.',
                    'descripcionProcedimiento' : 'Reconstrucción de la C.E. Libramiento Sur Huejutla - (E.C. Pachuca - Tempoal), municipio de Huejutla de Reyes.; ubicada en la localidad de Xiloco, Municipio de Huejutla de Reyes, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }30/N328/N328.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }30/N328/JAN328.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }30/N328/APN328.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }30/N328/FAN328.pdf`,
                       },
                    ],
                },
        // Licitación N327
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N327-2024.',
                    'vigencia' : 'Vigencia de venta de bases: del 2 al 6 de diciembre de 2024.',
                    'descripcionProcedimiento' : 'Programa de Campo Limpio.; de Cobertura Estatal.(Segundo procedimiento)',
                    'urlAnexos' : `${ ligabase }30/N327/N327.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }30/N327/JAN327.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }30/N327/APN327.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }30/N327/FAN327.pdf`,
                       },
                    ],
                },
        // Licitación N326
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N326-2024.',
                    'vigencia' : 'Vigencia de venta de bases: del 2 al 6 de diciembre de 2024.',
                    'descripcionProcedimiento' : 'Construcción de pavimento hidráulico en calle Zapata en la localidad de Estación de Apulco, en el municipio de Metepec; ubicada en la localidad de Estación de Apulco, Municipio de Metepec, Estado de Hidalgo. (Segundo procedimiento)',
                    'urlAnexos' : `${ ligabase }30/N326/N326.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }30/N326/JAN326.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }30/N326/APN326.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }30/N326/FAN326.pdf`,
                       },
                    ],
                },
            ],
    },
    {        
        // CONVOCATORIA NUM# 029
            'numConvocatoria' : 'Convocatoria No. 029/2024.',
            'idConvocatoria' : 'Convocatoria29',
            'procedimientos' : [
    // Licitación N325
    {
        'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N325-2024.',
        'vigencia' : 'Vigencia de venta de bases: del 25 de noviembre al 2 de diciembre  de 2024',
        'descripcionProcedimiento' : 'Pavimentación hidráulica y construcción de muro de contención en la C.E. acceso a Toctitlán, municipio de Tlanchinol; ubicada en la localidad de San Salvador, Municipio de Tlanchinol, Estado de Hidalgo.',
        'urlAnexos' : `${ ligabase }29/N325/N325.rar`,
        'resultados' : [
           {
               'resultado' : 'Aclaraciones',
               'urlresultado' : `${ ligabase }29/N325/JAN325.pdf`,
           },
           {
               'resultado' : 'Apertura',
               'urlresultado' : `${ ligabase }29/N325/APN325.pdf`,
           },
           {
               'resultado' : 'Fallo',
               'urlresultado' : `${ ligabase }29/N325/FAN325.pdf`,
           },
        ],
    },
// Licitación N324
    {
        'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N324-2024.',
        'vigencia' : 'Vigencia de venta de bases: del 25 de noviembre al 2 de diciembre  de 2024.',
        'descripcionProcedimiento' : 'Rehabilitación de acceso a Nicolás Flores vía Bocua - Cerro de la Cruz, municipio de Nicolás Flores.; ubicada en la localidad de , Municipio de Nicolás Flores, Estado de Hidalgo.',
        'urlAnexos' : `${ ligabase }29/N324/N324.rar`,
        'resultados' : [
           {
               'resultado' : 'Aclaraciones',
               'urlresultado' : `${ ligabase }29/N324/JAN324.pdf`,
           },
           {
            'resultado' : 'Anexo modificatorio',
            'urlresultado' : `${ ligabase }29/N324/AMDJAN324.pdf`,
            },
           {
               'resultado' : 'Apertura',
               'urlresultado' : `${ ligabase }29/N324/APN324.pdf`,
           },
           {
               'resultado' : 'Fallo',
               'urlresultado' : `${ ligabase }29/N324/FAN324.pdf`,
           },
        ],
    },
// Licitación N323
    {
        'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N323-2024.',
        'vigencia' : 'Vigencia de venta de bases: del 25 de noviembre al 2 de diciembre  de 2024.',
        'descripcionProcedimiento' : 'Rehabilitación del Camino a Tierra Colorada, municipio de Tlanchinol.; ubicada en la localidad de Tierra Colorada, Municipio de Tlanchinol, Estado de Hidalgo.',
        'urlAnexos' : `${ ligabase }29/N323/N323.rar`,
        'resultados' : [
           {
               'resultado' : 'Aclaraciones',
               'urlresultado' : `${ ligabase }29/N323/JAN323.pdf`,
           },
           {
               'resultado' : 'Apertura',
               'urlresultado' : `${ ligabase }29/N323/APN323.pdf`,
           },
           {
               'resultado' : 'Fallo',
               'urlresultado' : `${ ligabase }29/N323/FAN323.pdf`,
           },
        ],
    },
// Licitación N322
    {
        'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N322-2024.',
        'vigencia' : 'Vigencia de venta de bases: del 25 de noviembre al 2 de diciembre  de 2024.',
        'descripcionProcedimiento' : 'Reconstrucción de la C.E. Agua Blanca-Zacualpa (segunda etapa); en el municipio de Agua Blanca de Iturbide.; ubicada en Varias localidades del Municipio de Agua Blanca de Iturbide, Estado de Hidalgo.',
        'urlAnexos' : `${ ligabase }29/N322/N322.rar`,
        'resultados' : [
           {
               'resultado' : 'Aclaraciones',
               'urlresultado' : `${ ligabase }29/N322/JAN322.pdf`,
           },
           {
               'resultado' : 'Apertura',
               'urlresultado' : `${ ligabase }29/N322/APN322.pdf`,
           },
           {
               'resultado' : 'Fallo',
               'urlresultado' : `${ ligabase }29/N322/FAN322.pdf`,
           },
        ],
    },
// Licitación N321
    {
        'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N321-2024.',
        'vigencia' : 'Vigencia de venta de bases: del 25 de noviembre al 2 de diciembre  de 2024.',
        'descripcionProcedimiento' : 'Construcción de pavimentación del tramo carretero C.R. Portezuelo a Santiago Ixtlahuaca, en el municipio de Tasquillo.; ubicada en la localidad de Portezuelos, Municipio de Tasquillo, Estado de Hidalgo.',
        'urlAnexos' : `${ ligabase }29/N321/N321.rar`,
        'resultados' : [
           {
               'resultado' : 'Aclaraciones',
               'urlresultado' : `${ ligabase }29/N321/JAN321.pdf`,
           },
           {
               'resultado' : 'Apertura',
               'urlresultado' : `${ ligabase }29/N321/APN321.pdf`,
           },
           {
               'resultado' : 'Fallo',
               'urlresultado' : `${ ligabase }29/N321/FAN321.pdf`,
           },
        ],
    },
// Licitación N320
    {
        'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N320-2024.',
        'vigencia' : 'Vigencia de venta de bases: del 25 de noviembre al 2 de diciembre  de 2024.',
        'descripcionProcedimiento' : 'Rehabilitación de planta de tratamiento de aguas residuales en la cabecera municipal, en Jacala de Ledezma.; ubicada en la localidad de Jacala, Municipio de Jacala de Ledezma, Estado de Hidalgo.',
        'urlAnexos' : `${ ligabase }29/N320/N320.rar`,
        'resultados' : [
           {
               'resultado' : 'Aclaraciones',
               'urlresultado' : `${ ligabase }29/N320/JAN320.pdf`,
           },
           {
               'resultado' : 'Apertura',
               'urlresultado' : `${ ligabase }29/N320/APN320.pdf`,
           },
           {
               'resultado' : 'Fallo',
               'urlresultado' : `${ ligabase }29/N320/FAN320.pdf`,
           },
        ],
    },
// Licitación N319
    {
        'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N319-2024.',
        'vigencia' : 'Vigencia de venta de bases: del 25 de noviembre al 2 de diciembre  de 2024.',
        'descripcionProcedimiento' : 'Elaboración de Estudio de Impacto Vial y Urbano para el Desarrollo de Proyectos Estratégicos Tipo Industrial para la Reserva Territorial Zapotlán; ubicado en la localidad y Municipio de Zapotlán de Juárez, Estado de Hidalgo.',
        'urlAnexos' : `${ ligabase }29/N319/N319.rar`,
        'resultados' : [
           {
               'resultado' : 'Aclaraciones',
               'urlresultado' : `${ ligabase }29/N319/JAN319.pdf`,
           },
           {
            'resultado' : 'Anexo modificatorio',
            'urlresultado' : `${ ligabase }29/N319/AMDJAN319.pdf`,
        },
           {
               'resultado' : 'Apertura',
               'urlresultado' : `${ ligabase }29/N319/APN319.pdf`,
           },
           {
               'resultado' : 'Fallo',
               'urlresultado' : `${ ligabase }29/N319/FAN319.pdf`,
           },
        ],
    },
// Licitación N318
    {
        'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N318-2024.',
        'vigencia' : 'Vigencia de venta de bases: del 25 de noviembre al 2 de diciembre  de 2024.',
        'descripcionProcedimiento' : 'Estudios de impacto ambiental y análisis costo beneficio para la continuación de la construcción de la vialidad y el encauzamiento del río de las avenidas, municipio de Mineral de la Reforma; ubicado en varias localidades del Municipio de Mineral de la Reforma, Estado de Hidalgo. (Segundo procedimiento)',
        'urlAnexos' : `${ ligabase }29/N318/N318.rar`,
        'resultados' : [
           {
               'resultado' : 'Aclaraciones',
               'urlresultado' : `${ ligabase }29/N318/JAN318.pdf`,
           },
           {
            'resultado' : 'Anexo modificatorio',
            'urlresultado' : `${ ligabase }29/N318/AMDJAN318.pdf`,
        },
           {
               'resultado' : 'Apertura',
               'urlresultado' : `${ ligabase }29/N318/APN318.pdf`,
           },
           {
               'resultado' : 'Fallo',
               'urlresultado' : `${ ligabase }29/N318/FAN318.pdf`,
           },
        ],
    },
// Licitación N317
    {
        'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N317-2024.',
        'vigencia' : 'Vigencia de venta de bases: del 25 de noviembre al 2 de diciembre  de 2024.',
        'descripcionProcedimiento' : 'Mejoramiento del Centro Estatal de Evaluación y Control de Confianza; ubicada en la localidad de San José Palma Gorda, Municipio de Pachuca de Soto, Estado de Hidalgo.',
        'urlAnexos' : `${ ligabase }29/N317/N317.rar`,
        'resultados' : [
           {
               'resultado' : 'Aclaraciones',
               'urlresultado' : `${ ligabase }29/N317/JAN317.pdf`,
           },
           {
               'resultado' : 'Apertura',
               'urlresultado' : `${ ligabase }29/N317/APN317.pdf`,
           },
           {
               'resultado' : 'Fallo',
               'urlresultado' : `${ ligabase }29/N317/FAN317.pdf`,
           },
        ],
    },
// Licitación N316
    {
        'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N316-2024.',
        'vigencia' : 'Vigencia de venta de bases: del 25 de noviembre al 2 de diciembre  de 2024.',
        'descripcionProcedimiento' : 'Mejoramiento del Instituto de Formación Profesional.; ubicada en la localidad de San José Palma Gorda, Municipio de Mineral de la Reforma, Estado de Hidalgo.',
        'urlAnexos' : `${ ligabase }29/N316/N316.rar`,
        'resultados' : [
           {
               'resultado' : 'Aclaraciones',
               'urlresultado' : `${ ligabase }29/N316/JAN316.pdf`,
           },
           {
               'resultado' : 'Apertura',
               'urlresultado' : `${ ligabase }29/N316/APN316.pdf`,
           },
           {
            'resultado' : 'Anexo modificatorio',
            'urlresultado' : `${ ligabase }29/N316/AMDAPN316.pdf`,
            },
           {
               'resultado' : 'Fallo',
               'urlresultado' : `${ ligabase }29/N316/FAN316.pdf`,
           },
        ],
    },
// Licitación N315
    {
        'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N315-2024.',
        'vigencia' : 'Vigencia de venta de bases: del 25 de noviembre al 2 de diciembre  de 2024.',
        'descripcionProcedimiento' : 'Rehabilitación de la Carretera paso por Tulancingo, municipio de Tulancingo de Bravo.; ubicada en la localidad de Tulancingo, Municipio de Tulancingo de Bravo, Estado de Hidalgo.',
        'urlAnexos' : `${ ligabase }29/N315/N315.rar`,
        'resultados' : [
           {
               'resultado' : 'Aclaraciones',
               'urlresultado' : `${ ligabase }29/N315/JAN315.pdf`,
           },
           {
               'resultado' : 'Apertura',
               'urlresultado' : `${ ligabase }29/N315/APN315.pdf`,
           },
           {
               'resultado' : 'Fallo',
               'urlresultado' : `${ ligabase }29/N315/FAN315.pdf`,
           },
        ],
    },
// Licitación N314
    {
        'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N314-2024.',
        'vigencia' : 'Vigencia de venta de bases: del 25 de noviembre al 2 de diciembre  de 2024.',
        'descripcionProcedimiento' : 'Rehabilitación de la Pavimentación de concreto hidráulico del acceso a la localidad de Ixtlahuac, municipio de Huazalingo.; ubicada en la localidad de Ixtlahuac, Municipio de Huazalingo, Estado de Hidalgo.',
        'urlAnexos' : `${ ligabase }29/N314/N314.rar`,
        'resultados' : [
           {
               'resultado' : 'Aclaraciones',
               'urlresultado' : `${ ligabase }29/N314/JAN314.pdf`,
           },
           {
               'resultado' : 'Apertura',
               'urlresultado' : `${ ligabase }29/N314/APN314.pdf`,
           },
           {
               'resultado' : 'Fallo',
               'urlresultado' : `${ ligabase }29/N314/FAN314.pdf`,
           },
        ],
    },
// Licitación N313
    {
        'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N313-2024.',
        'vigencia' : 'Vigencia de venta de bases: del 25 de noviembre al 2 de diciembre  de 2024.',
        'descripcionProcedimiento' : 'Reconstrucción del C.R. Jalpa - La Florida, municipio de Lolotla.; ubicada en la localidad de La Florida, Municipio de Lolotla, Estado de Hidalgo. (Segundo procedimiento)',
        'urlAnexos' : `${ ligabase }29/N313/N313.rar`,
        'resultados' : [
           {
               'resultado' : 'Aclaraciones',
               'urlresultado' : `${ ligabase }29/N313/JAN313.pdf`,
           },
           {
               'resultado' : 'Apertura',
               'urlresultado' : `${ ligabase }29/N313/APN313.pdf`,
           },
           {
               'resultado' : 'Fallo',
               'urlresultado' : `${ ligabase }29/N313/FAN313.pdf`,
           },
        ],
    },
// Licitación N312
    {
        'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N312-2024.',
        'vigencia' : 'Vigencia de venta de bases: del 25 de noviembre al 2 de diciembre  de 2024.',
        'descripcionProcedimiento' : 'Construcción de pavimentación de concreto hidráulico en acceso a la localidad La Laguna,municipio de Apan.; ubicada en la localidad de La Laguna, Municipio de Apan, Estado de Hidalgo. (Segundo procedimiento)',
        'urlAnexos' : `${ ligabase }29/N312/N312.rar`,
        'resultados' : [
           {
               'resultado' : 'Aclaraciones',
               'urlresultado' : `${ ligabase }29/N312/JAN312.pdf`,
           },
           {
               'resultado' : 'Apertura',
               'urlresultado' : `${ ligabase }29/N312/APN312.pdf`,
           },
           {
               'resultado' : 'Fallo',
               'urlresultado' : `${ ligabase }29/N312/FAN312.pdf`,
           },
        ],
    },
// Licitación N311
    {
        'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N311-2024.',
        'vigencia' : 'Vigencia de venta de bases: del 25 de noviembre al 2 de diciembre  de 2024.',
        'descripcionProcedimiento' : 'Rehabilitación de la Carretera Huejutla a Santa Cruz, municipio de Huejutla de Reyes.; ubicada en la localidad de Santa Cruz, Municipio de Huejutla de Reyes, Estado de Hidalgo.',
        'urlAnexos' : `${ ligabase }29/N311/N311.rar`,
        'resultados' : [
           {
               'resultado' : 'Aclaraciones',
               'urlresultado' : `${ ligabase }29/N311/JAN311.pdf`,
           },
           {
               'resultado' : 'Apertura',
               'urlresultado' : `${ ligabase }29/N311/APN311.pdf`,
           },
           {
               'resultado' : 'Fallo',
               'urlresultado' : `${ ligabase }29/N311/FAN311.pdf`,
           },
        ],
    },                
        // Licitación N310
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N310-2024.',
                    'vigencia' : 'Vigencia de venta de bases: del 25 al 29 de noviembre de 2024.',
                    'descripcionProcedimiento' : 'Rehabilitación de puente vehicular en la Carretera Cececapa a La Corrala, en la localidad de Cececapa, municipio de Huejutla de Reyes.; ubicada en la localidad de Cececapa, Municipio de Huejutla de Reyes, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }29/N310/N310.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }29/N310/JAN310.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }29/N310/APN310.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }29/N310/FAN310.pdf`,
                       },
                    ],
                },
        // Licitación N309
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N309-2024.',
                    'vigencia' : 'Vigencia de venta de bases: del 25 al 29 de noviembre de 2024.',
                    'descripcionProcedimiento' : 'Rehabilitación de C.E. Xiquila a Huejutla, municipio de Huejutla de Reyes.; ubicada en la localidad de Xiquila, Municipio de Huejutla de Reyes, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }29/N309/N309.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }29/N309/JAN309.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }29/N309/APN309.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }29/N309/FAN309.pdf`,
                       },
                    ],
                },
        // Licitación N308
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N308-2024.',
                    'vigencia' : 'Vigencia de venta de bases: del 25 al 29 de noviembre de 2024.',
                    'descripcionProcedimiento' : 'Rehabilitación de la C.E. Zacualtipán a Soyatla, tramo Oxpantla a Soyatla, en el municipio de Tianguistengo.; ubicada en la localidad de Soyatla, Municipio de Tianguistengo, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }29/N308/N308.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }29/N308/JAN308.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }29/N308/APN308.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }29/N308/FAN308.pdf`,
                       },
                    ],
                },
        // Licitación N307
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N307-2024.',
                    'vigencia' : 'Vigencia de venta de bases: del 25 al 29 de noviembre de 2024.',
                    'descripcionProcedimiento' : 'Rehabilitación de Puente Vado Achichípil, en la localidad de Achichípil, municipio de Huejutla de Reyes.; ubicada en la localidad de Achichipil, Municipio de Huejutla de Reyes, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }29/N307/N307.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }29/N307/JAN307.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }29/N307/APN307.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }29/N307/FAN307.pdf`,
                       },
                    ],
                },
        // Licitación N306
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N306-2024.',
                    'vigencia' : 'Vigencia de venta de bases: del 25 al 29 de noviembre de 2024.',
                    'descripcionProcedimiento' : 'Rehabilitación de la Carretera de Mazaquilico a Coacuilco, municipio de Huejutla de Reyes.; ubicada en la localidad de Coacuilco, Municipio de Huejutla de Reyes, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }29/N306/N306.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }29/N306/JAN306.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }29/N306/APN306.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }29/N306/FAN306.pdf`,
                       },
                    ],
                },
        // Licitación N305
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N305-2024.',
                    'vigencia' : 'Vigencia de venta de bases: del 25 al 29 de noviembre de 2024.',
                    'descripcionProcedimiento' : 'Rehabilitación de la Carretera Pachuca a Tempoal, paso por Huejutla, municipio de Huejutla de Reyes.; ubicada en la localidad y Municipio de Huejutla de Reyes, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }29/N305/N305.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }29/N305/JAN305.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }29/N305/APN305.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }29/N305/FAN305.pdf`,
                       },
                    ],
                },
        // Licitación N304
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N304-2024.',
                    'vigencia' : 'Vigencia de venta de bases: del 25 al 29 de noviembre de 2024.',
                    'descripcionProcedimiento' : 'Rehabilitación de la Carretera Atlapexco a Lolotla, Tramo: Acceso a la localidad de Itzócal, municipio de Atlapexco.; ubicada en la localidad de Itzócal, Municipio de Atlapexco, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }29/N304/N304.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }29/N304/JAN304.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }29/N304/APN304.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }29/N304/FAN304.pdf`,
                       },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 028
            'numConvocatoria' : 'Convocatoria No. 028/2024.',
            'idConvocatoria' : 'Convocatoria28',
            'procedimientos' : [
    // Licitación N303
    {
        'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N303-2024.',
        'vigencia' : 'Vigencia de venta de bases: del 18 al 26 de noviembre de 2024',
        'descripcionProcedimiento' : 'Construcción de tanque elevado capacidad de 250 m3 pozo 1 y 2 "El Bojayito", Los Tepetates, municipio de Tlaxcoapan.; ubicada en la localidad y Municipio de Tlaxcoapan, Estado de Hidalgo. (Segundo procedimiento)',
        'urlAnexos' : `${ ligabase }28/N303/N303.rar`,
        'resultados' : [
           {
               'resultado' : 'Aclaraciones',
               'urlresultado' : `${ ligabase }28/N303/JAN303.pdf`,
           },
           {
               'resultado' : 'Apertura',
               'urlresultado' : `${ ligabase }28/N303/APN303.pdf`,
           },
           {
               'resultado' : 'Fallo',
               'urlresultado' : `${ ligabase }28/N303/FAN303.pdf`,
           },
        ],
    },
// Licitación N302
    {
        'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N302-2024.',
        'vigencia' : 'Vigencia de venta de bases: del 18 al 26 de noviembre de 2024.',
        'descripcionProcedimiento' : 'Mejoramiento del Centro de Justicia para Mujeres del Estado de Hidalgo; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
        'urlAnexos' : `${ ligabase }28/N302/N302.rar`,
        'resultados' : [
           {
               'resultado' : 'Aclaraciones',
               'urlresultado' : `${ ligabase }28/N302/JAN302.pdf`,
           },
           {
               'resultado' : 'Apertura',
               'urlresultado' : `${ ligabase }28/N302/APN302.pdf`,
           },
           {
               'resultado' : 'Fallo',
               'urlresultado' : `${ ligabase }28/N302/FAN302.pdf`,
           },
        ],
    },
// Licitación N301
    {
        'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N301-2024.',
        'vigencia' : 'Vigencia de venta de bases: del 18 al 26 de noviembre de 2024.',
        'descripcionProcedimiento' : 'Reconstrucción de la C.E. San Bartolo - San Miguel, municipio de San Bartolo Tutotepec.; ubicada en la localidad y Municipio de San Bartolo Tutotepec, Estado de Hidalgo. (Segundo Procedimiento)',
        'urlAnexos' : `${ ligabase }28/N301/N301.rar`,
        'resultados' : [
           {
               'resultado' : 'Aclaraciones',
               'urlresultado' : `${ ligabase }28/N301/JAN301.pdf`,
           },
           {
               'resultado' : 'Apertura',
               'urlresultado' : `${ ligabase }28/N301/APN301.pdf`,
           },
           {
               'resultado' : 'Fallo',
               'urlresultado' : `${ ligabase }28/N301/FAN301.pdf`,
           },
        ],
    },
// Licitación N300
    {
        'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N300-2024.',
        'vigencia' : 'Vigencia de venta de bases: del 18 al 26 de noviembre de 2024.',
        'descripcionProcedimiento' : 'Construcción de sistema de agua potable en la localidad de Atotomoc, en el municipio de Atlapexco.; ubicada en la localidad de Atotomoc, Municipio de Atlapexco, Estado de Hidalgo.',
        'urlAnexos' : `${ ligabase }28/N300/N300.rar`,
        'resultados' : [
           {
               'resultado' : 'Aclaraciones',
               'urlresultado' : `${ ligabase }28/N300/JAN300.pdf`,
           },
           {
               'resultado' : 'Apertura',
               'urlresultado' : `${ ligabase }28/N300/APN300.pdf`,
           },
           {
               'resultado' : 'Fallo',
               'urlresultado' : `${ ligabase }28/N300/FAN300.pdf`,
           },
        ],
    },
// Licitación N299
    {
        'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N299-2024.',
        'vigencia' : 'Vigencia de venta de bases: del 18 al 26 de noviembre de 2024.',
        'descripcionProcedimiento' : 'Rehabilitación del camino Aquetzpalco a la Mesa, municipio de Huautla.; ubicada en la localidad de La Mesa, Municipio de Huautla, Estado de Hidalgo.',
        'urlAnexos' : `${ ligabase }28/N299/N299.rar`,
        'resultados' : [
           {
               'resultado' : 'Aclaraciones',
               'urlresultado' : `${ ligabase }28/N299/JAN299.pdf`,
           },
           {
               'resultado' : 'Apertura',
               'urlresultado' : `${ ligabase }28/N299/APN299.pdf`,
           },
           {
               'resultado' : 'Fallo',
               'urlresultado' : `${ ligabase }28/N299/FAN299.pdf`,
           },
        ],
    },
// Licitación N298
    {
        'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N298-2024.',
        'vigencia' : 'Vigencia de venta de bases: del 18 al 26 de noviembre de 2024.',
        'descripcionProcedimiento' : 'Rehabilitación de pavimentación asfáltica de Circuito Dios Padre, en el municipio de Ixmiquilpan.; ubicada en la localidad de Dios Padre, Municipio de Ixmiquilpan, Estado de Hidalgo.',
        'urlAnexos' : `${ ligabase }28/N298/N298.rar`,
        'resultados' : [
           {
               'resultado' : 'Aclaraciones',
               'urlresultado' : `${ ligabase }28/N298/JAN298.pdf`,
           },
           {
               'resultado' : 'Apertura',
               'urlresultado' : `${ ligabase }28/N298/APN298.pdf`,
           },
           {
               'resultado' : 'Fallo',
               'urlresultado' : `${ ligabase }28/N298/FAN298.pdf`,
           },
        ],
    },
// Licitación N297
    {
        'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N297-2024.',
        'vigencia' : 'Vigencia de venta de bases: del 18 al 26 de noviembre de 2024.',
        'descripcionProcedimiento' : 'Construcción de pavimentación asfáltica en calle Jacarandas, localidad El Nith, en el municipio de Ixmiquilpan.; ubicada en la localidad de El Nith, Municipio de Ixmiquilpan, Estado de Hidalgo.',
        'urlAnexos' : `${ ligabase }28/N297/N297.rar`,
        'resultados' : [
           {
               'resultado' : 'Aclaraciones',
               'urlresultado' : `${ ligabase }28/N297/JAN297.pdf`,
           },
           {
               'resultado' : 'Apertura',
               'urlresultado' : `${ ligabase }28/N297/APN297.pdf`,
           },
           {
               'resultado' : 'Fallo',
               'urlresultado' : `${ ligabase }28/N297/FAN297.pdf`,
           },
        ],
    },

        // Licitación N296
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N296-2024.',
                    'vigencia' : 'Vigencia de venta de bases: del 18 al 25 de noviembre de 2024.',
                    'descripcionProcedimiento' : 'Terminación de la Construcción de Pavimento de Concreto Hidráulico de la Carretera Metztitlán - Zoquizoquipan; ubicada en la localidad de Zoquizoquipan, Municipio de Metztitlán, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }28/N296/N296.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }28/N296/JAN296.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }28/N296/APN296.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }28/N296/FAN296.pdf`,
                       },
                    ],
                },
        // Licitación N295
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N295-2024.',
                    'vigencia' : 'Vigencia de venta de bases: del 18 al 25 de noviembre de 2024.',
                    'descripcionProcedimiento' : 'Rehabilitación de la Carretera de Chilijapa a Teyahuala a Texcapa, municipio de Tepehuacán de Guerrero.; ubicada en Varias localidades del Municipio de Tepehuacán de Guerrero, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }28/N295/N295.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }28/N295/JAN295.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }28/N295/APN295.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }28/N295/FAN295.pdf`,
                       },
                    ],
                },
        // Licitación N294
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N294-2024.',
                    'vigencia' : 'Vigencia de venta de bases: del 18 al 25 de noviembre de 2024.',
                    'descripcionProcedimiento' : 'Rehabilitación de camino puente Cahuazas, sobre el camino Cahuazas a Ixtlapalaco, en el municipio de Tepehuacán de Guerrero.; ubicada en la localidad de Ixtlapalaco, Municipio de Tepehuacán de Guerrero, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }28/N294/N294.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }28/N294/JAN294.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }28/N294/APN294.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }28/N294/FAN294.pdf`,
                       },
                    ],
                },
        // Licitación N293
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N293-2024.',
                    'vigencia' : 'Vigencia de venta de bases: del 18 al 25 de noviembre de 2024.',
                    'descripcionProcedimiento' : 'Rehabilitación de Camino Calnali a Tostlamantla, del Km 0.000 al Km 5.000, en el municipio de Calnali.; ubicada en la localidad de Tostlamantla, Municipio de Calnali, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }28/N293/N293.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }28/N293/JAN293.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }28/N293/APN293.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }28/N293/FAN293.pdf`,
                       },
                    ],
                },
        // Licitación N292
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N292-2024.',
                    'vigencia' : 'Vigencia de venta de bases: del 18 al 25 de noviembre de 2024.',
                    'descripcionProcedimiento' : 'Construcción de muros de contención en la C.E. Huehuetla - San Ambrosio, municipio de Huehuetla.; ubicada en la localidad de San Ambrosio, Municipio de Huehuetla, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }28/N292/N292.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }28/N292/JAN292.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }28/N292/APN292.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }28/N292/FAN292.pdf`,
                       },
                    ],
                },
        // Licitación N291
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N291-2024.',
                    'vigencia' : 'Vigencia de venta de bases: del 18 al 25 de noviembre de 2024.',
                    'descripcionProcedimiento' : 'Rehabilitación de camino Xóchitl a Tenamaxtepec, del Km 0.000 al Km 3.780, en el municipio de Yahualica.; ubicada en la localidad de Tenamaxtepec, Municipio de Yahualica, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }28/N291/N291.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }28/N291/JAN291.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }28/N291/APN291.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }28/N291/FAN291.pdf`,
                       },
                    ],
                },
        // Licitación N290
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N290-2024.',
                    'vigencia' : 'Vigencia de venta de bases: del 18 al 25 de noviembre de 2024.',
                    'descripcionProcedimiento' : 'Rehabilitación de carpeta asfáltica de la calle Plan de San Luis en col. 20 de Noviembre 2da. etapa, municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }28/N290/N290.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }28/N290/JAN290.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }28/N290/APN290.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }28/N290/FAN290.pdf`,
                       },
                    ],
                },
        // Licitación N289
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N289-2024.',
                    'vigencia' : 'Vigencia de venta de bases: del 18 al 25 de noviembre de 2024.',
                    'descripcionProcedimiento' : 'Rehabilitación de la Carretera Nuevo Acatepec a Atlalco, municipio de Xochiatipan.; ubicada en la localidad de Nuevo Acatepec (Mezcalapa), Municipio de Xochiatipan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }28/N289/N289.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }28/N289/JAN289.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }28/N289/APN289.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }28/N289/FAN289.pdf`,
                       },
                    ],
                },
        // Licitación N288
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N288-2024.',
                    'vigencia' : 'Vigencia de venta de bases: del 18 al 25 de noviembre de 2024.',
                    'descripcionProcedimiento' : 'Rehabilitación de la Carretera de Temango a Santa Lucía a Pahuayo, municipio de Tlanchinol.; ubicada en la localidad de Santa Lucía, Municipio de Tlanchinol, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }28/N288/N288.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }28/N288/JAN288.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }28/N288/APN288.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }28/N288/FAN288.pdf`,
                       },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 027
            'numConvocatoria' : 'Convocatoria No. 027/2024.',
            'idConvocatoria' : 'Convocatoria27',
            'procedimientos' : [
    // Licitación N287
    {
        'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N287-2024.',
        'vigencia' : 'Vigencia de venta de bases: del 11 al 20 de noviembre de 2024',
        'descripcionProcedimiento' : 'Estudio de Evaluación Ambiental del Sitio (ESA) Fase I, Norma ASTME1527-21 para la evaluación de la contaminación ambiental en propiedades industriales, comerciales y de servicios para la Reserva Territorial Zapotlán, en aproximadamente 925 HA de superficie; ubicado en la localidad y Municipio de Zapotlán de Juárez, Estado de Hidalgo.',
        'urlAnexos' : `${ ligabase }27/N287/N287.rar`,
        'resultados' : [
           {
               'resultado' : 'Aclaraciones',
               'urlresultado' : `${ ligabase }27/N287/JAN287.pdf`,
           },
           {
               'resultado' : 'Apertura',
               'urlresultado' : `${ ligabase }27/N287/APN287.pdf`,
           },
           {
               'resultado' : 'Fallo',
               'urlresultado' : `${ ligabase }27/N287/FAN287.pdf`,
           },
           {
            'resultado' : 'Anexo modificatorio',
            'urlresultado' : `${ ligabase }27/N287/AMDFAN287.pdf`,
        },
        ],
    },
// Licitación N286
    {
        'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N286-2024.',
        'vigencia' : 'Vigencia de venta de bases: del 11 al 20 de noviembre de 2024.',
        'descripcionProcedimiento' : 'Construcción de obra de drenaje para Carretera Estatal El Tephé a Progreso de Obregón en la comunidad de El Xothi, en el municipio de Chilcuautla.; ubicada en la localidad de El Xothí, Municipio de Chilcuautla, Estado de Hidalgo.',
        'urlAnexos' : `${ ligabase }27/N286/N286.rar`,
        'resultados' : [
           {
               'resultado' : 'Aclaraciones',
               'urlresultado' : `${ ligabase }27/N286/JAN286.pdf`,
           },
           {
               'resultado' : 'Apertura',
               'urlresultado' : `${ ligabase }27/N286/APN286.pdf`,
           },
           {
               'resultado' : 'Fallo',
               'urlresultado' : `${ ligabase }27/N286/FAN286.pdf`,
           },
        ],
    },
// Licitación N285
    {
        'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N285-2024.',
        'vigencia' : 'Vigencia de venta de bases: del 11 al 20 de noviembre de 2024.',
        'descripcionProcedimiento' : 'Análisis costo beneficio del Proyecto de acceso a la Reserva Denominada de las 311 HA en Cd. Sahagún; ubicado en la localidad de Fray Bernardino de Sahagún (Ciudad Sahagún), Municipio de Tepeapulco, Estado de Hidalgo.',
        'urlAnexos' : `${ ligabase }27/N285/N285.rar`,
        'resultados' : [
           {
               'resultado' : 'Aclaraciones',
               'urlresultado' : `${ ligabase }27/N285/JAN285.pdf`,
           },
           {
               'resultado' : 'Apertura',
               'urlresultado' : `${ ligabase }27/N285/APN285.pdf`,
           },
           {
               'resultado' : 'Fallo',
               'urlresultado' : `${ ligabase }27/N285/FAN285.pdf`,
           },
           {
               'resultado' : 'Anexo modificatorio',
               'urlresultado' : `${ ligabase }27/N285/AMDFAN285.pdf`,
            },
        ],
    },
// Licitación N284
    {
        'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N284-2024.',
        'vigencia' : 'Vigencia de venta de bases: del 11 al 20 de noviembre de 2024.',
        'descripcionProcedimiento' : 'Reconstrucción del acceso a la Escuela Secundaria Libertadores de América, en el municipio de Ixmiquilpan.; ubicada en la localidad y Municipio de Ixmiquilpan, Estado de Hidalgo.',
        'urlAnexos' : `${ ligabase }27/N284/N284.rar`,
        'resultados' : [
           {
               'resultado' : 'Aclaraciones',
               'urlresultado' : `${ ligabase }27/N284/JAN284.pdf`,
           },
           {
               'resultado' : 'Apertura',
               'urlresultado' : `${ ligabase }27/N284/APN284.pdf`,
           },
           {
               'resultado' : 'Fallo',
               'urlresultado' : `${ ligabase }27/N284/FAN284.pdf`,
           },
        ],
    },
// Licitación N283
    {
        'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N283-2024.',
        'vigencia' : 'Vigencia de venta de bases: del 11 al 20 de noviembre de 2024.',
        'descripcionProcedimiento' : 'Rehabilitación de camino de San Andrés a La Palma, en el municipio de Tepehuacan de Guerrero.; ubicada en la localidad de La Palma, Municipio de Tepehuacán de Guerrero, Estado de Hidalgo.',
        'urlAnexos' : `${ ligabase }27/N283/N283.rar`,
        'resultados' : [
           {
               'resultado' : 'Aclaraciones',
               'urlresultado' : `${ ligabase }27/N283/JAN283.pdf`,
           },
           {
               'resultado' : 'Apertura',
               'urlresultado' : `${ ligabase }27/N283/APN283.pdf`,
           },
           {
               'resultado' : 'Fallo',
               'urlresultado' : `${ ligabase }27/N283/FAN283.pdf`,
           },
        ],
    },
// Licitación N282
    {
        'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N282-2024.',
        'vigencia' : 'Vigencia de venta de bases: del 11 al 20 de noviembre de 2024.',
        'descripcionProcedimiento' : 'Rehabilitación de camino Texcatla a límites del estado S.L.P., del km 0.000 al km 2.000, en el municipio de San Felipe Orizatlán.; ubicada en la localidad de Texcatla, Municipio de San Felipe Orizatlán, Estado de Hidalgo.',
        'urlAnexos' : `${ ligabase }27/N282/N282.rar`,
        'resultados' : [
           {
               'resultado' : 'Aclaraciones',
               'urlresultado' : `${ ligabase }27/N282/JAN282.pdf`,
           },
           {
               'resultado' : 'Apertura',
               'urlresultado' : `${ ligabase }27/N282/APN282.pdf`,
           },
           {
               'resultado' : 'Fallo',
               'urlresultado' : `${ ligabase }27/N282/FAN282.pdf`,
           },
        ],
    },
// Licitación N281
    {
        'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N281-2024.',
        'vigencia' : 'Vigencia de venta de bases: del 11 al 20 de noviembre de 2024.',
        'descripcionProcedimiento' : 'Rehabilitación de camino E.C. de Cuatitlanapa a La Unión a la Florida, en el municipio de Lolotla.; ubicada en la localidad de La Florida, Municipio de Lolotla, Estado de Hidalgo.',
        'urlAnexos' : `${ ligabase }27/N281/N281.rar`,
        'resultados' : [
           {
               'resultado' : 'Aclaraciones',
               'urlresultado' : `${ ligabase }27/N281/JAN281.pdf`,
           },
           {
               'resultado' : 'Apertura',
               'urlresultado' : `${ ligabase }27/N281/APN281.pdf`,
           },
           {
               'resultado' : 'Fallo',
               'urlresultado' : `${ ligabase }27/N281/FAN281.pdf`,
           },
        ],
    },
// Licitación N280
    {
        'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N280-2024.',
        'vigencia' : 'Vigencia de venta de bases: del 11 al 20 de noviembre de 2024.',
        'descripcionProcedimiento' : 'Rehabilitación de camino de Zacualtipanito a Petlapixca, en el municipio de Tepehuacan de Guerrero.; ubicada en la localidad de Zacualtipanito, Municipio de Tepehuacán de Guerrero, Estado de Hidalgo.',
        'urlAnexos' : `${ ligabase }27/N280/N280.rar`,
        'resultados' : [
           {
               'resultado' : 'Aclaraciones',
               'urlresultado' : `${ ligabase }27/N280/JAN280.pdf`,
           },
           {
               'resultado' : 'Apertura',
               'urlresultado' : `${ ligabase }27/N280/APN280.pdf`,
           },
           {
               'resultado' : 'Fallo',
               'urlresultado' : `${ ligabase }27/N280/FAN280.pdf`,
           },
        ],
    },
// Licitación N279
    {
        'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N279-2024.',
        'vigencia' : 'Vigencia de venta de bases: del 11 al 20 de noviembre de 2024.',
        'descripcionProcedimiento' : 'Rehabilitación de camino Xuchitlan a Cuatitlanapa, en el municipio de Lolotla.; ubicada en Varias localidades del Municipio de Lolotla, Estado de Hidalgo.',
        'urlAnexos' : `${ ligabase }27/N279/N279.rar`,
        'resultados' : [
           {
               'resultado' : 'Aclaraciones',
               'urlresultado' : `${ ligabase }27/N279/JAN279.pdf`,
           },
           {
               'resultado' : 'Apertura',
               'urlresultado' : `${ ligabase }27/N279/APN279.pdf`,
           },
           {
               'resultado' : 'Fallo',
               'urlresultado' : `${ ligabase }27/N279/FAN279.pdf`,
           },
        ],
    },
// Licitación N278
    {
        'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N278-2024.',
        'vigencia' : 'Vigencia de venta de bases: del 11 al 20 de noviembre de 2024.',
        'descripcionProcedimiento' : 'Construcción de pavimentación hidráulica en la localidad de San Pedro, Barrio El Mirador, municipio de Acaxochitlán.; ubicada en la localidad de San Pedro Tlachichilco, Municipio de Acaxochitlán, Estado de Hidalgo.',
        'urlAnexos' : `${ ligabase }27/N278/N278.rar`,
        'resultados' : [
           {
               'resultado' : 'Aclaraciones',
               'urlresultado' : `${ ligabase }27/N278/JAN278.pdf`,
           },
           {
               'resultado' : 'Apertura',
               'urlresultado' : `${ ligabase }27/N278/APN278.pdf`,
           },
           {
               'resultado' : 'Fallo',
               'urlresultado' : `${ ligabase }27/N278/FAN278.pdf`,
           },
        ],
    },
// Licitación N277
    {
        'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N277-2024.',
        'vigencia' : 'Vigencia de venta de bases: del 11 al 20 de noviembre de 2024.',
        'descripcionProcedimiento' : 'Rehabilitación de camino de Coacuilco a Pochotitla a Ahuimol, del Km 0.000 al Km 1.310, en el municipio de San Felipe Orizatlán.; ubicada en la localidad de Pochotitla, Municipio de San Felipe Orizatlán, Estado de Hidalgo.',
        'urlAnexos' : `${ ligabase }27/N277/N277.rar`,
        'resultados' : [
           {
               'resultado' : 'Aclaraciones',
               'urlresultado' : `${ ligabase }27/N277/JAN277.pdf`,
           },
           {
               'resultado' : 'Apertura',
               'urlresultado' : `${ ligabase }27/N277/APN277.pdf`,
           },
           {
               'resultado' : 'Fallo',
               'urlresultado' : `${ ligabase }27/N277/FAN277.pdf`,
           },
        ],
    },
    // Licitación N276
    {
        'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N276-2024.',
        'vigencia' : 'Vigencia de venta de bases: del 11 al 19 de noviembre de 2024.',
        'descripcionProcedimiento' : 'Rehabilitación de puente vehicular Barranca de San Miguel de la localidad de Texcatepec, en el municipio de Chilcuautla.; ubicada en la localidad de Texcatepec, Municipio de Chilcuautla, Estado de Hidalgo.',
        'urlAnexos' : `${ ligabase }27/N276/N276.rar`,
        'resultados' : [
           {
               'resultado' : 'Aclaraciones',
               'urlresultado' : `${ ligabase }27/N276/JAN276.pdf`,
           },
           {
               'resultado' : 'Apertura',
               'urlresultado' : `${ ligabase }27/N276/APN276.pdf`,
           },
           {
               'resultado' : 'Fallo',
               'urlresultado' : `${ ligabase }27/N276/FAN276.pdf`,
           },
        ],
    },
// Licitación N275
    {
        'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N275-2024.',
        'vigencia' : 'Vigencia de venta de bases: del 11 al 19 de noviembre de 2024.',
        'descripcionProcedimiento' : 'Reconstrucción de la C.E. Calnali a Papatlatla, paso por Calnali, en el municipio de Calnali.; ubicada en la localidad y Municipio de Calnali, Estado de Hidalgo.',
        'urlAnexos' : `${ ligabase }27/N275/N275.rar`,
        'resultados' : [
           {
               'resultado' : 'Aclaraciones',
               'urlresultado' : `${ ligabase }27/N275/JAN275.pdf`,
           },
           {
               'resultado' : 'Apertura',
               'urlresultado' : `${ ligabase }27/N275/APN275.pdf`,
           },
           {
               'resultado' : 'Fallo',
               'urlresultado' : `${ ligabase }27/N275/FAN275.pdf`,
           },
        ],
    },
// Licitación N274
    {
        'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N274-2024.',
        'vigencia' : 'Vigencia de venta de bases: del 11 al 19 de noviembre de 2024.',
        'descripcionProcedimiento' : 'Construcción de pavimento tramo Rancho Nuevo a La Lomita, en el municipio de Pisaflores.; ubicada en la localidad de Rancho Nuevo, Municipio de Pisaflores, Estado de Hidalgo.',
        'urlAnexos' : `${ ligabase }27/N274/N274.rar`,
        'resultados' : [
           {
               'resultado' : 'Aclaraciones',
               'urlresultado' : `${ ligabase }27/N274/JAN274.pdf`,
           },
           {
               'resultado' : 'Apertura',
               'urlresultado' : `${ ligabase }27/N274/APN274.pdf`,
           },
           {
               'resultado' : 'Fallo',
               'urlresultado' : `${ ligabase }27/N274/FAN274.pdf`,
           },
        ],
    },
// Licitación N273
    {
        'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N273-2024.',
        'vigencia' : 'Vigencia de venta de bases: del 11 al 19 de noviembre de 2024.',
        'descripcionProcedimiento' : 'Rehabilitación de camino E.C. de Calnali a Papatlatla a Tula, del km 0.000 al km 7.635, en el municipio de Calnali.; ubicada en la localidad de Tula, Municipio de Calnali, Estado de Hidalgo.',
        'urlAnexos' : `${ ligabase }27/N273/N273.rar`,
        'resultados' : [
           {
               'resultado' : 'Aclaraciones',
               'urlresultado' : `${ ligabase }27/N273/JAN273.pdf`,
           },
           {
               'resultado' : 'Apertura',
               'urlresultado' : `${ ligabase }27/N273/APN273.pdf`,
           },
           {
               'resultado' : 'Fallo',
               'urlresultado' : `${ ligabase }27/N273/FAN273.pdf`,
           },
        ],
    },
// Licitación N272
    {
        'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N272-2024.',
        'vigencia' : 'Vigencia de venta de bases: del 11 al 19 de noviembre de 2024.',
        'descripcionProcedimiento' : 'Rehabilitación de pavimento en carretera principal de Pacula a la Estancia en tramos de las comunidades del Puerto Jilialpan a la Mohonera, municipio de Pacula.; ubicada en Varias localidades del Municipio de Pacula, Estado de Hidalgo.',
        'urlAnexos' : `${ ligabase }27/N272/N272.rar`,
        'resultados' : [
           {
               'resultado' : 'Aclaraciones',
               'urlresultado' : `${ ligabase }27/N272/JAN272.pdf`,
           },
           {
               'resultado' : 'Apertura',
               'urlresultado' : `${ ligabase }27/N272/APN272.pdf`,
           },
           {
               'resultado' : 'Fallo',
               'urlresultado' : `${ ligabase }27/N272/FAN272.pdf`,
           },
           {
            'resultado' : 'Anexo modificatorio',
            'urlresultado' : `${ ligabase }27/N272/AMDFAN272.pdf`,
        },
        ],
    },
// Licitación N271
    {
        'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N271-2024.',
        'vigencia' : 'Vigencia de venta de bases: del 11 al 19 de noviembre de 2024.',
        'descripcionProcedimiento' : 'Construcción de pavimentación hidráulica del Camino Intermunicipal Cardonal Nicolás Flores tramo El Boxo Barrio del Tixqui, en el municipio de Cardonal.; ubicada en la localidad de El Boxo, Municipio de Cardonal, Estado de Hidalgo.',
        'urlAnexos' : `${ ligabase }27/N271/N271.rar`,
        'resultados' : [
           {
               'resultado' : 'Aclaraciones',
               'urlresultado' : `${ ligabase }27/N271/JAN271.pdf`,
           },
           {
               'resultado' : 'Apertura',
               'urlresultado' : `${ ligabase }27/N271/APN271.pdf`,
           },
           {
               'resultado' : 'Fallo',
               'urlresultado' : `${ ligabase }27/N271/FAN271.pdf`,
           },
        ],
    },
// Licitación N270
    {
        'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N270-2024.',
        'vigencia' : 'Vigencia de venta de bases: del 11 al 19 de noviembre de 2024.',
        'descripcionProcedimiento' : 'Rehabilitación de camino Tohuaco I a Tepetzquimitl, del km 0.000 al km 4.000, en el municipio de Huautla.; ubicada en la localidad de Tohuaco, Municipio de Huautla, Estado de Hidalgo.',
        'urlAnexos' : `${ ligabase }27/N270/N270.rar`,
        'resultados' : [
           {
               'resultado' : 'Aclaraciones',
               'urlresultado' : `${ ligabase }27/N270/JAN270.pdf`,
           },
           {
               'resultado' : 'Apertura',
               'urlresultado' : `${ ligabase }27/N270/APN270.pdf`,
           },
           {
               'resultado' : 'Fallo',
               'urlresultado' : `${ ligabase }27/N270/FAN270.pdf`,
           },
        ],
    },
// Licitación N269
    {
        'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N269-2024.',
        'vigencia' : 'Vigencia de venta de bases: del 11 al 19 de noviembre de 2024.',
        'descripcionProcedimiento' : 'Rehabilitación de camino E.C. de Tamala a Tepehuacan, a San Miguel, del km 0.000 al km 9.400, en el municipio de Tepehuacan de Guerrero.; ubicada en la localidad de San Miguel Ayotempa, Municipio de Tepehuacán de Guerrero, Estado de Hidalgo.',
        'urlAnexos' : `${ ligabase }27/N269/N269.rar`,
        'resultados' : [
           {
               'resultado' : 'Aclaraciones',
               'urlresultado' : `${ ligabase }27/N269/JAN269.pdf`,
           },
           {
               'resultado' : 'Apertura',
               'urlresultado' : `${ ligabase }27/N269/APN269.pdf`,
           },
           {
            'resultado' : 'Anexo modificatorio',
            'urlresultado' : `${ ligabase }27/N269/AMDAPN269.pdf`,
        },
           {
               'resultado' : 'Fallo',
               'urlresultado' : `${ ligabase }27/N269/FAN269.pdf`,
           },
        ],
    },
// Licitación N268
    {
        'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N268-2024.',
        'vigencia' : 'Vigencia de venta de bases: del 11 al 19 de noviembre de 2024.',
        'descripcionProcedimiento' : 'Rehabilitacion C.R. crucero de Otlamalacatla a Xochimilco, subtramo Otlamalacatla El Hormiguero, en el municipio de  Tianguistengo.; ubicada en la localidad de Otlamalacatla, Municipio de Tianguistengo, Estado de Hidalgo.',
        'urlAnexos' : `${ ligabase }27/N268/N268.rar`,
        'resultados' : [
           {
               'resultado' : 'Aclaraciones',
               'urlresultado' : `${ ligabase }27/N268/JAN268.pdf`,
           },
           {
               'resultado' : 'Apertura',
               'urlresultado' : `${ ligabase }27/N268/APN268.pdf`,
           },
           {
               'resultado' : 'Fallo',
               'urlresultado' : `${ ligabase }27/N268/FAN268.pdf`,
           },
        ],
    },
// Licitación N267
    {
        'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N267-2024.',
        'vigencia' : 'Vigencia de venta de bases: del 11 al 19 de noviembre de 2024.',
        'descripcionProcedimiento' : 'Rehabilitación de camino E.C. de Tlanchinol a Hueyapa, a Cuatlimax, del Km 0.000 al Km 10.000, en el municipio de Tlanchinol.; ubicada en la localidad de Cuatlimax, Municipio de Tlanchinol, Estado de Hidalgo.',
        'urlAnexos' : `${ ligabase }27/N267/N267.rar`,
        'resultados' : [
           {
               'resultado' : 'Aclaraciones',
               'urlresultado' : `${ ligabase }27/N267/JAN267.pdf`,
           },
           {
               'resultado' : 'Apertura',
               'urlresultado' : `${ ligabase }27/N267/APN267.pdf`,
           },
           {
               'resultado' : 'Fallo',
               'urlresultado' : `${ ligabase }27/N267/FAN267.pdf`,
           },
        ],
    },                
        // Licitación N266
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N266-2024.',
                    'vigencia' : 'Vigencia de venta de bases: del 11 al 15 de noviembre de 2024.',
                    'descripcionProcedimiento' : 'Rehabilitación de camino E.C. de Tlanchinol a Apantlazol, tramo Chichatla a Xochititla, del Km 0.000 al Km 10.000, en el municipio de Tlanchinol.; ubicada en la localidad de Chichatla, Municipio de Tlanchinol, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }27/N266/N266.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }27/N266/JAN266.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }27/N266/APN266.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }27/N266/FAN266.pdf`,
                       },
                    ],
                },
        // Licitación N265
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N265-2024.',
                    'vigencia' : 'Vigencia de venta de bases: del 11 al 15 de noviembre de 2024.',
                    'descripcionProcedimiento' : 'Construcción de pavimentación de C.R. Tlaltzonco a Tzapotitla del km. 0.469 al km 1.269, municipio de Huazalingo.; ubicada en la localidad de Tzapotitla, Municipio de Huazalingo, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }27/N265/N265.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }27/N265/JAN265.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }27/N265/APN265.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }27/N265/FAN265.pdf`,
                       },
                    ],
                },
        // Licitación N264
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N264-2024.',
                    'vigencia' : 'Vigencia de venta de bases: del 11 al 15 de noviembre de 2024.',
                    'descripcionProcedimiento' : 'Rehabilitación de camino el Ixtle a El Lindero a Coatempa, del km 0.000 al km 12.000, en el municipio de Huautla.; ubicada en Varias localidades del Municipio de Huautla, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }27/N264/N264.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }27/N264/JAN264.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }27/N264/APN264.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }27/N264/FAN264.pdf`,
                       },
                    ],
                },
        // Licitación N263
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N263-2024.',
                    'vigencia' : 'Vigencia de venta de bases: del 11 al 15 de noviembre de 2024.',
                    'descripcionProcedimiento' : 'Rehabilitación de camino E.C. de Tehuetlán a Huejutla a Ixcatépec, del Km 0.000 al Km 6.000, en el municipio de Huejutla de Reyes.; ubicada en la localidad de Ixcatépec, Municipio de Huejutla de Reyes, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }27/N263/N263.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }27/N263/JAN263.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }27/N263/APN263.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }27/N263/FAN263.pdf`,
                       },
                    ],
                },
        // Licitación N262
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N262-2024.',
                    'vigencia' : 'Vigencia de venta de bases: del 11 al 15 de noviembre de 2024.',
                    'descripcionProcedimiento' : 'Reconstrucción de la C.E. Tlanchinol a Hueyapa a Temango, en el municipio de Tlanchinol.; ubicada en la localidad de Hueyapa, Municipio de Tlanchinol, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }27/N262/N262.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }27/N262/JAN262.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }27/N262/APN262.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }27/N262/FAN262.pdf`,
                       },
                    ],
                },
        // Licitación N261
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N261-2024.',
                    'vigencia' : 'Vigencia de venta de bases: del 11 al 15 de noviembre de 2024.',
                    'descripcionProcedimiento' : 'Construcción de piso de concreto hidráulico en acceso a Tolantongo, en el municipio de Cardonal.; ubicada en la localidad de San Cristóbal, Municipio de Cardonal, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }27/N261/N261.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }27/N261/JAN261.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }27/N261/APN261.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }27/N261/FAN261.pdf`,
                       },
                    ],
                },
        // Licitación N260
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N260-2024.',
                    'vigencia' : 'Vigencia de venta de bases: del 11 al 15 de noviembre de 2024.',
                    'descripcionProcedimiento' : 'Construcción de pavimentación de concreto hidráulico en acceso a la localidad de Pahuatlán, en el municipio de Huejutla de Reyes.; ubicada en la localidad de Pahuatlán, Municipio de Huejutla de Reyes, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }27/N260/N260.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }27/N260/JAN260.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }27/N260/APN260.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }27/N260/FAN260.pdf`,
                       },
                    ],
                },
        // Licitación N259
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N259-2024.',
                    'vigencia' : 'Vigencia de venta de bases: del 11 al 15 de noviembre de 2024.',
                    'descripcionProcedimiento' : 'Construcción de pavimentación hidráulica del camino Pahactla a Atlapexco en el municipio de Atlapexco.; ubicada en la localidad de Pahactla, Municipio de Atlapexco, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }27/N259/N259.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }27/N259/JAN259.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }27/N259/APN259.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }27/N259/FAN259.pdf`,
                       },
                    ],
                },
        // Licitación N258
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N258-2024.',
                    'vigencia' : 'Vigencia de venta de bases: del 11 al 15 de noviembre de 2024.',
                    'descripcionProcedimiento' : 'Rehabilitación de puente vehicular Mirasol, en el municipio de Huehuetla.; ubicada en la localidad de Linda Vista I (Mirasol), Municipio de Huehuetla, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }27/N258/N258.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }27/N258/JAN258.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }27/N258/APN258.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }27/N258/FAN258.pdf`,
                       },
                    ],
                },
        // Licitación N257
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N257-2024.',
                    'vigencia' : 'Vigencia de venta de bases: del 11 al 15 de noviembre de 2024.',
                    'descripcionProcedimiento' : 'Construcción de cimentación y estructura de las nuevas Oficinas de Gobierno en Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }27/N257/N257.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }27/N257/JAN257.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }27/N257/APN257.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }27/N257/FAN257.pdf`,
                       },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 026
            'numConvocatoria' : 'Convocatoria No. 026/2024.',
            'idConvocatoria' : 'Convocatoria26',
            'procedimientos' : [
        // Licitación N256
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N256-2024.',
                    'vigencia' : 'Vigencia de venta de bases: del 4 al 8 de noviembre de 2024',
                    'descripcionProcedimiento' : 'Construcción de Corredor Artesanal ubicado en el lugar conocido como Bajada de Pastores ejido de Maguey Blanco, municipio de Ixmiquilpan, ubicada en la localidad de Ejido Maguey Blanco, Municipio de Ixmiquilpan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }26/N256/N256.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }26/N256/JAN256.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }26/N256/APN256.pdf`,
                       },
                       {
                        'resultado' : 'Anexo modificatorio',
                        'urlresultado' : `${ ligabase }26/N256/AMDAPN256.pdf`,
                    },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }26/N256/FAN256.pdf`,
                       },
                    ],
                },
        // Licitación N255
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N255-2024.',
                    'vigencia' : 'Vigencia de venta de bases: del 4 al 8 de noviembre de 2024.',
                    'descripcionProcedimiento' : 'Construcción de sucursal Montepío Pachuca.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }26/N255/N255.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }26/N255/JAN255.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }26/N255/APN255.pdf`,
                       },
                       {
                        'resultado' : 'Anexo modificatorio',
                        'urlresultado' : `${ ligabase }26/N255/AMDAPN255.pdf`,
                    },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }26/N255/FAN255.pdf`,
                       },
                    ],
                },
        // Licitación N254
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N254-2024.',
                    'vigencia' : 'Vigencia de venta de bases: del 4 al 8 de noviembre de 2024.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica de calle Michimaloyan, en la localidad de La Loma, municipio de Tepetitlán.; ubicada en la localidad de La Loma, Municipio de Tepetitlán, Estado de Hidalgo(Segundo procedimiento)',
                    'urlAnexos' : `${ ligabase }26/N254/N254.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }26/N254/JAN254.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }26/N254/APN254.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }26/N254/FAN254.pdf`,
                       },
                    ],
                },
        // Licitación N253
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N253-2024.',
                    'vigencia' : 'Vigencia de venta de bases: del 4 al 8 de noviembre de 2024.',
                    'descripcionProcedimiento' : 'Construcción de la casa de la mujer indígena 1er etapa en el municipio de Atlapexco; ubicada en la localidad y Municipio de Atlapexco, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }26/N253/N253.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }26/N253/JAN253.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }26/N253/APN253.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }26/N253/FAN253.pdf`,
                       },
                    ],
                },
        // Licitación N252
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N252-2024.',
                    'vigencia' : 'Vigencia de venta de bases: del 4 al 8 de noviembre de 2024.',
                    'descripcionProcedimiento' : 'Construcción de Sistema Integral de Abastecimiento de Agua Potable en la cabecera municipal de Chapulhuacan (2da Etapa).; ubicada en la localidad y Municipio de Chapulhuacán, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }26/N252/N252.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }26/N252/JAN252.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }26/N252/APN252.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }26/N252/FAN252.pdf`,
                       },
                    ],
                },
        // Licitación N251
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N251-2024.',
                    'vigencia' : 'Vigencia de venta de bases: del 4 al 8 de noviembre de 2024.',
                    'descripcionProcedimiento' : 'Mejoramiento de unidades en el IFP de Mineral de la Reforma; ubicada en la localidad de San José Palma Gorda, Municipio de Mineral de la Reforma, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }26/N251/N251.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }26/N251/JAN251.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }26/N251/APN251.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }26/N251/FAN251.pdf`,
                       },
                    ],
                },
        // Licitación N250
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N250-2024.',
                    'vigencia' : 'Vigencia de venta de bases: del 4 al 8 de noviembre de 2024.',
                    'descripcionProcedimiento' : 'Programa de Campo Limpio.; de Cobertura Estatal.',
                    'urlAnexos' : `${ ligabase }26/N250/N250.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }26/N250/JAN250.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }26/N250/APN250.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }26/N250/FAN250.pdf`,
                       },
                    ],
                },
        // Licitación N249
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N249-2024.',
                    'vigencia' : 'Vigencia de venta de bases: del 4 al 8 de noviembre de 2024.',
                    'descripcionProcedimiento' : 'Construcción de avenida Calzada Periférica 1ra. Etapa, Cd. Sahagún municipio Tepeapulco.; ubicada en la localidad y Municipio de Tepeapulco, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }26/N249/N249.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }26/N249/JAN249.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }26/N249/APN249.pdf`,
                       },
                       {
                        'resultado' : 'Anexo modificatorio',
                        'urlresultado' : `${ ligabase }26/N249/AMDAPN249.pdf`,
                    },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }26/N249/FAN249.pdf`,
                       },
                    ],
                },
        // Licitación N248
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N248-2024.',
                    'vigencia' : 'Vigencia de venta de bases: del 4 al 8 de noviembre de 2024.',
                    'descripcionProcedimiento' : 'Construcción de muro de contensión C.E. Ohuatipa - Iztazoquico, municipio de Xochiatipan; ubicada en la localidad de Ohuatipa, Municipio de Xochiatipan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }26/N248/N248.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }26/N248/JAN248.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }26/N248/APN248.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }26/N248/FAN248.pdf`,
                       },
                    ],
                },
        // Licitación N247
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N247-2024.',
                    'vigencia' : 'Vigencia de venta de bases: del 4 al 8 de noviembre de 2024.',
                    'descripcionProcedimiento' : 'Construcción de pavimento hidráulico en calle Zapata en la localidad de Estación de Apulco, en el municipio de Metepec; ubicada en la localidad de Estación de Apulco, Municipio de Metepec, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }26/N247/N247.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }26/N247/JAN247.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }26/N247/APN247.pdf`,
                       },
                    //    {
                    //        'resultado' : 'Fallo',
                    //        'urlresultado' : `${ ligabase }26/N247/FAN247.pdf`,
                    //    },
                    ],
                },
        // Licitación N246
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N246-2024.',
                    'vigencia' : 'Vigencia de venta de bases: del 4 al 8 de noviembre de 2024.',
                    'descripcionProcedimiento' : 'Modernización del camino Jacala - Quetzalapa en el municipio de Jacala (segunda etapa); ubicada en la localidad de Octupilla, Municipio de Jacala de Ledezma, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }26/N246/N246.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }26/N246/JAN246.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }26/N246/APN246.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }26/N246/FAN246.pdf`,
                       },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 025
        'numConvocatoria': 'Convocatoria No. 025/2024.',
        'idConvocatoria': 'Convocatoria25',
        'procedimientos': [
            // Licitación N245
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N245-2024.',
                'vigencia' : 'Vigencia de venta de bases: del 28 de octubre al 12 de noviembre de 2024',
                'descripcionProcedimiento' : 'Estudio hidrológico para la reserva territorial Zapotlán, en aproximadamente 925 ha de superficie; ubicado en la localidad y Municipio de Zapotlán de Juárez, Estado de Hidalgo. forma, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }25/N245/N245.rar`,
                'resultados' : [
                   {
                       'resultado' : 'Aclaraciones',
                       'urlresultado' : `${ ligabase }25/N245/JAN245.pdf`,
                   },
                   {
                       'resultado' : 'Apertura',
                       'urlresultado' : `${ ligabase }25/N245/APN245.pdf`,
                   },
                   {
                       'resultado' : 'Fallo',
                       'urlresultado' : `${ ligabase }25/N245/FAN245.pdf`,
                   },
                ],
            },
    // Licitación N244
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N244-2024.',
                'vigencia' : 'Vigencia de venta de bases: del 28 de octubre al 12 de noviembre de 2024.',
                'descripcionProcedimiento' : 'Construcción de pavimentación hidráulica en Quinta Cerrada, en el municipio de Ixmiquilpan.; ubicada en la localidad y Municipio de Ixmiquilpan, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }25/N244/N244.rar`,
                'resultados' : [
                   {
                       'resultado' : 'Aclaraciones',
                       'urlresultado' : `${ ligabase }25/N244/JAN244.pdf`,
                   },
                   {
                    'resultado' : 'Aclaraciones (2da.)',
                    'urlresultado' : `${ ligabase }25/N244/JAN244-2.pdf`,
                    },
                   {
                       'resultado' : 'Apertura',
                       'urlresultado' : `${ ligabase }25/N244/APN244.pdf`,
                   },
                   {
                       'resultado' : 'Fallo',
                       'urlresultado' : `${ ligabase }25/N244/FAN244.pdf`,
                   },
                ],
            },
    // Licitación N243
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N243-2024.',
                'vigencia' : 'Vigencia de venta de bases: del 28 de octubre al 12 de noviembre de 2024.',
                'descripcionProcedimiento' : 'Construcción de pavimentación de concreto hidráulico de Calle Nezahualcóyotl en la localidad del Nith, en el municipio de Ixmiquilpan.; ubicada en la localidad de El Nith, Municipio de Ixmiquilpan, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }25/N243/N243.rar`,
                'resultados' : [
                   {
                       'resultado' : 'Aclaraciones',
                       'urlresultado' : `${ ligabase }25/N243/JAN243.pdf`,
                   },
                   {
                    'resultado' : 'Aclaraciones (2da.)',
                    'urlresultado' : `${ ligabase }25/N243/JAN243-2.pdf`,
                    },
                   {
                       'resultado' : 'Apertura',
                       'urlresultado' : `${ ligabase }25/N243/APN243.pdf`,
                   },
                   {
                       'resultado' : 'Fallo',
                       'urlresultado' : `${ ligabase }25/N243/FAN243.pdf`,
                   },
                ],
            },
    // Licitación N242
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N242-2024.',
                'vigencia' : 'Vigencia de venta de bases: del 28 de octubre al 12 de noviembre de 2024.',
                'descripcionProcedimiento' : 'Pavimentación hidráulica del C.R. Matatlán - Tzincoatlán, en el municipio de Zacualtipán de Ángeles.; ubicada en la localidad de Matlatlán, Municipio de Zacualtipán de Ángeles, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }25/N242/N242.rar`,
                'resultados' : [
                   {
                       'resultado' : 'Aclaraciones',
                       'urlresultado' : `${ ligabase }25/N242/JAN242.pdf`,
                   },
                   {
                       'resultado' : 'Apertura',
                       'urlresultado' : `${ ligabase }25/N242/APN242.pdf`,
                   },
                   {
                       'resultado' : 'Fallo',
                       'urlresultado' : `${ ligabase }25/N242/FAN242.pdf`,
                   },
                ],
            },
    // Licitación N241
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N241-2024.',
                'vigencia' : 'Vigencia de venta de bases: del 28 de octubre al 12 de noviembre de 2024.',
                'descripcionProcedimiento' : 'Construcción de pavimentación de concreto hidráulico, Calle 16 de Enero, B. San Miguel, en el municipio de Ixmiquilpan.; ubicada en la localidad y Municipio de Ixmiquilpan, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }25/N241/N241.rar`,
                'resultados' : [
                   {
                       'resultado' : 'Aclaraciones',
                       'urlresultado' : `${ ligabase }25/N241/JAN241.pdf`,
                   },
                   {
                    'resultado' : 'Aclaraciones (2da.)',
                    'urlresultado' : `${ ligabase }25/N241/JAN241-2.pdf`,
                    },
                   {
                       'resultado' : 'Apertura',
                       'urlresultado' : `${ ligabase }25/N241/APN241.pdf`,
                   },
                   {
                       'resultado' : 'Fallo',
                       'urlresultado' : `${ ligabase }25/N241/FAN241.pdf`,
                   },
                ],
            },
    // Licitación N240
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N240-2024.',
                'vigencia' : 'Vigencia de venta de bases: del 28 de octubre al 12 de noviembre de 2024.',
                'descripcionProcedimiento' : 'Construcción de pavimentación de concreto hidráulico en calle Ponciano Arriaga en la sexta demarcación en el municipio de Mixquiahuala de Juárez .; ubicada en la localidad y Municipio de Mixquiahuala de Juárez, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }25/N240/N240.rar`,
                'resultados' : [
                   {
                       'resultado' : 'Aclaraciones',
                       'urlresultado' : `${ ligabase }25/N240/JAN240.pdf`,
                   },
                   {
                       'resultado' : 'Apertura',
                       'urlresultado' : `${ ligabase }25/N240/APN240.pdf`,
                   },
                   {
                       'resultado' : 'Fallo',
                       'urlresultado' : `${ ligabase }25/N240/FAN240.pdf`,
                   },
                ],
            },
    // Licitación N239
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N239-2024.',
                'vigencia' : 'Vigencia de venta de bases: del 28 de octubre al 12 de noviembre de 2024.',
                'descripcionProcedimiento' : 'Construcción de muro de contención de la C.E. Ixtlahuaco - Calnali, Ahuacatlán, municipio de Calnali.; ubicada en la localidad de Ahuacatlán, Municipio de Calnali, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }25/N239/N239.rar`,
                'resultados' : [
                   {
                       'resultado' : 'Aclaraciones',
                       'urlresultado' : `${ ligabase }25/N239/JAN239.pdf`,
                   },
                   {
                       'resultado' : 'Apertura',
                       'urlresultado' : `${ ligabase }25/N239/APN239.pdf`,
                   },
                   {
                       'resultado' : 'Fallo',
                       'urlresultado' : `${ ligabase }25/N239/FAN239.pdf`,
                   },
                ],
            },
    // Licitación N238
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N238-2024.',
                'vigencia' : 'Vigencia de venta de bases: del 28 de octubre al 12 de noviembre de 2024.',
                'descripcionProcedimiento' : 'Construcción de muro de contención y pavimento hidráulico en el C.R. La Misión - Puerto de los Naranjos, municipio de La Misión.; ubicada en la localidad y Municipio de La Misión, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }25/N238/N238.rar`,
                'resultados' : [
                   {
                       'resultado' : 'Aclaraciones',
                       'urlresultado' : `${ ligabase }25/N238/JAN238.pdf`,
                   },
                   {
                       'resultado' : 'Apertura',
                       'urlresultado' : `${ ligabase }25/N238/APN238.pdf`,
                   },
                   {
                       'resultado' : 'Fallo',
                       'urlresultado' : `${ ligabase }25/N238/FAN238.pdf`,
                   },
                ],
            },
    // Licitación N237
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N237-2024.',
                'vigencia' : 'Vigencia de venta de bases: del 28 de octubre al 12 de noviembre de 2024.',
                'descripcionProcedimiento' : 'Reconstrucción de concreto hidráulico de la C.E. Juárez - Tlahuiltepa, municipio de Tlahuiltepa.; ubicada en la localidad de Tlaxcantitla, Municipio de Tlahuiltepa, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }25/N237/N237.rar`,
                'resultados' : [
                   {
                       'resultado' : 'Aclaraciones',
                       'urlresultado' : `${ ligabase }25/N237/JAN237.pdf`,
                   },
                   {
                       'resultado' : 'Apertura',
                       'urlresultado' : `${ ligabase }25/N237/APN237.pdf`,
                   },
                   {
                       'resultado' : 'Fallo',
                       'urlresultado' : `${ ligabase }25/N237/FAN237.pdf`,
                   },
                ],
            },
    // Licitación N236
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N236-2024.',
                'vigencia' : 'Vigencia de venta de bases: del 28 de octubre al 12 de noviembre de 2024.',
                'descripcionProcedimiento' : 'Construcción de muro de contención de la C.E. Otongo - Acayuca, municipio de Molango de Escamilla.; ubicada en la localidad de Acayuca, Municipio de Molango de Escamilla, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }25/N236/N236.rar`,
                'resultados' : [
                   {
                       'resultado' : 'Aclaraciones',
                       'urlresultado' : `${ ligabase }25/N236/JAN236.pdf`,
                   },
                   {
                       'resultado' : 'Apertura',
                       'urlresultado' : `${ ligabase }25/N236/APN236.pdf`,
                   },
                   {
                       'resultado' : 'Fallo',
                       'urlresultado' : `${ ligabase }25/N236/FAN236.pdf`,
                   },
                ],
            },
            
            // Licitación N235
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N235-2024.',
                'vigencia': 'Vigencia de venta de bases: del 28 de octubre al 5 de noviembre de 2024.',
                'descripcionProcedimiento': 'Construcción de pavimentación de concreto hidráulico en la localidad de San Antonio Sabanillas, municipio de Cardonal.; ubicada en la localidad de San Antonio Sabanillas, Municipio de Cardonal, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }25/N235/N235.rar`,
                'resultados': [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }25/N235/JAN235.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }25/N235/APN235.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }25/N235/FAN235.pdf`,
                       },
                       {
                        'resultado' : 'Anexo modificatorio',
                        'urlresultado' : `${ ligabase }25/N235/AMDFAN235.pdf`,
                    },
                ],
            },
            // Licitación N234
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N234-2024.',
                'vigencia': 'Vigencia de venta de bases: del 28 de octubre al 5 de noviembre de 2024.',
                'descripcionProcedimiento': 'Construcción de pavimentación de concreto hidráulico de Calle Gladiolas, Col. Loma de Oro, en el municipio de Ixmiquilpan.; ubicada en Varias localidades del Municipio de Ixmiquilpan, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }25/N234/N234.rar`,
                'resultados': [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }25/N234/JAN234.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }25/N234/APN234.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }25/N234/FAN234.pdf`,
                       },
                ],
            },
            // Licitación N233
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N233-2024.',
                'vigencia': 'Vigencia de venta de bases: del 28 de octubre al 5 de noviembre de 2024.',
                'descripcionProcedimiento': 'Rehabilitación del C.R. Tamalcuatitla - Apilol - Chalahuitzintla - Tlanepantla, municipio de Huejutla de Reyes.; ubicada en la localidad de Chalahuitzintla, Municipio de Huejutla de Reyes, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }25/N233/N233.rar`,
                'resultados': [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }25/N233/JAN233.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }25/N233/APN233.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }25/N233/FAN233.pdf`,
                       },
                ],
            },
            // Licitación N232
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N232-2024.',
                'vigencia': 'Vigencia de venta de bases: del 28 de octubre al 5 de noviembre de 2024.',
                'descripcionProcedimiento': 'Reconstrucción de superficie de rodamiento del puente El Aguacate, municipio de Huejutla de Reyes.; ubicada en la localidad de Los Parajes, Municipio de Huejutla de Reyes, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }25/N232/N232.rar`,
                'resultados': [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }25/N232/JAN232.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }25/N232/APN232.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }25/N232/FAN232.pdf`,
                       },
                ],
            },
            // Licitación N231
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N231-2024.',
                'vigencia': 'Vigencia de venta de bases: del 28 de octubre al 5 de noviembre de 2024.',
                'descripcionProcedimiento': 'Construcción de muro de contención y obra de drenaje en la C.E. Huazalingo - Calnali (Calnali - San Andrés - Santa Lucia), San Andrés, municipio de Calnali.; ubicada en la localidad de San Andrés (San Andrés Chichayotla), Municipio de Calnali, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }25/N231/N231.rar`,
                'resultados': [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }25/N231/JAN231.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }25/N231/APN231.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }25/N231/FAN231.pdf`,
                       },
                ],
            },
            // Licitación N230
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N230-2024.',
                'vigencia': 'Vigencia de venta de bases: del 28 de octubre al 5 de noviembre de 2024.',
                'descripcionProcedimiento': 'Reconstrucción en calle Nicolás Flores, colonia Centro, Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }25/N230/N230.rar`,
                'resultados': [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }25/N230/JAN230.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }25/N230/APN230.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }25/N230/FAN230.pdf`,
                       },
                ],
            },
            // Licitación N229
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N229-2024.',
                'vigencia': 'Vigencia de venta de bases: del 28 de octubre al 5 de noviembre de 2024.',
                'descripcionProcedimiento': 'Pavimentación Calle 2 de Enero, en la localidad La Reforma, municipio de Mixquiahuala.; ubicada en la localidad de La Arboleda, Municipio de Mixquiahuala de Juárez, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }25/N229/N229.rar`,
                'resultados': [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }25/N229/JAN229.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }25/N229/APN229.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }25/N229/FAN229.pdf`,
                       },
                ],
            },
            // Licitación N228
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N228-2024.',
                'vigencia': 'Vigencia de venta de bases: del 28 de octubre al 5 de noviembre de 2024.',
                'descripcionProcedimiento': 'Barda perimetral del Centro de Identificación Humana y Resguardo Temporal de Hidalgo.; ubicada en la localidad y Municipio de San Agustín Tlaxiaca, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }25/N228/N228.rar`,
                'resultados': [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }25/N228/JAN228.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }25/N228/APN228.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }25/N228/FAN228.pdf`,
                       },
                ],
            },
            // Licitación N227
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N227-2024.',
                'vigencia': 'Vigencia de venta de bases: del 28 de octubre al 5 de noviembre de 2024.',
                'descripcionProcedimiento': 'Rehabilitación de camino Xoxolpa a Aguacatitla, del Km 0.000 al Km 2.539, en el municipio de Yahualica.; ubicada en la localidad de Xoxolpa, Municipio de Yahualica, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }25/N227/N227.rar`,
                'resultados': [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }25/N227/JAN227.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }25/N227/APN227.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }25/N227/FAN227.pdf`,
                       },
                ],
            },
            // Licitación N226
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N226-2024.',
                'vigencia': 'Vigencia de venta de bases: del 28 de octubre al 5 de noviembre de 2024.',
                'descripcionProcedimiento': 'Rehabilitación del C.R. El Rayo - Bonigú, municipio de Pisaflores.; ubicada en la localidad de El Rayo, Municipio de Pisaflores, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }25/N226/N226.rar`,
                'resultados': [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }25/N226/JAN226.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }25/N226/APN226.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }25/N226/FAN226.pdf`,
                       },
                       {
                        'resultado' : 'Anexo modificatorio',
                        'urlresultado' : `${ ligabase }25/N226/AMDFAN226.pdf`,
                    },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 024
        'numConvocatoria': 'Convocatoria No. 024/2024.',
        'idConvocatoria': 'Convocatoria24',
        'procedimientos': [
                // Licitación N225
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N225-2024.',
                    'vigencia' : 'Vigencia de venta de bases: del 28 de octubre al 7 de noviembre de 2024',
                    'descripcionProcedimiento' : 'Muro de contención en la comunidad de Texcapa, municipio de Tepehuacán de Guerrero.; ubicada en la localidad de Texcapa, Municipio de Tepehuacán de Guerrero, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }24/N225/N225.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }24/N225/JAN225.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }24/N225/APN225.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }24/N225/FAN225.pdf`,
                       },
                    ],
                },
        // Licitación N224
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N224-2024.',
                    'vigencia' : 'Vigencia de venta de bases: del 28 de octubre al 7 de noviembre de 2024.',
                    'descripcionProcedimiento' : 'Rehabilitación del C.R. Tultitlán - E.C. (San Felipe-Tamazunchale), municipio de San Felipe Orizatlán.; ubicada en la localidad de Tultitlán, Municipio de San Felipe Orizatlán, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }24/N224/N224.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }24/N224/JAN224.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }24/N224/APN224.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }24/N224/FAN224.pdf`,
                       },
                    ],
                },
        // Licitación N223
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N223-2024.',
                    'vigencia' : 'Vigencia de venta de bases: del 28 de octubre al 7 de noviembre de 2024.',
                    'descripcionProcedimiento' : 'Reconstrucción del Blvd. Santa Cecilia, La Providencia, Mineral de la Reforma.; ubicada en la localidad de La Providencia Siglo XXI, Municipio de Mineral de la Reforma, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }24/N223/N223.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }24/N223/JAN223.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }24/N223/APN223.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }24/N223/FAN223.pdf`,
                       },
                    ],
                },
        // Licitación N222
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N222-2024.',
                    'vigencia' : 'Vigencia de venta de bases: del 28 de octubre al 7 de noviembre de 2024.',
                    'descripcionProcedimiento' : 'Rehabilitación de camino Cuatitlanapa a La Unión, del km 0.000 al km 6.000, en el municipio de Lolotla.; ubicada en Varias localidades del Municipio de Lolotla, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }24/N222/N222.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }24/N222/JAN222.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }24/N222/APN222.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }24/N222/FAN222.pdf`,
                       },
                    ],
                },
        // Licitación N221
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N221-2024.',
                    'vigencia' : 'Vigencia de venta de bases: del 28 de octubre al 7 de noviembre de 2024.',
                    'descripcionProcedimiento' : 'Ampliación de construcción de la línea de conducción de agua potable del pozo San Pedro Huatengo al tanque elevado en la colonia Satélites, en el municipio de Santiago Tulantepec.; ubicada en la localidad de San Pedro Huatengo, Municipio de Santiago Tulantepec de Lugo Guerrero, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }24/N221/N221.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }24/N221/JAN221.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }24/N221/APN221.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }24/N221/FAN221.pdf`,
                       },
                    ],
                },
        // Licitación N220
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N220-2024.',
                    'vigencia' : 'Vigencia de venta de bases: del 28 de octubre al 7 de noviembre de 2024.',
                    'descripcionProcedimiento' : 'Construcción de pavimento hidráulico en calle 21 de Marzo, San Guillermo la Reforma, municipio de Mineral de la Reforma.; ubicada en la localidad de San Guillermo la Reforma, Municipio de Mineral de la Reforma, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }24/N220/N220.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }24/N220/JAN220.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }24/N220/APN220.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }24/N220/FAN220.pdf`,
                       },
                    ],
                },
        // Licitación N219
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N219-2024.',
                    'vigencia' : 'Vigencia de venta de bases: del 28 de octubre al 7 de noviembre de 2024.',
                    'descripcionProcedimiento' : 'Rehabilitación de avenida Corona del Rosal, conjunto habitacional Juan C. Doria en el municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }24/N219/N219.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }24/N219/JAN219.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }24/N219/APN219.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }24/N219/FAN219.pdf`,
                       },
                    ],
                },
        // Licitación N218
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N218-2024.',
                    'vigencia' : 'Vigencia de venta de bases: del 28 de octubre al 7 de noviembre de 2024.',
                    'descripcionProcedimiento' : 'Rehabilitación de camino E.C. de Tepehuacán a San Juan Ahuehueco, a Choquintla, en el municipio de Tepehuacán de Guerrero.; ubicada en la localidad de Choquintla (San Nicolás Choquintla), Municipio de Tepehuacán de Guerrero, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }24/N218/N218.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }24/N218/JAN218.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }24/N218/APN218.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }24/N218/FAN218.pdf`,
                       },
                    ],
                },
        // Licitación N217
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N217-2024.',
                    'vigencia' : 'Vigencia de venta de bases: del 28 de octubre al 7 de noviembre de 2024.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica de avenida Revolución, San Gabriel Atengo - Achichilco, municipio de Tezontepec de Aldama.; ubicada en la localidad de San Gabriel, Municipio de Tezontepec de Aldama, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }24/N217/N217.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }24/N217/JAN217.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }24/N217/APN217.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }24/N217/FAN217.pdf`,
                       },
                    ],
                },
            // Licitación N216
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N216-2024.',
                'vigencia': 'Vigencia de venta de bases: del 28 de octubre al 6 de noviembre de 2024.',
                'descripcionProcedimiento': 'Rehabilitación del C.R. Hueytlale - Petlácatl Comunal - Zacapilol, municipio de San Felipe Orizatlán.; ubicada en la localidad de Hueytlale, Municipio de San Felipe Orizatlán, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }24/N216/N216.rar`,
                'resultados': [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }24/N216/JAN216.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }24/N216/APN216.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }24/N216/FAN216.pdf`,
                       },
                ],
            },
            // Licitación N215
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N215-2024.',
                'vigencia': 'Vigencia de venta de bases: del 28 de octubre al 6 de noviembre de 2024.',
                'descripcionProcedimiento': 'Reconstrucción de pavimento de concreto hidráulico en calle San Martín de Porres, Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }24/N215/N215.rar`,
                'resultados': [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }24/N215/JAN215.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }24/N215/APN215.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }24/N215/FAN215.pdf`,
                       },
                ],
            },
            // Licitación N214
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N214-2024.',
                'vigencia': 'Vigencia de venta de bases: del 28 de octubre al 6 de noviembre de 2024.',
                'descripcionProcedimiento': 'Construcción de pavimento tramo Tripuente a Chalahuite, en el municipio de Pisaflores.; ubicada en la localidad de Chalahuite, Municipio de Pisaflores, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }24/N214/N214.rar`,
                'resultados': [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }24/N214/JAN214.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }24/N214/APN214.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }24/N214/FAN214.pdf`,
                       },
                ],
            },
            // Licitación N213
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N213-2024.',
                'vigencia': 'Vigencia de venta de bases: del 28 de octubre al 6 de noviembre de 2024.',
                'descripcionProcedimiento': 'Rehabilitación del C.R. Atlalco - Acanoa, municipio de Xochiatipan.; ubicada en la localidad de Atlalco, Municipio de Xochiatipan, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }24/N213/N213.rar`,
                'resultados': [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }24/N213/JAN213.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }24/N213/APN213.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }24/N213/FAN213.pdf`,
                       },
                ],
            },
            // Licitación N212
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N212-2024.',
                'vigencia': 'Vigencia de venta de bases: del 28 de octubre al 6 de noviembre de 2024.',
                'descripcionProcedimiento': 'Construcción de pavimentación con concreto hidráulico en Calle Tlaloc, en la localidad de Santiago Tezontlale, Colonia Cuauhtémoc, municipio de Ajacuba.; ubicada en la localidad de Santiago Tezontlale, Municipio de Ajacuba, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }24/N212/N212.rar`,
                'resultados': [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }24/N212/JAN212.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }24/N212/APN212.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }24/N212/FAN212.pdf`,
                       },
                ],
            },
            // Licitación N211
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N211-2024.',
                'vigencia': 'Vigencia de venta de bases: del 28 de octubre al 6 de noviembre de 2024.',
                'descripcionProcedimiento': 'Construcción de pavimentación asfáltica en Circuito Sur, en la localidad de Xothí, en el municipio de Chilcuautla.; ubicada en la localidad de El Xothí, Municipio de Chilcuautla, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }24/N211/N211.rar`,
                'resultados': [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }24/N211/JAN211.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }24/N211/APN211.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }24/N211/FAN211.pdf`,
                       },
                ],
            },
            // Licitación N210
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N210-2024.',
                'vigencia': 'Vigencia de venta de bases: del 28 de octubre al 6 de noviembre de 2024.',
                'descripcionProcedimiento': 'Rehabilitación de Av. Federalismo, colonia El Palmar, en el municipio de Pachuca (segunda etapa).; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }24/N210/N210.rar`,
                'resultados': [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }24/N210/JAN210.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }24/N210/APN210.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }24/N210/FAN210.pdf`,
                       },
                ],
            },
            // Licitación N209
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N209-2024.',
                'vigencia': 'Vigencia de venta de bases: del 28 de octubre al 6 de noviembre de 2024.',
                'descripcionProcedimiento': 'Rehabilitación de la C.E Xochiatipan - Pezmayo, municipio de Xochiatipan.; ubicada en la localidad de Pesmayo, Municipio de Xochiatipan, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }24/N209/N209.rar`,
                'resultados': [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }24/N209/JAN209.pdf`,
                       },
                       {
                        'resultado' : 'Anexo modificatorio',
                        'urlresultado' : `${ ligabase }24/N209/AMDJAN209.pdf`,
                    },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }24/N209/APN209.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }24/N209/FAN209.pdf`,
                       },
                ],
            },
            // Licitación N208
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N208-2024.',
                'vigencia': 'Vigencia de venta de bases: del 28 de octubre al 6 de noviembre de 2024.',
                'descripcionProcedimiento': 'Rehabilitación de la C.E.(E.C. Pachuca-Tempoal) - Santa María, municipio de Tlanchinol.; ubicada en la localidad de Santa María Catzotipan (Santa María Tepetzintla), Municipio de Tlanchinol, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }24/N208/N208.rar`,
                'resultados': [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }24/N208/JAN208.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }24/N208/APN208.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }24/N208/FAN208.pdf`,
                       },
                ],
            },
            // Licitación N207
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N207-2024.',
                'vigencia': 'Vigencia de venta de bases: del 28 de octubre al 5 de noviembre de 2024.',
                'descripcionProcedimiento': 'Pavimentación asfáltica en camino col. Bonfil - Salida a Tepeapulco, en el municipio de Tlanalapa.; ubicada en la localidad y Municipio de Tlanalapa, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }24/N207/N207.rar`,
                'resultados': [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }24/N207/JAN207.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }24/N207/APN207.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }24/N207/FAN207.pdf`,
                       },
                ],
            },
            // Licitación N206
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N206-2024.',
                'vigencia': 'Vigencia de venta de bases: del 28 de octubre al 5 de noviembre de 2024.',
                'descripcionProcedimiento': 'Rehabilitación del Boulevard Ejército Mexicano, tramo Glorieta del Soldado E.C.F. México Pachuca.; ubicada en la localidad y Municipio de Tizayuca, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }24/N206/N206.rar`,
                'resultados': [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }24/N206/JAN206.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }24/N206/APN206.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }24/N206/FAN206.pdf`,
                       },
                ],
            },
            // Licitación N205
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N205-2024.',
                'vigencia': 'Vigencia de venta de bases: del 28 de octubre al 5 de noviembre de 2024.',
                'descripcionProcedimiento': 'Construcción de pavimentación de concreto hidráulico en calle 5 de mayo, Col. Chapultepec, en el municipio de Actopan.; ubicada en la localidad y Municipio de Actopan, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }24/N205/N205.rar`,
                'resultados': [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }24/N205/JAN205.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }24/N205/APN205.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }24/N205/FAN205.pdf`,
                       },
                ],
            },
            // Licitación N204
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N204-2024.',
                'vigencia': 'Vigencia de venta de bases: del 28 de octubre al 5 de noviembre de 2024.',
                'descripcionProcedimiento': 'Pavimentación de concreto hidráulico en calle Prolongación Rojo Gómez en la colonia La Loma, en el municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }24/N204/N204.rar`,
                'resultados': [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }24/N204/JAN204.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }24/N204/APN204.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }24/N204/FAN204.pdf`,
                       },
                ],
            },
            // Licitación N203
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N203-2024.',
                'vigencia': 'Vigencia de venta de bases: del 28 de octubre al 5 de noviembre de 2024.',
                'descripcionProcedimiento': 'Rehabilitación de la Av. Solidaridad del Km 0+000 al Km 0+900, en el municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }24/N203/N203.rar`,
                'resultados': [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }24/N203/JAN203.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }24/N203/APN203.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }24/N203/FAN203.pdf`,
                       },
                ],
            },
            // Licitación N202
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N202-2024.',
                'vigencia': 'Vigencia de venta de bases: del 28 de octubre al 5 de noviembre de 2024.',
                'descripcionProcedimiento': 'Reconstrucción de muro de contención en la C.E. Huejutla - Macuxtepetla, municipio de Huejutla de Reyes.; ubicada en la localidad de Tepexititla, Municipio de Huejutla de Reyes, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }24/N202/N202.rar`,
                'resultados': [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }24/N202/JAN202.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }24/N202/APN202.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }24/N202/FAN202.pdf`,
                       },
                ],
            },
            // Licitación N201
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N201-2024.',
                'vigencia': 'Vigencia de venta de bases: del 28 de octubre al 5 de noviembre de 2024.',
                'descripcionProcedimiento': 'Reconstrucción de la C.E. Santa Ana de Allende - Huatepango, municipio de Chapulhuacán.; ubicada en Varias localidades del Municipio de Chapulhuacán, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }24/N201/N201.rar`,
                'resultados': [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }24/N201/JAN201.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }24/N201/APN201.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }24/N201/FAN201.pdf`,
                       },
                ],
            },
            // Licitación N200
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N200-2024.',
                'vigencia': 'Vigencia de venta de bases: del 28 de octubre al 5 de noviembre de 2024.',
                'descripcionProcedimiento': 'Reconstrucción de la Carretera Eloxochitlán - Juárez Hidalgo; en el municipio de Juárez Hidalgo (Segunda Etapa).; ubicada en la localidad y Municipio de Juárez Hidalgo, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }24/N200/N200.rar`,
                'resultados': [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }24/N200/JAN200.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }24/N200/APN200.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }24/N200/FAN200.pdf`,
                       },
                ],
            },
            // Licitación N199
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N199-2024.',
                'vigencia': 'Vigencia de venta de bases: del 28 de octubre al 5 de noviembre de 2024.',
                'descripcionProcedimiento': 'Reconstrucción asfáltica de la calle Camino Interparcelario, entronque con boulevard Las Torres, municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }24/N199/N199.rar`,
                'resultados': [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }24/N199/JAN199.pdf`,
                       },
                    //    {
                    //        'resultado' : 'Apertura',
                    //        'urlresultado' : `${ ligabase }24/N199/APN199.pdf`,
                    //    },
                    //    {
                    //        'resultado' : 'Fallo',
                    //        'urlresultado' : `${ ligabase }24/N199/FAN199.pdf`,
                    //    },
                ],
            },
            // Licitación N198
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N198-2024.',
                'vigencia': 'Vigencia de venta de bases: del 28 de octubre al 4 de noviembre de 2024.',
                'descripcionProcedimiento': 'Rehabilitación de la C.E. Chantasco - Xalcuatla, municipio de Lolotla.; ubicada en la localidad de Chantasco, Municipio de Lolotla, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }24/N198/N198.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }24/N198/JAN198.pdf`,
                    },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }24/N198/APN198.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }24/N198/FAN198.pdf`,
                       },
                ],
            },
            // Licitación N197
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N197-2024.',
                'vigencia': 'Vigencia de venta de bases: del 28 de octubre al 4 de noviembre de 2024.',
                'descripcionProcedimiento': 'Rehabilitación de carpeta asfáltica en boulevard Pachuca - Pachuquilla (Imss - Amaque) dos cuerpos, municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }24/N197/N197.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }24/N197/JAN197.pdf`,
                    },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }24/N197/APN197.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }24/N197/FAN197.pdf`,
                       },
                ],
            },
            // Licitación N196
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N196-2024.',
                'vigencia': 'Vigencia de venta de bases: del 28 de octubre al 4 de noviembre de 2024.',
                'descripcionProcedimiento': 'Construcción de pavimentación hidráulica del Camino Rural los Parajes a Chalahuiyapa segunda etapa, en el municipio de Huejutla de Reyes.; ubicada en la localidad de Los Parajes Benito Juárez, Municipio de Huejutla de Reyes, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }24/N196/N196.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }24/N196/JAN196.pdf`,
                    },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }24/N196/APN196.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }24/N196/FAN196.pdf`,
                       },
                ],
            },
            // Licitación N195
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N195-2024.',
                'vigencia': 'Vigencia de venta de bases: del 28 de octubre al 4 de noviembre de 2024.',
                'descripcionProcedimiento': 'Construcción de pavimentación asfáltica en la localidad de Santa Mónica, municipio de Tenango de Doria.; ubicada en la localidad de Santa Mónica, Municipio de Tenango de Doria, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }24/N195/N195.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }24/N195/JAN195.pdf`,
                    },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }24/N195/APN195.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }24/N195/FAN195.pdf`,
                       },
                ],
            },
            // Licitación N194
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N194-2024.',
                'vigencia': 'Vigencia de venta de bases: del 28 de octubre al 4 de noviembre de 2024.',
                'descripcionProcedimiento': 'Reconstrucción del C.R. Jalpa - La Florida, municipio de Lolotla.; ubicada en la localidad de La Florida, Municipio de Lolotla, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }24/N194/N194.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }24/N194/JAN194.pdf`,
                    },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }24/N194/APN194.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }24/N194/FAN194.pdf`,
                       },
                ],
            },
            // Licitación N193
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N193-2024.',
                'vigencia': 'Vigencia de venta de bases: del 28 de octubre al 4 de noviembre de 2024.',
                'descripcionProcedimiento': 'Pavimentación del C.R. acceso a Tizapan, en el municipio de Zacualtipán de Ángeles.; ubicada en la localidad de Tizapán, Municipio de Zacualtipán de Ángeles, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }24/N193/N193.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }24/N193/JAN193.pdf`,
                    },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }24/N193/APN193.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }24/N193/FAN193.pdf`,
                       },
                ],
            },
            // Licitación N192
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N192-2024.',
                'vigencia': 'Vigencia de venta de bases: del 28 de octubre al 4 de noviembre de 2024.',
                'descripcionProcedimiento': 'Construcción de pavimentación de concreto hidráulico en acceso a la localidad La Laguna,municipio de Apan.; ubicada en la localidad de La Laguna, Municipio de Apan, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }24/N192/N192.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }24/N192/JAN192.pdf`,
                    },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }24/N192/APN192.pdf`,
                       },
                    //    {
                    //        'resultado' : 'Fallo',
                    //        'urlresultado' : `${ ligabase }24/N192/FAN192.pdf`,
                    //    },
                ],
            },
            // Licitación N191
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N191-2024.',
                'vigencia': 'Vigencia de venta de bases: del 28 de octubre al 4 de noviembre de 2024.',
                'descripcionProcedimiento': 'Reconstrucción de la Carretera Ramal a Tlahuelompa (Segunda Etapa), en el municipio de Zacualtipán.; ubicada en la localidad de Tlahuelompa (San Francisco Tlahuelompa), Municipio de Zacualtipán de Ángeles, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }24/N191/N191.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }24/N191/JAN191.pdf`,
                    },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }24/N191/APN191.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }24/N191/FAN191.pdf`,
                       },
                ],
            },
            // Licitación N190
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N190-2024.',
                'vigencia': 'Vigencia de venta de bases: del 28 de octubre al 4 de noviembre de 2024.',
                'descripcionProcedimiento': 'Reconstrucción de pavimento asfáltico en camino acceso a San José Palma Gorda - La Higa, municipio de Mineral de la Reforma.; ubicada en la localidad de San Miguel la Higa, Municipio de Mineral de la Reforma, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }24/N190/N190.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }24/N190/JAN190.pdf`,
                    },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }24/N190/APN190.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }24/N190/FAN190.pdf`,
                       },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 023
        'numConvocatoria': 'Convocatoria No. 023/2024.',
        'idConvocatoria': 'Convocatoria23',
        'procedimientos': [
            // Licitación N189
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N189-2024.',
                'vigencia': 'Vigencia de venta de bases: del 28 de octubre al 6 de noviembre de 2024',
                'descripcionProcedimiento': 'Proyecto de restauración de la Estación de Ferrocarril "Apulco".; ubicada en la localidad de Estación de Apulco, Municipio de Metepec, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }23/N189/N189.rar`,
                'resultados': [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }23/N189/JAN189.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }23/N189/APN189.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }23/N189/FAN189.pdf`,
                       },
                ],
            },
            // Licitación N188
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N188-2024.',
                'vigencia': 'Vigencia de venta de bases: del 28 de octubre al 6 de noviembre de 2024.',
                'descripcionProcedimiento': 'Construcción de trota pista, espacios lúdicos y gimnasio al aire libre, en la reserva centro (cancha de futbol 7), en la cabecera municipal de Tecozautla.; ubicada en la localidad y Municipio de Tecozautla, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }23/N188/N188.rar`,
                'resultados': [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }23/N188/JAN188.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }23/N188/APN188.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }23/N188/FAN188.pdf`,
                       },
                ],
            },
            // Licitación N187
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N187-2024.',
                'vigencia': 'Vigencia de venta de bases: del 28 de octubre al 6 de noviembre de 2024.',
                'descripcionProcedimiento': 'Remodelación de campo de beisbol "Vicente Guerrero", en el municipio de Tolcayuca.; ubicada en la localidad y Municipio de Tolcayuca, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }23/N187/N187.rar`,
                'resultados': [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }23/N187/JAN187.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }23/N187/APN187.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }23/N187/FAN187.pdf`,
                       },
                ],
            },
            // Licitación N186
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N186-2024.',
                'vigencia': 'Vigencia de venta de bases: del 28 de octubre al 6 de noviembre de 2024.',
                'descripcionProcedimiento': 'Rehabilitación de calles de acceso Valle de San Javier entronque Río de las Avenidas, Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }23/N186/N186.rar`,
                'resultados': [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }23/N186/JAN186.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }23/N186/APN186.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }23/N186/FAN186.pdf`,
                       },
                ],
            },
            // Licitación N185
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N185-2024.',
                'vigencia': 'Vigencia de venta de bases: del 28 de octubre al 6 de noviembre de 2024.',
                'descripcionProcedimiento': 'Reconstrucción de puente vehicular acceso a Tenexhueyac, municipio de Xochiatipan.; ubicada en la localidad de Tenexhueyac, Municipio de Xochiatipan, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }23/N185/N185.rar`,
                'resultados': [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }23/N185/JAN185.pdf`,
                       },
                       {
                        'resultado' : 'Anexo modificatorio',
                        'urlresultado' : `${ ligabase }23/N185/AMDJAN185.pdf`,
                    },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }23/N185/APN185.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }23/N185/FAN185.pdf`,
                       },
                ],
            },
            // Licitación N184
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N184-2024.',
                'vigencia': 'Vigencia de venta de bases: del 28 de octubre al 6 de noviembre de 2024.',
                'descripcionProcedimiento': 'Construcción de interconexiones a la línea de conducción del sistema de agua potable Los Berros, en el municipio de Atotonilco el Grande.; ubicada en la localidad y Municipio de Atotonilco el Grande, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }23/N184/N184.rar`,
                'resultados': [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }23/N184/JAN184.pdf`,
                       },
                       {
                        'resultado' : 'Anexo modificatorio',
                        'urlresultado' : `${ ligabase }23/N184/AMDJAN184.pdf`,
                    },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }23/N184/APN184.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }23/N184/FAN184.pdf`,
                       },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 022
        'numConvocatoria': 'Convocatoria No. 022/2024.',
        'idConvocatoria': 'Convocatoria22',
        'procedimientos': [
            // Licitación N183
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N183-2024.',
                'vigencia': 'Vigencia de venta de bases: del 21 de octubre al 5 de noviembre de 2024',
                'descripcionProcedimiento': 'Modernización de C.R. El Ixtle - El Aguacate, en el municipio de Huautla.; ubicada en la localidad de El Ixtle, Municipio de Huautla, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }22/N183/N183.rar`,
                'resultados': [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }22/N183/JAN183.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }22/N183/APN183.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }22/N183/FAN183.pdf`,
                       },
                ],
            },
            // Licitación N182
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N182-2024.',
                'vigencia': 'Vigencia de venta de bases: del 21 de octubre al 5 de noviembre de 2024.',
                'descripcionProcedimiento': 'Rehabilitación y mejoramiento de la imagen urbana de avenida Álamo del 0+000 al Km 1+020, El Tezontle, municipio  de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }22/N182/N182.rar`,
                'resultados': [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }22/N182/JAN182.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }22/N182/APN182.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }22/N182/FAN182.pdf`,
                       },
                ],
            },
            // Licitación N181
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N181-2024.',
                'vigencia': 'Vigencia de venta de bases: del 21 de octubre al 5 de noviembre de 2024.',
                'descripcionProcedimiento': 'Apertura de camino intermunicipal Tuzancocac (Xochicoatlán) - Tula (Calnai), segunda etapa, en el municipio de Xochicoatlán.; ubicada en la localidad de Tuzancoac, Municipio de Xochicoatlán, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }22/N181/N181.rar`,
                'resultados': [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }22/N181/JAN181.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }22/N181/APN181.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }22/N181/FAN181.pdf`,
                       },
                ],
            },
            // Licitación N180
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N180-2024.',
                'vigencia': 'Vigencia de venta de bases: del 21 de octubre al 5 de noviembre de 2024.',
                'descripcionProcedimiento': 'Pavimentación en Calle Primero de Mayo, fraccionamientos, en el municipio de Zempoala.; ubicada en Varias localidades del Municipio de Zempoala, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }22/N180/N180.rar`,
                'resultados': [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }22/N180/JAN180.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }22/N180/APN180.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }22/N180/FAN180.pdf`,
                       },
                ],
            },
            // Licitación N179
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N179-2024.',
                'vigencia': 'Vigencia de venta de bases: del 21 de octubre al 5 de noviembre de 2024.',
                'descripcionProcedimiento': 'Reconstrucción y rehabilitación de la Carretera La Estanzuela - Tilcuautla, municipio de Mineral del Chico.; ubicada en la localidad y Municipio de Mineral del Chico, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }22/N179/N179.rar`,
                'resultados': [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }22/N179/JAN179.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }22/N179/APN179.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }22/N179/FAN179.pdf`,
                       },
                ],
            },
            // Licitación N178
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N178-2024.',
                'vigencia': 'Vigencia de venta de bases: del 21 de octubre al 5 de noviembre de 2024.',
                'descripcionProcedimiento': 'Fortalecimiento eléctrico del Centro Cultural del Ferrocarril.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }22/N178/N178.rar`,
                'resultados': [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }22/N178/JAN178.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }22/N178/APN178.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }22/N178/FAN178.pdf`,
                       },
                ],
            },
            // Licitación N177
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N177-2024.',
                'vigencia': 'Vigencia de venta de bases: del 21 de octubre al 5 de noviembre de 2024.',
                'descripcionProcedimiento': 'Construcción del nuevo Centro Gerontológico Integral de Huejutla de Reyes.; ubicada en la localidad y Municipio de Huejutla de Reyes, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }22/N177/N177.rar`,
                'resultados': [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }22/N177/JAN177.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }22/N177/APN177.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }22/N177/FAN177.pdf`,
                       },
                ],
            },
            // Licitación N176
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N176-2024.',
                'vigencia': 'Vigencia de venta de bases: del 21 de octubre al 4 de noviembre de 2024.',
                'descripcionProcedimiento': 'Reconstrucción de la C.E. casetas Otongo, municipio de Tlanchinol.; ubicada en Varias localidades del Municipio de Tlanchinol, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }22/N176/N176.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }22/N176/JAN176.pdf`,
                    },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }22/N176/APN176.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }22/N176/FAN176.pdf`,
                       },
                ],
            },
            // Licitación N175
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N175-2024.',
                'vigencia': 'Vigencia de venta de bases: del 21 de octubre al 4 de noviembre de 2024.',
                'descripcionProcedimiento': 'Pavimentación hidráulica en calle El Roble y Av. de Los Sabinos, en San Miguel La Higa, Mineral de la Reforma.; ubicada en la localidad de San Miguel la Higa, Municipio de Mineral de la Reforma, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }22/N175/N175.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }22/N175/JAN175.pdf`,
                    },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }22/N175/APN175.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }22/N175/FAN175.pdf`,
                       },
                ],
            },
            // Licitación N174
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N174-2024.',
                'vigencia': 'Vigencia de venta de bases: del 21 de octubre al 4 de noviembre de 2024.',
                'descripcionProcedimiento': 'Reconstrucción asfáltica paseo de Los Solares (dos cuerpos), municipio de San Agustín Tlaxiaca.; ubicada en la localidad de San Juan Tilcuautla, Municipio de San Agustín Tlaxiaca, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }22/N174/N174.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }22/N174/JAN174.pdf`,
                    },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }22/N174/APN174.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }22/N174/FAN174.pdf`,
                       },
                ],
            },
            // Licitación N173
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N173-2024.',
                'vigencia': 'Vigencia de venta de bases: del 21 de octubre al 4 de noviembre de 2024.',
                'descripcionProcedimiento': 'Construcción de pavimentación asfáltica en caminos rurales de la Manzana El Pirul de la localidad de La Estancia, municipio de Chilcuautla.; ubicada en la localidad de La Estancia, Municipio de Chilcuautla, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }22/N173/N173.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }22/N173/JAN173.pdf`,
                    },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }22/N173/APN173.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }22/N173/FAN173.pdf`,
                       },
                ],
            },
            // Licitación N172
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N172-2024.',
                'vigencia': 'Vigencia de venta de bases: del 21 de octubre al 4 de noviembre de 2024.',
                'descripcionProcedimiento': 'Pavimentación hidráulica de camino El Mercillero - Crucero de Nexpa, tercera etapa, municipio de Epazoyucan.; ubicada en la localidad de El Mercillero, Municipio de Epazoyucan, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }22/N172/N172.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }22/N172/JAN172.pdf`,
                    },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }22/N172/APN172.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }22/N172/FAN172.pdf`,
                       },
                ],
            },
            // Licitación N171
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N171-2024.',
                'vigencia': 'Vigencia de venta de bases: del 21 de octubre al 4 de noviembre de 2024.',
                'descripcionProcedimiento': 'Construcción de pavimentación asfáltica Acceso a Jiquilpan, en el municipio de Apan.; ubicada en la localidad de San José Jiquilpan, Municipio de Apan, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }22/N171/N171.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }22/N171/JAN171.pdf`,
                    },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }22/N171/APN171.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }22/N171/FAN171.pdf`,
                       },
                ],
            },
            // Licitación N170
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N170-2024.',
                'vigencia': 'Vigencia de venta de bases: del 21 de octubre al 4 de noviembre de 2024.',
                'descripcionProcedimiento': 'Estudios de impacto ambiental y análisis costo beneficio para la continuación de la construcción de la vialidad y el encauzamiento del río de las avenidas, municipio de Mineral de la Reforma; ubicado en varias localidades del Municipio de Mineral de la Reforma, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }22/N170/N170.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }22/N170/JAN170.pdf`,
                    },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }22/N170/APN170.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }22/N170/FAN170.pdf`,
                       },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 021
        'numConvocatoria': 'Convocatoria No. 021/2024.',
        'idConvocatoria': 'Convocatoria21',
        'procedimientos': [
            // Licitación N169
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N169-2024.',
                'vigencia': 'Vigencia de venta de bases: del 14 al 29 de octubre de 2024',
                'descripcionProcedimiento': 'Remodelación de andadores y espacios anexos al jardín "Hombres y Mujeres Ilustres de Hidalgo"; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }21/N169/N169.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }21/N169/JAN169.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }21/N169/APN169.pdf`,
                    },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }21/N169/FAN169.pdf`,
                       },
                ],
            },
            // Licitación N168
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N168-2024.',
                'vigencia': 'Vigencia de venta de bases: del 14 al 29 de octubre de 2024.',
                'descripcionProcedimiento': 'Remodelación de parque, beneficiando a la localidad de Eloxochitlán, municipio de Eloxochitlán; ubicada en la localidad de Eloxochitlan, Municipio de Eloxochitlán, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }21/N168/N168.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }21/N168/JAN168.pdf`,
                    },
                    //    {
                    //        'resultado' : 'Apertura',
                    //        'urlresultado' : `${ ligabase }21/N168/APN168.pdf`,
                    //    },
                    //    {
                    //        'resultado' : 'Fallo',
                    //        'urlresultado' : `${ ligabase }21/N168/FAN168.pdf`,
                    //    },
                ],
            },
            // Licitación N167
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N167-2024.',
                'vigencia': 'Vigencia de venta de bases: del 14 al 29 de octubre de 2024.',
                'descripcionProcedimiento': 'Centro Gastronómico y Turístico Santiago de Anaya Primera Etapa.; ubicada en la localidad y Municipio de Santiago de Anaya, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }21/N167/N167.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }21/N167/JAN167.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }21/N167/APN167.pdf`,
                    },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }21/N167/FAN167.pdf`,
                       },
                ],
            },
            // Licitación N166
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N166-2024.',
                'vigencia': 'Vigencia de venta de bases: del 14 al 29 de octubre de 2024.',
                'descripcionProcedimiento': 'Construcción de pavimento hidráulico en calle Prolongación Hidalgo en la localidad de Estación de Apulco, en el municipio de Metepec.; ubicada en la localidad de Estación de Apulco, Municipio de Metepec, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }21/N166/N166.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }21/N166/JAN166.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }21/N166/APN166.pdf`,
                    },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }21/N166/FAN166.pdf`,
                       },
                ],
            },
            // Licitación N165
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N165-2024.',
                'vigencia': 'Vigencia de venta de bases: del 14 al 29 de octubre de 2024.',
                'descripcionProcedimiento': 'Construcción de pavimentación hidráulica acceso a Zacualtipanito, en el municipio de Tepehuacán de Guerrero.; ubicada en la localidad de Zacualtipanito, Municipio de Tepehuacán de Guerrero, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }21/N165/N165.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }21/N165/JAN165.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }21/N165/APN165.pdf`,
                    },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }21/N165/FAN165.pdf`,
                       },
                ],
            },
            // Licitación N164
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N164-2024.',
                'vigencia': 'Vigencia de venta de bases: del 14 al 29 de octubre de 2024.',
                'descripcionProcedimiento': 'Reconstrucción de pavimento hidráulico en Boulevard San Carlos, Fraccionamiento San José, municipio de Mineral de la Reforma.; ubicada en la localidad de San José, Municipio de Mineral de la Reforma, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }21/N164/N164.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }21/N164/JAN164.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }21/N164/APN164.pdf`,
                    },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }21/N164/FAN164.pdf`,
                       },
                ],
            },
            // Licitación N163
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N163-2024.',
                'vigencia': 'Vigencia de venta de bases: del 14 al 29 de octubre de 2024.',
                'descripcionProcedimiento': 'Construcción de bardeado perimetral del Instituto de Formación Profesional.; ubicada en la localidad de San José Palma Gorda, Municipio de Mineral de la Reforma, Estado de Hidalgo. (Segundo procedimiento).',
                'urlAnexos': `${ ligabase }21/N163/N163.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }21/N163/JAN163.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }21/N163/APN163.pdf`,
                    },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }21/N163/FAN163.pdf`,
                       },
                ],
            },
            // Licitación N162
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N162-2024.',
                'vigencia': 'Vigencia de venta de bases: del 14 al 29 de octubre de 2024.',
                'descripcionProcedimiento': 'Mantenimiento integral de instalaciones eléctricas e instalación de circuito de seguridad en Ex-Hacienda la Concepción_2024.; ubicada en la localidad de San Juan Tilcuautla, Municipio de San Agustín Tlaxiaca, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }21/N162/N162.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }21/N162/JAN162.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }21/N162/APN162.pdf`,
                    },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }21/N162/FAN162.pdf`,
                       },
                ],
            },

            // Licitación N161
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N161-2024.',
                'vigencia': 'Vigencia de venta de bases: del 14 al 28 de octubre de 2024.',
                'descripcionProcedimiento': 'Construcción de tanque elevado capacidad de 250 m3 pozo 1 y 2 "El Bojayito", Los Tepetates, municipio de Tlaxcoapan.; ubicada en la localidad y Municipio de Tlaxcoapan, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }21/N161/N161.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }21/N161/JAN161.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }21/N161/APN161.pdf`,
                    },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }21/N161/FAN161.pdf`,
                       },
                ],
            },
            // Licitación N160
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N160-2024.',
                'vigencia': 'Vigencia de venta de bases: del 14 al 28 de octubre de 2024.',
                'descripcionProcedimiento': 'Perforación exploratoria y equipamiento de pozo profundo Rincón Chico, en el municipio de Omitlán de Juárez.; ubicada en la localidad y Municipio de Omitlán de Juárez, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }21/N160/N160.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }21/N160/JAN160.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }21/N160/APN160.pdf`,
                    },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }21/N160/FAN160.pdf`,
                       },
                ],
            },
            // Licitación N159
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N159-2024.',
                'vigencia': 'Vigencia de venta de bases: del 14 al 28 de octubre de 2024.',
                'descripcionProcedimiento': 'Reconstrucción de la C.E. San Bartolo - San Miguel, municipio de San Bartolo Tutotepec.; ubicada en la localidad y Municipio de San Bartolo Tutotepec, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }21/N159/N159.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }21/N159/JAN159.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }21/N159/APN159.pdf`,
                    },
                    //    {
                    //        'resultado' : 'Fallo',
                    //        'urlresultado' : `${ ligabase }21/N159/FAN159.pdf`,
                    //    },
                ],
            },
            // Licitación N158
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N158-2024.',
                'vigencia': 'Vigencia de venta de bases: del 14 al 28 de octubre de 2024.',
                'descripcionProcedimiento': 'Construcción de superestructura para puente en camino de acceso principal a la localidad El Piñal, San Bartolo Tutotepec.; ubicada en la localidad de El Piñal, Municipio de San Bartolo Tutotepec, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }21/N158/N158.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }21/N158/JAN158.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }21/N158/APN158.pdf`,
                    },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }21/N158/FAN158.pdf`,
                       }, 
                ],
            },
            // Licitación N157
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N157-2024.',
                'vigencia': 'Vigencia de venta de bases: del 14 al 28 de octubre de 2024.',
                'descripcionProcedimiento': 'Obra complementaria para la rehabilitación de la unidad deportiva de San Bartolo Tutotepec.; ubicada en la localidad y Municipio de San Bartolo Tutotepec, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }21/N157/N157.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }21/N157/JAN157.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }21/N157/APN157.pdf`,
                    },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }21/N157/FAN157.pdf`,
                       },
                       {
                        'resultado' : 'Anexo modificatorio',
                        'urlresultado' : `${ ligabase }21/N157/AMDFAN157.pdf`,
                    },
                ],
            },
            // Licitación N156
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N156-2024.',
                'vigencia': 'Vigencia de venta de bases: del 14 al 28 de octubre de 2024.',
                'descripcionProcedimiento': 'Modernización del camino Eloxochitlán - Molango, en el municipio de Eloxochitlán (segunda etapa).; ubicada en la localidad de Ixmolintla, Municipio de Molango de Escamilla, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }21/N156/N156.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }21/N156/JAN156.pdf`,
                    },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }21/N156/APN156.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }21/N156/FAN156.pdf`,
                       },
                       {
                        'resultado' : 'Anexo modificatorio',
                        'urlresultado' : `${ ligabase }21/N156/AMDFAN156.pdf`,
                    },
                ],
            },
            // Licitación N155
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N155-2024.',
                'vigencia': 'Vigencia de venta de bases: del 14 al 28 de octubre de 2024.',
                'descripcionProcedimiento': 'Construcción de libramiento del Dendho a la carretera Tula - Jorobas, en el municipio de Atitalaquia.; ubicada en la localidad de Cardonal, Municipio de Atitalaquia, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }21/N155/N155.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }21/N155/JAN155.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }21/N155/APN155.pdf`,
                    },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }21/N155/FAN155.pdf`,
                       },
                ],
            },
            // Licitación N154
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N154-2024.',
                'vigencia': 'Vigencia de venta de bases: del 14 al 28 de octubre de 2024.',
                'descripcionProcedimiento': 'Pavimentación hidráulica en Calle Olivos, ampliación segunda manzana, en el municipio de Tepetitlán.; ubicada en la localidad de Colonia Ampliación (Segunda Manzana), Municipio de Tepetitlán, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }21/N154/N154.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }21/N154/JAN154.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }21/N154/APN154.pdf`,
                    },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }21/N154/FAN154.pdf`,
                       },
                ],
            },
            // Licitación N153
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N153-2024.',
                'vigencia': 'Vigencia de venta de bases: del 14 al 28 de octubre de 2024.',
                'descripcionProcedimiento': 'Reconstrucción del libramiento Tulancingo - Metepec, en el Municipio de Tulancingo de Bravo.; ubicada en la localidad de Zototlán, Municipio de Tulancingo de Bravo, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }21/N153/N153.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }21/N153/JAN153.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }21/N153/APN153.pdf`,
                    },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }21/N153/FAN153.pdf`,
                       },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 020
        'numConvocatoria': 'Convocatoria No. 020/2024.',
        'idConvocatoria': 'Convocatoria20',
        'procedimientos': [
            // Licitación N152
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N152-2024.',
                'vigencia': 'Vigencia de venta de bases: del 30 de septiembre al 11 de octubre de 2024',
                'descripcionProcedimiento': 'Construcción del sistema de alcantarillado sanitario en la localidad de Acocul Cebolletas municipio de Metepec, ubicada en la localidad de Acocul Cebolletas, Municipio de Metepec, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }20/N152/N152.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }20/N152/JAN152.pdf`,
                    },
                    {
                        'resultado': 'Anexo modificatorio',
                        'urlresultado': `${ ligabase }20/N152/AMDJAN152.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }20/N152/APN152.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }20/N152/FAN152.pdf`,
                    },
                ],
            },
            // Licitación N151
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N151-2024.',
                'vigencia': 'Vigencia de venta de bases: del 30 de septiembre al 11 de octubre de 2024.',
                'descripcionProcedimiento': 'Construcción de pavimentación hidráulica acceso a Petlapixca, en el municipio de Tepehuacán de Guerrero.; ubicada en la localidad de Petlapixca, Municipio de Tepehuacán de Guerrero, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }20/N151/N151.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }20/N151/JAN151.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }20/N151/APN151.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }20/N151/FAN151.pdf`,
                    },
                ],
            },
            // Licitación N150
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N150-2024.',
                'vigencia': 'Vigencia de venta de bases: del 30 de septiembre al 11 de octubre de 2024.',
                'descripcionProcedimiento': 'Pavimentación hidráulica de calle Sin Nombre en Puerto de Naranjos, en el municipio de La Misión.; ubicada en la localidad de Puerto de Naranjos, Municipio de La Misión, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }20/N150/N150.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }20/N150/JAN150.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }20/N150/APN150.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }20/N150/FAN150.pdf`,
                    },
                ],
            },
            // Licitación N149
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N149-2024.',
                'vigencia': 'Vigencia de venta de bases: del 30 de septiembre al 11 de octubre de 2024.',
                'descripcionProcedimiento': 'Pavimentación hidráulica de calle Michimaloyan, en la localidad de La Loma, municipio de Tepetitlán.; ubicada en la localidad de La Loma, Municipio de Tepetitlán, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }20/N149/N149.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }20/N149/JAN149.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }20/N149/APN149.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }20/N149/FAN149.pdf`,
                    },
                ],
            },
            // Licitación N148
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N148-2024.',
                'vigencia': 'Vigencia de venta de bases: del 30 de septiembre al 11 de octubre de 2024.',
                'descripcionProcedimiento': 'Construcción de pavimento hidráulico en Barrio Mirador calle Francisco Sarabia, municipio de Jaltocán.; ubicada en la localidad y Municipio de Jaltocán, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }20/N148/N148.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }20/N148/JAN148.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }20/N148/APN148.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }20/N148/FAN148.pdf`,
                    },
                ],
            },
            // Licitación N147
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N147-2024.',
                'vigencia': 'Vigencia de venta de bases: del 30 de septiembre al 11 de octubre de 2024.',
                'descripcionProcedimiento': 'Reconstrucción de pavimento asfáltico de Carretera Mineral del Chico - E.C.F. Pachuca - Huejutla.; ubicada en la localidad de La Estanzuela, Municipio de Mineral del Chico, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }20/N147/N147.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }20/N147/JAN147.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }20/N147/APN147.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }20/N147/FAN147.pdf`,
                    },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 019
        'numConvocatoria': 'Convocatoria No. 019/2024.',
        'idConvocatoria': 'Convocatoria19',
        'procedimientos': [
            // Licitación N146
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N146-2024.',
                'vigencia': 'Vigencia de venta de bases: del 23 de septiembre al 4 de octubre de 2024',
                'descripcionProcedimiento': 'Remodelación de las Instalaciones de la Estación de Radio y Televisión XHIND 94.1 FM en el Municipio de Tlanchinol.; ubicada en la localidad y Municipio de Tlanchinol, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }19/N146/N146.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }19/N146/JAN146.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }19/N146/APN146.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }19/N146/FAN146.pdf`,
                    },
                ],
            },
            // Licitación N145
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N145-2024.',
                'vigencia': 'Vigencia de venta de bases: del 23 de septiembre al 4 de octubre de 2024.',
                'descripcionProcedimiento': 'Rehabilitación de la C.E. ramal a Tlamamala, municipio de Huazalingo.; ubicada en la localidad de Tlamamala, Municipio de Huazalingo, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }19/N145/N145.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }19/N145/JAN145.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }19/N145/APN145.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }19/N145/FAN145.pdf`,
                    },
                ],
            },
            // Licitación N144
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N144-2024.',
                'vigencia': 'Vigencia de venta de bases: del 23 de septiembre al 4 de octubre de 2024.',
                'descripcionProcedimiento': 'Reconstrucción de pavimento asfáltico en calle Campo de Tiro, municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }19/N144/N144.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }19/N144/JAN144.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }19/N144/APN144.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }19/N144/FAN144.pdf`,
                    },
                ],
            },
            // Licitación N143
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N143-2024.',
                'vigencia': 'Vigencia de venta de bases: del 23 de septiembre al 4 de octubre de 2024.',
                'descripcionProcedimiento': 'Rehabilitación de C.R. San Pedro Gilo - Almolón - San Juan Amajac - Camarones - Cieneguilla, municipio de Eloxochitlán.; ubicada en Varias localidades del Municipio de Eloxochitlán, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }19/N143/N143.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }19/N143/JAN143.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }19/N143/APN143.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }19/N143/FAN143.pdf`,
                    },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 018
        'numConvocatoria': 'Convocatoria No. 018/2024.',
        'idConvocatoria': 'Convocatoria18',
        'procedimientos': [
            // Licitación N142
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N142-2024.',
                'vigencia': 'Vigencia de venta de bases: del 16 de septiembre al 3 de octubre de 2024',
                'descripcionProcedimiento': 'Construcción del dren pluvial San Antonio - Rio de las Avenidas, en los municipios de Pachuca de Soto y Mineral de la Reforma; ubicada en varias localidades de Cobertura Estatal. (Segundo procedimiento)',
                'urlAnexos': `${ ligabase }18/N142/N142.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }18/N142/JAN142.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }18/N142/APN142.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }18/N142/FAN142.pdf`,
                    },
                ],
            },
            // Licitación N141
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N141-2024.',
                'vigencia': 'Vigencia de venta de bases: del 16 de septiembre al 3 de octubre de 2024.',
                'descripcionProcedimiento': 'Rehabilitación de la imagen urbana de la vialidad Pachuca - Actopan y Boulevard de acceso a la Concepción, comunidad de Tilcuautla, en los municipios de Pachuca y San Agustín Tlaxiaca; ubicada en varias localidades de Cobertura Regional, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }18/N141/N141.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }18/N141/JAN141.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }18/N141/APN141.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }18/N141/FAN141.pdf`,
                    },
                ],
            },
            // Licitación N140
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N140-2024.',
                'vigencia': 'Vigencia de venta de bases: del 16 de septiembre al 3 de octubre de 2024.',
                'descripcionProcedimiento': 'Estudios de impacto ambiental, análisis costo beneficio y diseño de pavimento y geotecnia para la reconstrucción del boulevard Las Torres, en los municipios de Pachuca de Soto y Mineral de la Reforma; ubicada en varias localidades de Cobertura Regional, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }18/N140/N140.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }18/N140/JAN140.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }18/N140/APN140.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }18/N140/FAN140.pdf`,
                    },
                ],
            },
            // Licitación N139
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N139-2024.',
                'vigencia': 'Vigencia de venta de bases: del 16 de septiembre al 3 de octubre de 2024.',
                'descripcionProcedimiento': 'Construcción de pavimentación asfáltica en la localidad de Zimapantongo, municipio de Chapantongo.; ubicada en la localidad de Zimapantongo, Municipio de Chapantongo, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }18/N139/N139.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }18/N139/JAN139.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }18/N139/APN139.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }18/N139/FAN139.pdf`,
                    },
                ],
            },
            // Licitación N138
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N138-2024.',
                'vigencia': 'Vigencia de venta de bases: del 16 de septiembre al 3 de octubre de 2024.',
                'descripcionProcedimiento': 'Modernización y Ampliación del C.R. Pozuelos - El Palmar; Tramo del Km 0+000 al 12+209, Subtramo: del Km 6+770 al Km 12+209.; ubicada en la localidad de El Palmar, Municipio de Santiago de Anaya, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }18/N138/N138.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }18/N138/JAN138.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }18/N138/APN138.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }18/N138/FAN138.pdf`,
                    },
                ],
            },
            // Licitación N137
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N137-2024.',
                'vigencia': 'Vigencia de venta de bases: del 16 de septiembre al 3 de octubre de 2024.',
                'descripcionProcedimiento': 'Pavimentación hidráulica de calle Sin Nombre del Km 1+239.5 al 1+850.90 en Mesa del Huizache, municipio de La Misión.; ubicada en la localidad de Mesa del Huizache, Municipio de La Misión, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }18/N137/N137.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }18/N137/JAN137.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }18/N137/APN137.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }18/N137/FAN137.pdf`,
                    },
                ],
            },
            // Licitación N136
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N136-2024.',
                'vigencia': 'Vigencia de venta de bases: del 16 de septiembre al 3 de octubre de 2024.',
                'descripcionProcedimiento': 'Construcción de pavimento hidráulico en Calle San Mateo, Barrio Carboneras, Mineral de la Reforma.; ubicada en la localidad de Carboneras, Municipio de Mineral de la Reforma, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }18/N136/N136.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }18/N136/JAN136.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }18/N136/APN136.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }18/N136/FAN136.pdf`,
                    },
                ],
            },
            // Licitación N135
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N135-2024.',
                'vigencia': 'Vigencia de venta de bases: del 16 de septiembre al 3 de octubre de 2024.',
                'descripcionProcedimiento': 'Construcción de muro de contención en E.C. (Lolotla - Atlapexco) - Santa Teresa, municipio de Yahualica.; ubicada en la localidad de Santa Teresa, Municipio de Yahualica, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }18/N135/N135.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }18/N135/JAN135.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }18/N135/APN135.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }18/N135/FAN135.pdf`,
                    },
                ],
            },
            // Licitación N134
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N134-2024.',
                'vigencia': 'Vigencia de venta de bases: del 16 de septiembre al 2 de octubre de 2024.',
                'descripcionProcedimiento': 'Pavimentación hidráulica y construcción de muro de contención en el C.R. Huilotitla I - Pilchatipa, municipio de Huazalingo.; ubicada en la localidad de Huilotitla I, Municipio de Huazalingo, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }18/N134/N134.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }18/N134/JAN134.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }18/N134/APN134.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }18/N134/FAN134.pdf`,
                    },
                ],
            },
            // Licitación N133
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N133-2024.',
                'vigencia': 'Vigencia de venta de bases: del 16 de septiembre al 2 de octubre de 2024.',
                'descripcionProcedimiento': 'Construcción de pavimentación hidráulica del C.R. Macangui - Cerro Prieto, municipio de La Misión.; ubicada en la localidad de Macanguí, Municipio de La Misión, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }18/N133/N133.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }18/N133/JAN133.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }18/N133/APN133.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }18/N133/FAN133.pdf`,
                    },
                ],
            },
            // Licitación N132
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N132-2024.',
                'vigencia': 'Vigencia de venta de bases: del 16 de septiembre al 2 de octubre de 2024.',
                'descripcionProcedimiento': 'Acondicionamiento de muros gaviones en la Secretaría de Seguridad Pública, en el municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }18/N132/N132.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }18/N132/JAN132.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }18/N132/APN132.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }18/N132/FAN132.pdf`,
                    },
                ],
            },
            // Licitación N131
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N131-2024.',
                'vigencia': 'Vigencia de venta de bases: del 16 de septiembre al 2 de octubre de 2024.',
                'descripcionProcedimiento': 'Construcción de cunetas y obras de drenaje para protección del acceso a Malayerba, municipio de Apan.; ubicada en la localidad de Malayerba, Municipio de Apan, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }18/N131/N131.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }18/N131/JAN131.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }18/N131/APN131.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }18/N131/FAN131.pdf`,
                    },
                ],
            },
            // Licitación N130
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N130-2024.',
                'vigencia': 'Vigencia de venta de bases: del 16 de septiembre al 2 de octubre de 2024.',
                'descripcionProcedimiento': 'Rehabilitación de pavimento libramiento Tlahuelilpan.; ubicada en la localidad y Municipio de Tlahuelilpan, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }18/N130/N130.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }18/N130/JAN130.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }18/N130/APN130.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }18/N130/FAN130.pdf`,
                    },
                ],
            },
            // Licitación N129
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N129-2024.',
                'vigencia': 'Vigencia de venta de bases: del 16 de septiembre al 2 de octubre de 2024.',
                'descripcionProcedimiento': 'Rehabilitación y mejoramiento de la imagen urbana sobre el Boulevard Felipe Ángeles zona del hospital IMSS en el municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }18/N129/N129.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }18/N129/JAN129.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }18/N129/APN129.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }18/N129/FAN129.pdf`,
                    },
                ],
            },
            // Licitación N128
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N128-2024.',
                'vigencia': 'Vigencia de venta de bases: del 16 de septiembre al 2 de octubre de 2024.',
                'descripcionProcedimiento': 'Pavimentación asfáltica de carretera Singuilucan - Francisco I Madero, tramo: La Conchita - La Gloria, en el municipio de Singuilucan.; ubicada en Varias localidades del Municipio de Singuilucan, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }18/N128/N128.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }18/N128/JAN128.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }18/N128/APN128.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }18/N128/FAN128.pdf`,
                    },
                ],
            },
            // Licitación N127
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N127-2024.',
                'vigencia': 'Vigencia de venta de bases: del 16 de septiembre al 2 de octubre de 2024.',
                'descripcionProcedimiento': 'Construcción de pavimentación asfáltica en camino Sin Nombre, localidad El Olvera, municipio de San Salvador.; ubicada en la localidad de El Olvera, Municipio de San Salvador, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }18/N127/N127.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }18/N127/JAN127.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }18/N127/APN127.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }18/N127/FAN127.pdf`,
                    },
                ],
            },
            // Licitación N126
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N126-2024.',
                'vigencia': 'Vigencia de venta de bases: del 16 de septiembre al 2 de octubre de 2024.',
                'descripcionProcedimiento': 'Pavimentación con concreto hidráulico calle Sin Nombre en la localidad de Cuatecomaco, en el municipio de Jaltocán.; ubicada en la localidad de Cuatecomaco, Municipio de Jaltocán, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }18/N126/N126.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }18/N126/JAN126.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }18/N126/APN126.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }18/N126/FAN126.pdf`,
                    },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 017
        'numConvocatoria': 'Convocatoria No. 017/2024.',
        'idConvocatoria': 'Convocatoria17',
        'procedimientos': [
            // Licitación N125
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N125-2024.',
                'vigencia': 'Vigencia de venta de bases: del 2 al 17 de septiembre de 2024',
                'descripcionProcedimiento': 'Construcción de pavimento de concreto hidráulico en acceso a cabecera de Tlahuiltepa.; ubicada en la localidad y Municipio de Tlahuiltepa, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }17/N125/N125.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }17/N125/JAN125.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }17/N125/APN125.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }17/N125/FAN125.pdf`,
                    },
                ],
            },
            // Licitación N124
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N124-2024.',
                'vigencia': 'Vigencia de venta de bases: del 2 al 17 de septiembre de 2024.',
                'descripcionProcedimiento': 'Reconstrucción de la C.E. Juandhó - Ulapa- Tetepango, en el municipio de Tetepango.; ubicada en la localidad de La Hormiga, Municipio de Tetepango, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }17/N124/N124.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }17/N124/JAN124.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }17/N124/APN124.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }17/N124/FAN124.pdf`,
                    },
                ],
            },
            // Licitación N123
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N123-2024.',
                'vigencia': 'Vigencia de venta de bases: del 2 al 17 de septiembre de 2024.',
                'descripcionProcedimiento': 'Terminación de construcción del Libramiento El Peral - Hacienda Hueyapan y ampliación de Puente Vehicular "Puente Blanco" a dos carriles, en el municipio de Huasca de Ocampo.; ubicada en la localidad de San Juan Hueyapan, Municipio de Huasca de Ocampo, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }17/N123/N123.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }17/N123/JAN123.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }17/N123/APN123.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }17/N123/FAN123.pdf`,
                    },
                ],
            },
            // Licitación N122
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N122-2024.',
                'vigencia': 'Vigencia de venta de bases: del 2 al 17 de septiembre de 2024.',
                'descripcionProcedimiento': 'Reconstrucción de la vialidad de acceso al CRIT y Casa de la Niña, en el municipio de Pachuca.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }17/N122/N122.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }17/N122/JAN122.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }17/N122/APN122.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }17/N122/FAN122.pdf`,
                    },
                ],
            },
            // Licitación N121
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N121-2024.',
                'vigencia': 'Vigencia de venta de bases: del 2 al 17 de septiembre de 2024.',
                'descripcionProcedimiento': 'Construcción de calle en la localidad de Tepojaco, en el municipio de Tizayuca.; ubicada en la localidad de Tepojaco, Municipio de Tizayuca, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }17/N121/N121.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }17/N121/JAN121.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }17/N121/APN121.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }17/N121/FAN121.pdf`,
                    },
                ],
            },
            // Licitación N120
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N120-2024.',
                'vigencia': 'Vigencia de venta de bases: del 2 al 17 de septiembre de 2024.',
                'descripcionProcedimiento': 'Empedrado ahogado en camino de interconexión Bomanxotha - La Mesilla, en el municipio de Tecozautla.; ubicada en la localidad de Bomanxotha, Municipio de Tecozautla, Estado de Hidalgo.(Segundo Procedimiento)',
                'urlAnexos': `${ ligabase }17/N120/N120.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }17/N120/JAN120.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }17/N120/APN120.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }17/N120/FAN120.pdf`,
                    },
                ],
            },
            // Licitación N119
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N119-2024.',
                'vigencia': 'Vigencia de venta de bases: del 2 al 17 de septiembre de 2024.',
                'descripcionProcedimiento': 'Construcción del Circuito Ciclopista Santa Clara - entronque Carretera Federal, en el municipio de Emiliano Zapata.; ubicada en la localidad de Santa Clara, Municipio de Emiliano Zapata, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }17/N119/N119.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }17/N119/JAN119.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }17/N119/APN119.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }17/N119/FAN119.pdf`,
                    },
                ],
            },
            // Licitación N118
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N118-2024.',
                'vigencia': 'Vigencia de venta de bases: del 2 al 17 de septiembre de 2024.',
                'descripcionProcedimiento': 'Construcción del Corredor Artesanal en la localidad de Chilcuautla, municipio de Chilcuautla; ubicada en la localidad y Municipio de Chilcuautla, Estado de Hidalgo.(Segundo Procedimiento)',
                'urlAnexos': `${ ligabase }17/N118/N118.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }17/N118/JAN118.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }17/N118/APN118.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }17/N118/FAN118.pdf`,
                    },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 016
        'numConvocatoria': 'Convocatoria No. 016/2024.',
        'idConvocatoria': 'Convocatoria16',
        'procedimientos': [
            // Licitación N117
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N117-2024.',
                'vigencia': 'Vigencia de venta de bases: del 26 al 30 de agosto de 2024',
                'descripcionProcedimiento': 'Construcción de estacionamiento para las oficinas centrales de la Secretaría de Contraloría; ubicada en la localidad de San Juan Tilcuautla, Municipio de San Agustín Tlaxiaca, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }16/N117/N117.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }16/N117/JAN117.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }16/N117/APN117.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }16/N117/FAN117.pdf`,
                    },
                ],
            },
            // Licitación N116
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N116-2024.',
                'vigencia': 'Vigencia de venta de bases: del 26 al 30 de agosto de 2024.',
                'descripcionProcedimiento': 'Construcción de las oficinas centrales de la Secretaría de Contraloría, ubicada en la localidad de San Juan Tilcuautla, Municipio de San Agustín Tlaxiaca, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }16/N116/N116.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }16/N116/JAN116.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }16/N116/APN116.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }16/N116/FAN116.pdf`,
                    },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 015
        'numConvocatoria': 'Convocatoria No. 015/2024.',
        'idConvocatoria': 'Convocatoria15',
        'procedimientos': [
            // Licitación N115
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N115-2024.',
                'vigencia': 'Vigencia de venta de bases: del 26 de agosto al 9 de septiembre de 2024',
                'descripcionProcedimiento': 'Rehabilitación punto de venta Hidarte; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }15/N115/N115.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }15/N115/JAN115.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }15/N115/APN115.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }15/N115/FAN115.pdf`,
                    },
                    {
                        'resultado': 'Anexo modificatorio',
                        'urlresultado': `${ ligabase }15/N115/AMDFAN115.pdf`,
                    },
                ],
            },
            // Licitación N114
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N114-2024.',
                'vigencia': 'Vigencia de venta de bases: del 26 de agosto al 9 de septiembre de 2024.',
                'descripcionProcedimiento': 'Reconstrucción de carpeta asfáltica en Boulevard Centenario (Antigua Carretera La Paz) Dos Cuerpos, Pachuca de Soto, Hgo.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }15/N114/N114.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }15/N114/JAN114.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }15/N114/APN114.pdf`,
                    },
                    {
                        'resultado': 'Anexo modificatorio',
                        'urlresultado': `${ ligabase }15/N114/AMDAPN114.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }15/N114/FAN114.pdf`,
                    },
                ],
            },
            // Licitación N113
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N113-2024.',
                'vigencia': 'Vigencia de venta de bases: del 26 de agosto al 9 de septiembre de 2024.',
                'descripcionProcedimiento': 'Reconstrucción de pavimento en el Boulevard Nuevo Hidalgo tramo Distribuidor Colonias - Distribuidor Vial Municipios Unidos - Puente el Venado (cuerpo izquierdo), en el municipio de Mineral de la Reforma.; ubicada en Varias localidades del Municipio de Mineral de la Reforma, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }15/N113/N113.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }15/N113/JAN113.pdf`,
                    },
                    {
                        'resultado': 'Aclaraciones (2)',
                        'urlresultado': `${ ligabase }15/N113/JAN113-2.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }15/N113/APN113.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }15/N113/FAN113.pdf`,
                    },
                    {
                        'resultado': 'Anexo modificatorio',
                        'urlresultado': `${ ligabase }15/N113/AMDFAN113.pdf`,
                    },
                ],
            },
            // Licitación N112
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N112-2024.',
                'vigencia': 'Vigencia de venta de bases: del 26 de agosto al 9 de septiembre de 2024.',
                'descripcionProcedimiento': 'Pavimentación hidráulica de calle Industrial Metal Mecánica, en el municipio de Actopan.; ubicada en la localidad y Municipio de Actopan, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }15/N112/N112.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }15/N112/JAN112.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }15/N112/APN112.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }15/N112/FAN112.pdf`,
                    },
                ],
            },
            // Licitación N111
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N111-2024.',
                'vigencia': 'Vigencia de venta de bases: del 26 de agosto al 9 de septiembre de 2024.',
                'descripcionProcedimiento': 'Continuidad de perforación de pozo profundo para extracción de agua potable, en la localidad de Los Filtros, municipio de Francisco I. Madero.; ubicada en la localidad de Los Filtros, Municipio de Francisco I. Madero, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }15/N111/N111.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }15/N111/JAN111.pdf`,
                    },
                    {
                        'resultado': 'Anexo modificatorio',
                        'urlresultado': `${ ligabase }15/N111/AMDJAN111.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }15/N111/APN111.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }15/N111/FAN111.pdf`,
                    },
                ],
            },
            // Licitación N110
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N110-2024.',
                'vigencia': 'Vigencia de venta de bases: del 26 de agosto al 9 de septiembre de 2024.',
                'descripcionProcedimiento': 'Construcción de vía escénica y plaza de los comensales del Parque David Ben Gurión, en Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }15/N110/N110.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }15/N110/JAN110.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }15/N110/APN110.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }15/N110/FAN110.pdf`,
                    },
                ],
            },
            // Licitación N109
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N109-2024.',
                'vigencia': 'Vigencia de venta de bases: del 26 de agosto al 9 de septiembre de 2024.',
                'descripcionProcedimiento': 'Terminación de construcción del canal de interconexión en la Presa el Yathé, Alfajayucan.; ubicada en la localidad y Municipio de Alfajayucan, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }15/N109/N109.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }15/N109/JAN109.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }15/N109/APN109.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }15/N109/FAN109.pdf`,
                    },
                ],
            },
            // Licitación N108
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N108-2024.',
                'vigencia': 'Vigencia de venta de bases: del 26 de agosto al 9 de septiembre de 2024.',
                'descripcionProcedimiento': 'Alumbrado de canchas deportivas y pista de manejo del Instituto de Formación Profesional.; ubicada en la localidad de San José Palma Gorda, Municipio de Mineral de la Reforma, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }15/N108/N108.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }15/N108/JAN108.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }15/N108/APN108.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }15/N108/FAN108.pdf`,
                    },
                ],
            },
            // Licitación N107
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N107-2024.',
                'vigencia': 'Vigencia de venta de bases: del 26 de agosto al 6 de septiembre de 2024.',
                'descripcionProcedimiento': 'Rehabilitación y mejoramiento de la imagen urbana en el acceso, Boulevard Everardo Márquez, municipio de Mineral de la Reforma.; ubicada en Varias localidades del Municipio de Mineral de la Reforma, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }15/N107/N107.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }15/N107/JAN107.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }15/N107/APN107.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }15/N107/FAN107.pdf`,
                    },
                ],
            },
            // Licitación N106
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N106-2024.',
                'vigencia': 'Vigencia de venta de bases: del 26 de agosto al 6 de septiembre de 2024.',
                'descripcionProcedimiento': 'Pavimentación de camino Juandho - Cañada, en el municipio de Mixquiahuala de Juárez.; ubicada en la localidad de Cañada, Municipio de Mixquiahuala de Juárez, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }15/N106/N106.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }15/N106/JAN106.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }15/N106/APN106.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }15/N106/FAN106.pdf`,
                    },
                ],
            },
            // Licitación N105
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N105-2024.',
                'vigencia': 'Vigencia de venta de bases: del 26 de agosto al 6 de septiembre de 2024.',
                'descripcionProcedimiento': 'Construcción de bardeado perimetral del Instituto de Formación Profesional.; ubicada en la localidad de San José Palma Gorda, Municipio de Mineral de la Reforma, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }15/N105/N105.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }15/N105/JAN105.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }15/N105/APN105.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }15/N105/FAN105.pdf`,
                    },
                ],
            },
            // Licitación N104
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N104-2024.',
                'vigencia': 'Vigencia de venta de bases: del 26 de agosto al 6 de septiembre de 2024.',
                'descripcionProcedimiento': 'Reparación de tubería de drenaje, Blvd. Río de las Avenidas, en el municipio de Pachuca.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }15/N104/N104.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }15/N104/JAN104.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }15/N104/APN104.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }15/N104/FAN104.pdf`,
                    },
                ],
            },
            // Licitación N103
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N103-2024.',
                'vigencia': 'Vigencia de venta de bases: del 26 de agosto al 6 de septiembre de 2024.',
                'descripcionProcedimiento': 'Reconstrucción de la C.E. Tuzanapa - C.E. El Enzuelado Carpinteros, San Agustín Metzquititlán.; ubicada en la localidad de Tuzanapa, Municipio de San Agustín Metzquititlán, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }15/N103/N103.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }15/N103/JAN103.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }15/N103/APN103.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }15/N103/FAN103.pdf`,
                    },
                ],
            },
            // Licitación N102
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N102-2024.',
                'vigencia': 'Vigencia de venta de bases: del 26 de agosto al 6 de septiembre de 2024.',
                'descripcionProcedimiento': 'Pavimentación de la calle Alcatraz, Colonia Estación Tepa, en el municipio de Zempoala.; ubicada en Varias localidades del Municipio de Zempoala, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }15/N102/N102.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }15/N102/JAN102.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }15/N102/APN102.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }15/N102/FAN102.pdf`,
                    },
                ],
            },
            // Licitación N101
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N101-2024.',
                'vigencia': 'Vigencia de venta de bases: del 26 de agosto al 6 de septiembre de 2024.',
                'descripcionProcedimiento': 'Construcción de pavimento hidráulico en calle Independencia, en el municipio de Acatlán.; ubicada en la localidad y Municipio de Acatlán, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }15/N101/N101.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }15/N101/JAN101.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }15/N101/APN101.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }15/N101/FAN101.pdf`,
                    },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 014
        'numConvocatoria': 'Convocatoria No. 014/2024.',
        'idConvocatoria': 'Convocatoria14',
        'procedimientos': [
            // Licitación N100
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N100-2024.',
                'vigencia': 'Vigencia de venta de bases: del 19 de agosto al 2 de septiembre de 2024',
                'descripcionProcedimiento': 'Señaléticas y adecuaciones viales.; de Cobertura Estatal.',
                'urlAnexos': `${ ligabase }14/N100/N100.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }14/N100/JAN100.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }14/N100/APN100.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }14/N100/FAN100.pdf`,
                    },
                ],
            },
            // Licitación N99
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N99-2024.',
                'vigencia': 'Vigencia de venta de bases: del 19 de agosto al 2 de septiembre de 2024.',
                'descripcionProcedimiento': 'Pavimentación asfáltica de 2 tramos de la C.M. Chilcuautla - Alfajayucan, en el municipio de Alfajayucan.; ubicada en la localidad de Cerro Azúl, Municipio de Alfajayucan, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }14/N99/N99.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }14/N99/JAN99.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }14/N99/APN99.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }14/N99/FAN99.pdf`,
                    },
                ],
            },
            // Licitación N98
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N98-2024.',
                'vigencia': 'Vigencia de venta de bases: del 19 de agosto al 2 de septiembre de 2024.',
                'descripcionProcedimiento': 'Pavimentación con concreto hidráulico Blvd. Minero del Km. 0+000 Al Km. 4+200 (Dos Cuerpos), en el municipio de Pachuca.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }14/N98/N98.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }14/N98/JAN98.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }14/N98/APN98.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }14/N98/FAN98.pdf`,
                    },
                ],
            },
            // Licitación N97
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N97-2024.',
                'vigencia': 'Vigencia de venta de bases: del 19 de agosto al 2 de septiembre de 2024.',
                'descripcionProcedimiento': 'Terminación de la pavimentación del acceso al IMSS, en el municipio de Tulancingo de Bravo.; ubicada en la localidad de Santa María el Chico, Municipio de Tulancingo de Bravo, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }14/N97/N97.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }14/N97/JAN97.pdf`,
                    },
                    {
                        'resultado': 'Anexo modificatorio',
                        'urlresultado': `${ ligabase }14/N97/AMDJAN97.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }14/N97/APN97.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }14/N97/FAN97.pdf`,
                    },
                ],
            },
            // Licitación N96
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N96-2024.',
                'vigencia': 'Vigencia de venta de bases: del 19 de agosto al 2 de septiembre de 2024.',
                'descripcionProcedimiento': 'Construcción de pavimentación asfáltica en calle Sinaloa en la localidad de Dengantzhá (Segunda etapa), en el municipio de Francisco I. Madero.; ubicada en la localidad de Dengantzha, Municipio de Francisco I. Madero, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }14/N96/N96.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }14/N96/JAN96.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }14/N96/APN96.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }14/N96/FAN96.pdf`,
                    },
                ],
            },
            // Licitación N95
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N95-2024.',
                'vigencia': 'Vigencia de venta de bases: del 19 de agosto al 2 de septiembre de 2024.',
                'descripcionProcedimiento': 'Pavimentación asfáltica del camino rural de San Buenaventura - Cantera de Villagrán, en el municipio de Tepeji del Río.; ubicada en la localidad de Cantera de Villagrán, Municipio de Tepeji del Río de Ocampo, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }14/N95/N95.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }14/N95/JAN95.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }14/N95/APN95.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }14/N95/FAN95.pdf`,
                    },
                ],
            },
            // Licitación N94
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N94-2024.',
                'vigencia': 'Vigencia de venta de bases: del 19 de agosto al 2 de septiembre de 2024.',
                'descripcionProcedimiento': 'Alumbrado público en zona metropolitana.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo. (Segundo procedimiento).',
                'urlAnexos': `${ ligabase }14/N94/N94.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }14/N94/JAN94.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }14/N94/APN94.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }14/N94/FAN94.pdf`,
                    },
                ],
            },
            // Licitación N93
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N93-2024.',
                'vigencia': 'Vigencia de venta de bases: del 19 de agosto al 2 de septiembre de 2024.',
                'descripcionProcedimiento': 'Reconstrucción de C.E. Atotonilco de Tula - El Cardonal, municipio de Atotonilco de Tula.; ubicada en Varias localidades del Municipio de Atotonilco de Tula, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }14/N93/N93.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }14/N93/JAN93.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }14/N93/APN93.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }14/N93/FAN93.pdf`,
                    },
                ],
            },
            // Licitación N92
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N92-2024.',
                'vigencia': 'Vigencia de venta de bases: del 19 de agosto al 2 de septiembre de 2024.',
                'descripcionProcedimiento': 'Construcción de cunetas en vialidad de acceso a Nicolás Flores, en el municipio de Nicolás Flores.; ubicada en Varias localidades del Municipio de Nicolás Flores, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }14/N92/N92.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }14/N92/JAN92.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }14/N92/APN92.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }14/N92/FAN92.pdf`,
                    },
                ],
            },
            // Licitación N91
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N91-2024.',
                'vigencia': 'Vigencia de venta de bases: del 19 al 30 de agosto de 2024.',
                'descripcionProcedimiento': 'Pavimentación asfáltica del tramo Francisco Sarabia - entronque Tlacatepa, en la localidad de Francisco Sarabia del municipio de Tepeapulco.; ubicada en la localidad de Francisco Sarabia (Corralillos), Municipio de Tepeapulco, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }14/N91/N91.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }14/N91/JAN91.pdf`,
                    },
                    {
                        'resultado': 'Anexo modificatorio',
                        'urlresultado': `${ ligabase }14/N91/AMDJAN91.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }14/N91/APN91.pdf`,
                    },
                    {
                        'resultado': 'Anexo modificatorio',
                        'urlresultado': `${ ligabase }14/N91/AMDAPN91.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }14/N91/FAN91.pdf`,
                    },
                ],
            },
            // Licitación N90
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N90-2024.',
                'vigencia': 'Vigencia de venta de bases: del 19 al 30 de agosto de 2024.',
                'descripcionProcedimiento': 'Pavimentación con concreto hidráulico Blvd. Everardo Márquez del Km. 0+000 al 5+800 de Puente Tuzos - Rio de las Avenidas (dos cuerpos).; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }14/N90/N90.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }14/N90/JAN90.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }14/N90/APN90.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }14/N90/FAN90.pdf`,
                    },
                ],
            },
            // Licitación N89
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N89-2024.',
                'vigencia': 'Vigencia de venta de bases: del 19 al 30 de agosto de 2024.',
                'descripcionProcedimiento': 'Reconstrucción de pavimentación asfáltica de la C.E. Saucillo - Nopala (segunda etapa), en el municipio de Nopala de Villagran.; ubicada en la localidad de San Sebastián Tenochtitlán, Municipio de Nopala de Villagrán, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }14/N89/N89.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }14/N89/JAN89.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }14/N89/APN89.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }14/N89/FAN89.pdf`,
                    },
                ],
            },
            // Licitación N88
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N88-2024.',
                'vigencia': 'Vigencia de venta de bases: del 19 al 30 de agosto de 2024.',
                'descripcionProcedimiento': 'Construcción del Corredor Artesanal en la localidad de Pañhe, municipio de Tecozautla; ubicada en la localidad de Pañhé, Municipio de Tecozautla, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }14/N88/N88.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }14/N88/JAN88.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }14/N88/APN88.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }14/N88/FAN88.pdf`,
                    },
                ],
            },
            // Licitación N87
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N87-2024.',
                'vigencia': 'Vigencia de venta de bases: del 19 al 30 de agosto de 2024.',
                'descripcionProcedimiento': 'Construcción del Corredor Artesanal en la localidad de Pozuelos, municipio de el Cardonal; ubicada en la localidad de Pozuelos, Municipio de Cardonal, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }14/N87/N87.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }14/N87/JAN87.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }14/N87/APN87.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }14/N87/FAN87.pdf`,
                    },
                ],
            },
            // Licitación N86
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N86-2024.',
                'vigencia': 'Vigencia de venta de bases: del 19 al 30 de agosto de 2024.',
                'descripcionProcedimiento': 'Trabajos preliminares para la construcción de las nuevas oficinas de Gobierno en Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }14/N86/N86.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }14/N86/JAN86.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }14/N86/APN86.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }14/N86/FAN86.pdf`,
                    },
                ],
            },
            // Licitación N85
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N85-2024.',
                'vigencia': 'Vigencia de venta de bases: del 19 al 30 de agosto de 2024.',
                'descripcionProcedimiento': 'Construcción de espacios recreativos y culturales del Parque David Ben Gurión, en Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }14/N85/N85.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }14/N85/JAN85.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }14/N85/APN85.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }14/N85/FAN85.pdf`,
                    },
                ],
            },
            // Licitación N84
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N84-2024.',
                'vigencia': 'Vigencia de venta de bases: del 19 al 30 de agosto de 2024.',
                'descripcionProcedimiento': 'Construcción del colector pluvial Real de la Plata, en el municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }14/N84/N84.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }14/N84/JAN84.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }14/N84/APN84.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }14/N84/FAN84.pdf`,
                    },
                ],
            },
            // Licitación N83
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N83-2024.',
                'vigencia': 'Vigencia de venta de bases: del 19 al 30 de agosto de 2024.',
                'descripcionProcedimiento': 'Construcción del dren pluvial Norponiente, en el municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }14/N83/N83.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }14/N83/JAN83.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }14/N83/APN83.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }14/N83/FAN83.pdf`,
                    },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 013
        'numConvocatoria': 'Convocatoria No. 013/2024.',
        'idConvocatoria': 'Convocatoria13',
        'procedimientos': [
            // Licitación N82
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N82-2024.',
                'vigencia': 'Vigencia de venta de bases: del 5 al 19 de agosto de 2024',
                'descripcionProcedimiento': 'Construcción de pavimento hidráulico en caminos municipales de Atopixco, en el municipio de Zacualtipán de Ángeles.; ubicada en la localidad de Atopixco, Municipio de Zacualtipán de Ángeles, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }13/N82/N82.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }13/N82/JAN82.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }13/N82/APN82.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }13/N82/FAN82.pdf`,
                    },
                ],
            },
            // Licitación N81
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N81-2024.',
                'vigencia': 'Vigencia de venta de bases: del 5 al 19 de agosto de 2024.',
                'descripcionProcedimiento': 'Construcción de pavimentación asfáltica de Fray Francisco al Rincón, en el municipio de el Arenal; ubicada en la localidad de Fray Francisco, Municipio de El Arenal, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }13/N81/N81.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }13/N81/JAN81.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }13/N81/APN81.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }13/N81/FAN81.pdf`,
                    },
                ],
            },
            // Licitación N80
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N80-2024.',
                'vigencia': 'Vigencia de venta de bases: del 5 al 19 de agosto de 2024.',
                'descripcionProcedimiento': 'Reconstrucción del camino Gandhó - al crucero (Carretera Tecozautla - Huichapan), en el municipio de Tecozautla.; ubicada en la localidad de Gandho, Municipio de Tecozautla, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }13/N80/N80.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }13/N80/JAN80.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }13/N80/APN80.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }13/N80/FAN80.pdf`,
                    },
                ],
            },
            // Licitación N79
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N79-2024.',
                'vigencia': 'Vigencia de venta de bases: del 5 al 19 de agosto de 2024.',
                'descripcionProcedimiento': 'Pavimentación hidráulica del C.R. Tzincoatlán - E.C. (Santo Domingo - Tlahuelompa), en el municipio de Zacualtipán de Ángeles.; ubicada en la localidad de Tzincoatlán, Municipio de Zacualtipán de Ángeles, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }13/N79/N79.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }13/N79/JAN79.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }13/N79/APN79.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }13/N79/FAN79.pdf`,
                    },
                ],
            },
            // Licitación N78
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N78-2024.',
                'vigencia': 'Vigencia de venta de bases: del 5 al 19 de agosto de 2024.',
                'descripcionProcedimiento': 'Construcción del dren pluvial San Antonio - Rio de las Avenidas, en los municipios de Pachuca de Soto y Mineral de la Reforma.; de Cobertura Estatal.',
                'urlAnexos': `${ ligabase }13/N78/N78.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }13/N78/JAN78.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }13/N78/APN78.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }13/N78/FAN78.pdf`,
                    },
                ],
            },
            // Licitación N77
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N77-2024.',
                'vigencia': 'Vigencia de venta de bases: del 5 al 16 de agosto de 2024.',
                'descripcionProcedimiento': 'Actualización de Estudio y Proyecto de la Carretera Eje Transversal Actopan – Atotonilco el Grande; de Cobertura Estatal.',
                'urlAnexos': `${ ligabase }13/N77/N77.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }13/N77/JAN77.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }13/N77/APN77.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }13/N77/FAN77.pdf`,
                    },
                ],
            },
            // Licitación N76
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N76-2024.',
                'vigencia': 'Vigencia de venta de bases: del 5 al 16 de agosto de 2024.',
                'descripcionProcedimiento': 'Estudio y proyecto para el encauzamiento y saneamiento del Río Chinguiñoso, en el municipio de Huejutla de Reyes; ubicado en la localidad y Municipio de Huejutla de Reyes, Estado de Hidalgo. (Segundo procedimiento)',
                'urlAnexos': `${ ligabase }13/N76/N76.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }13/N76/JAN76.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }13/N76/APN76.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }13/N76/FAN76.pdf`,
                    },
                ],
            },
            // Licitación N75
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N75-2024.',
                'vigencia': 'Vigencia de venta de bases: del 5 al 16 de agosto de 2024.',
                'descripcionProcedimiento': 'Construcción de sanitario con biodigestor en el municipio de Huejutla de Reyes; ubicada en Varias localidades del Municipio de Huejutla de Reyes, Estado de Hidalgo. (Tercer procedimiento)',
                'urlAnexos': `${ ligabase }13/N75/N75.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }13/N75/JAN75.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }13/N75/APN75.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }13/N75/FAN75.pdf`,
                    },
                ],
            },
            // Licitación N74
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N74-2024.',
                'vigencia': 'Vigencia de venta de bases: del 5 al 16 de agosto de 2024.',
                'descripcionProcedimiento': 'Pavimentación de concreto hidráulico en calle de acceso a la comunidad de La Escondida, municipio de Chapulhuacán.; ubicada en la localidad de La Escondida, Municipio de Chapulhuacán, Estado de Hidalgo. (Segundo procedimiento)',
                'urlAnexos': `${ ligabase }13/N74/N74.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }13/N74/JAN74.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }13/N74/APN74.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }13/N74/FAN74.pdf`,
                    },
                ],
            },
            // Licitación N73
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N73-2024.',
                'vigencia': 'Vigencia de venta de bases: del 5 al 16 de agosto de 2024.',
                'descripcionProcedimiento': 'Pavimentación asfáltica de Av. de La Plata y Av. de las Torres, en la colonia El Palmar, municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo. (Segundo procedimiento)',
                'urlAnexos': `${ ligabase }13/N73/N73.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }13/N73/JAN73.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }13/N73/APN73.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }13/N73/FAN73.pdf`,
                    },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 012
        'numConvocatoria': 'Convocatoria No. 012/2024.',
        'idConvocatoria': 'Convocatoria12',
        'procedimientos': [
            // Licitación N72
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N72-2024.',
                'vigencia': 'Vigencia de venta de bases: del 29 de julio al 2 de agosto de 2024',
                'descripcionProcedimiento': 'Laboratorio de Control de Calidad y Análisis de Materiales (Segunda Etapa); ubicado en la localidad de San Juan Tilcuautla, Municipio de San Agustín Tlaxiaca, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }12/N72/N72.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }12/N72/JAN72.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }12/N72/APN72.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }12/N72/FAN72.pdf`,
                    },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 011
        'numConvocatoria': 'Convocatoria No. 011/2024.',
        'idConvocatoria': 'Convocatoria11',
        'procedimientos': [
            // Licitación N71
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N71-2024.',
                'vigencia': 'Vigencia de venta de bases: del 22 de julio al 5 de agosto de 2024',
                'descripcionProcedimiento': 'Construcción de pavimento hidráulico en calle La Piaña, Santa María Amajac; en el municipio de Atotonilco el  Grande.; ubicada en la localidad de Santa María Amajac, Municipio de Atotonilco el Grande, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }11/N71/N71.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }11/N71/JAN71.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }11/N71/APN71.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }11/N71/FAN71.pdf`,
                    },
                ],
            },
            // Licitación N70
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N70-2024.',
                'vigencia': 'Vigencia de venta de bases: del 22 de julio al 5 de agosto de 2024.',
                'descripcionProcedimiento': 'Continuación de la construcción de andador en San Salvador en la localidad Caxuxi, Camino Caxuxi - San Salvador.; ubicada en la localidad de Caxuxi, Municipio de San Salvador, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }11/N70/N70.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }11/N70/JAN70.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }11/N70/APN70.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }11/N70/FAN70.pdf`,
                    },
                ],
            },
            // Licitación N69
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N69-2024.',
                'vigencia': 'Vigencia de venta de bases: del 22 de julio al 5 de agosto de 2024.',
                'descripcionProcedimiento': 'Pavimentación de concreto hidráulico en calle Teodora Cerón, Barrio Huizache, municipio de San Agustín Tlaxiaca.; ubicada en la localidad de El Huizache, Municipio de San Agustín Tlaxiaca, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }11/N69/N69.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }11/N69/JAN69.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }11/N69/APN69.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }11/N69/FAN69.pdf`,
                    },
                ],
            },
            // Licitación N68
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N68-2024.',
                'vigencia': 'Vigencia de venta de bases: del 22 de julio al 5 de agosto de 2024.',
                'descripcionProcedimiento': 'Empedrado ahogado en camino de interconexión Bomanxotha - La Mesilla, en el municipio de Tecozautla.; ubicada en la localidad de Bomanxotha, Municipio de Tecozautla, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }11/N68/N68.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }11/N68/JAN68.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }11/N68/APN68.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }11/N68/FAN68.pdf`,
                    },
                ],
            },
            // Licitación N67
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N67-2024.',
                'vigencia': 'Vigencia de venta de bases: del 22 de julio al 5 de agosto de 2024.',
                'descripcionProcedimiento': 'Construcción del Corredor Artesanal en la localidad de González Ortega, municipio de Santiago de Anaya; ubicada en la localidad de González Ortega, Municipio de Santiago de Anaya, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }11/N67/N67.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }11/N67/JAN67.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }11/N67/APN67.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }11/N67/FAN67.pdf`,
                    },
                ],
            },
            // Licitación N66
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N66-2024.',
                'vigencia': 'Vigencia de venta de bases: del 22 de julio al 2 de agosto de 2024.',
                'descripcionProcedimiento': 'Construcción del Corredor Artesanal en la localidad de Chilcuautla, municipio de Chilcuautla; ubicada en la localidad de Chilcua, Municipio de Chilcuautla, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }11/N66/N66.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }11/N66/JAN66.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }11/N66/APN66.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }11/N66/FAN66.pdf`,
                    },
                ],
            },
            // Licitación N65
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N65-2024.',
                'vigencia': 'Vigencia de venta de bases: del 22 de julio al 2 de agosto de 2024.',
                'descripcionProcedimiento': 'Construcción del Corredor Artesanal en la localidad de Rinconada Municipio de Tasquillo; ubicada en la localidad de Rinconada, Municipio de Tasquillo, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }11/N65/N65.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }11/N65/JAN65.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }11/N65/APN65.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }11/N65/FAN65.pdf`,
                    },
                ],
            },
            // Licitación N64
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N64-2024.',
                'vigencia': 'Vigencia de venta de bases: del 22 de julio al 2 de agosto de 2024.',
                'descripcionProcedimiento': 'Construcción de pavimentación asfáltica de la Carretera Rancho Viejo - Las Vigas, en el municipio de Almoloya.; ubicada en la localidad de Rancho Nuevo, Municipio de Almoloya, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }11/N64/N64.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }11/N64/JAN64.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }11/N64/APN64.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }11/N64/FAN64.pdf`,
                    },
                ],
            },
            // Licitación N63
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N63-2024.',
                'vigencia': 'Vigencia de venta de bases: del 22 de julio al 2 de agosto de 2024.',
                'descripcionProcedimiento': 'Construcción de pavimento asfáltico en calle Caxpojay, en el municipio de San Salvador.; ubicada en la localidad de Déxtho de Victoria, Municipio de San Salvador, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }11/N63/N63.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }11/N63/JAN63.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }11/N63/APN63.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }11/N63/FAN63.pdf`,
                    },
                ],
            },
            // Licitación N62
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N62-2024.',
                'vigencia': 'Vigencia de venta de bases: del 22 de julio al 2 de agosto de 2024.',
                'descripcionProcedimiento': 'Reconstrucción de la C.E. E.C.F. 45 Portezuelo - Palmillas a Tecozautla, en el municipio de Huichapan.; ubicada en Varias localidades del Municipio de Huichapan, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }11/N62/N62.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }11/N62/JAN62.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }11/N62/APN62.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }11/N62/FAN62.pdf`,
                    },
                ],
            },
            // Licitación N61
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N61-2024.',
                'vigencia': 'Vigencia de venta de bases: del 22 de julio al 2 de agosto de 2024.',
                'descripcionProcedimiento': 'Construcción de pavimentación asfáltica en calle Pedro María Anaya, en la localidad de La Palma, municipio de San Salvador.; ubicada en la localidad de La Palma, Municipio de San Salvador, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }11/N61/N61.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }11/N61/JAN61.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }11/N61/APN61.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }11/N61/FAN61.pdf`,
                    },
                ],
            },
            // Licitación N60
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N60-2024.',
                'vigencia': 'Vigencia de venta de bases: del 22 de julio al 2 de agosto de 2024.',
                'descripcionProcedimiento': 'Estudio y proyecto para el Distribuidor Vial Centenario de la Revolución, en el municipio de Pachuca de Soto; ubicado en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }11/N60/N60.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }11/N60/JAN60.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }11/N60/APN60.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }11/N60/FAN60.pdf`,
                    },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 010
        'numConvocatoria': 'Convocatoria No. 010/2024.',
        'idConvocatoria': 'Convocatoria10',
        'procedimientos': [
            // Licitación N59
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N59-2024.',
                'vigencia': 'Vigencia de venta de bases: del 8 al 22 de julio de 2024',
                'descripcionProcedimiento': 'Estudio y proyecto para mitigar los riesgos viales en el entorno hospitalario oriente de Pachuca de Soto; ubicado en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }10/N59/N59.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }10/N59/JAN59.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }10/N59/APN59.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }10/N59/FAN59.pdf`,
                    },
                ],
            },
            // Licitación N58
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N58-2024.',
                'vigencia': 'Vigencia de venta de bases: del 8 al 22 de julio de 2024.',
                'descripcionProcedimiento': 'Estudios y proyecto complementarios para estacionamiento y plancha de la Plaza Independencia, en el municipio de Pachuca de Soto; ubicado en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }10/N58/N58.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }10/N58/JAN58.pdf`,
                    },
                    {
                        'resultado': 'Anexo modifiatorio',
                        'urlresultado': `${ ligabase }10/N58/AMDJAN58.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }10/N58/APN58.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }10/N58/FAN58.pdf`,
                    },
                ],
            },
            // Licitación N57
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N57-2024.',
                'vigencia': 'Vigencia de venta de bases: del 8 al 22 de julio de 2024.',
                'descripcionProcedimiento': 'Estudio y proyecto para la solución en el crucero sobre la C.F. Pachuca - Tampico hacia el Boulevard   Chalahuiyapa en el municipio de Huejutla de Reyes.; ubicada en la localidad de Chalahiuyapa, Municipio de Huejutla de Reyes, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }10/N57/N57.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }10/N57/JAN57.pdf`,
                    },
                    {
                        'resultado': 'Anexo modificatorio',
                        'urlresultado': `${ ligabase }10/N57/AMDJAN57.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }10/N57/APN57.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }10/N57/FAN57.pdf`,
                    },
                ],
            },
            // Licitación N56
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N56-2024.',
                'vigencia': 'Vigencia de venta de bases: del 8 al 22 de julio de 2024.',
                'descripcionProcedimiento': 'Construcción de comedor en Casa del Niño DIF.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }10/N56/N56.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }10/N56/JAN56.pdf`,
                    },
                    {
                        'resultado': 'Anexo modificatorio',
                        'urlresultado': `${ ligabase }10/N56/AMDJAN56.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }10/N56/APN56.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }10/N56/FAN56.pdf`,
                    },
                ],
            },
            // Licitación N55
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N55-2024.',
                'vigencia': 'Vigencia de venta de bases: del 8 al 19 de julio de 2024.',
                'descripcionProcedimiento': 'Construcción de acceso a la Unidad Deportiva y Ciclovía, en el municipio de San Agustín Tlaxiaca.; ubicada en la localidad de El Huzache, Municipio de San Agustín Tlaxiaca, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }10/N55/N55.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }10/N55/JAN55.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }10/N55/APN55.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }10/N55/FAN55.pdf`,
                    },
                ],
            },
            // Licitación N54
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N54-2024.',
                'vigencia': 'Vigencia de venta de bases: del 8 al 19 de julio de 2024.',
                'descripcionProcedimiento': 'Reconstrucción de pavimento asfáltico Pachuca - La Estanzuela - Las Milpas, en el municipio de Mineral del Chico.; ubicada en Varias localidades del Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }10/N54/N54.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }10/N54/JAN54.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }10/N54/APN54.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }10/N54/FAN54.pdf`,
                    },
                ],
            },
            // Licitación N53
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N53-2024.',
                'vigencia': 'Vigencia de venta de bases: del 8 al 19 de julio de 2024.',
                'descripcionProcedimiento': 'Reconstrucción de la C.E. Husaca de Ocampo - Tulancingo; ubicada en Varias localidades del Municipio de Huasca de Ocampo, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }10/N53/N53.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }10/N53/JAN53.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }10/N53/APN53.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }10/N53/FAN53.pdf`,
                    },
                ],
            },
            // Licitación N52
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N52-2024.',
                'vigencia': 'Vigencia de venta de bases: del 8 al 19 de julio de 2024.',
                'descripcionProcedimiento': 'Reconstrucción de la Carretera Tula - Xochitlán, en el municipio de Tula de Allende.; ubicada en la localidad de Xochitlán de las Flores, Municipio de Tula de Allende, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }10/N52/N52.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }10/N52/JAN52.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }10/N52/APN52.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }10/N52/FAN52.pdf`,
                    },
                ],
            },
            // Licitación N51
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N51-2024.',
                'vigencia': 'Vigencia de venta de bases: del 8 al 19 de julio de 2024.',
                'descripcionProcedimiento': 'Pavimentación hidráulica en Avenida Remedios y calle Héroes de la Independencia, localidad El Tablón, en el municipio de San Salvador.; ubicada en la localidad de El Tablón, Municipio de San Salvador, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }10/N51/N51.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }10/N51/JAN51.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }10/N51/APN51.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }10/N51/FAN51.pdf`,
                    },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 009
        'numConvocatoria': 'Convocatoria No. 009/2024.',
        'idConvocatoria': 'Convocatoria9',
        'procedimientos': [
            // Licitación N50
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N50-2024.',
                'vigencia': 'Vigencia de venta de bases: del 1 al 15 de julio de 2024',
                'descripcionProcedimiento': 'Arco de Bienvenida Omitlán de Juárez; ubicado en la localidad y Municipio de Omitlán de Juárez, Estado de Hidalgo. (Segundo procedimiento)',
                'urlAnexos': `${ ligabase }9/N50/N50.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }9/N50/JAN50.pdf`,
                    },
                    {
                        'resultado': 'Anexo modificatorio',
                        'urlresultado': `${ ligabase }9/N50/AMDJAN50.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }9/N50/APN50.pdf`,
                    },
                    {
                        'resultado': 'Anexo modificatorio',
                        'urlresultado': `${ ligabase }9/N50/AMDAPN50.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }9/N50/FAN50.pdf`,
                    },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 008
        'numConvocatoria': 'Convocatoria No. 008/2024.',
        'idConvocatoria': 'Convocatoria8',
        'procedimientos': [
            // Licitación N49
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N49-2024.',
                'vigencia': 'Vigencia de venta de bases: del 24 de junio al 9 de julio de 2024',
                'descripcionProcedimiento': 'Construcción de sanitario con biodigestor en el municipio de Huejutla de Reyes; ubicada en Varias localidades del Municipio de Huejutla de Reyes, Estado de Hidalgo. (Segundo procedimiento)',
                'urlAnexos': `${ ligabase }8/N49/N49.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }8/N49/JAN49.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }8/N49/APN49.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }8/N49/FAN49.pdf`,
                    },
                ],
            },
            // Licitación N48
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N48-2024.',
                'vigencia': 'Vigencia de venta de bases: del 24 de junio al 9 de julio de 2024.',
                'descripcionProcedimiento': 'Estudio y proyecto para el encauzamiento y saneamiento del Río Chinguiñoso, en el municipio de Huejutla de Reyes; ubicado en la localidad y Municipio de Huejutla de Reyes, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }8/N48/N48.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }8/N48/JAN48.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }8/N48/APN48.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }8/N48/FAN48.pdf`,
                    },
                ],
            },
            // Licitación N47
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N47-2024.',
                'vigencia': 'Vigencia de venta de bases: del 24 de junio al 9 de julio de 2024.',
                'descripcionProcedimiento': 'Estudio y proyecto para la solución del conflicto vial en el Distribuidor Miguel Hidalgo, en el municipio de Pachuca de Soto; ubicado en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }8/N47/N47.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }8/N47/JAN47.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }8/N47/APN47.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }8/N47/FAN47.pdf`,
                    },
                ],
            },
            // Licitación N46
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N46-2024.',
                'vigencia': 'Vigencia de venta de bases: del 24 de junio al 9 de julio de 2024.',
                'descripcionProcedimiento': 'Rehabilitación del Boulevard Felipe Ángeles (dos cuerpos), en el municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }8/N46/N46.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }8/N46/JAN46.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }8/N46/APN46.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }8/N46/FAN46.pdf`,
                    },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 007
        'numConvocatoria': 'Convocatoria No. 007/2024.',
        'idConvocatoria': 'Convocatoria7',
        'procedimientos': [
            // Licitación N45
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N45-2024.',
                'vigencia': 'Vigencia de venta de bases: del 24 de junio al 8 de julio de 2024',
                'descripcionProcedimiento': 'Rehabilitación de Albergue Alpino; ubicada en la localidad de Las Ventanas, Municipio de Mineral del Chico, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }7/N45/N45.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }7/N45/JAN45.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }7/N45/APN45.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }7/N45/FAN45.pdf`,
                    },
                ],
            },
            // Licitación N44
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N44-2024.',
                'vigencia': 'Vigencia de venta de bases: del 24 de junio al 8 de julio de 2024.',
                'descripcionProcedimiento': 'Construcción del sistema de alcantarillado sanitario en la localidad de Tepalzingo municipio de Tulancingo de Bravo; ubicada en la localidad de Tepalzingo, Municipio de Tulancingo de Bravo, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }7/N44/N44.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }7/N44/JAN44.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }7/N44/APN44.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }7/N44/FAN44.pdf`,
                    },
                ],
            },
            // Licitación N43
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N43-2024.',
                'vigencia': 'Vigencia de venta de bases: del 24 de junio al 8 de julio de 2024.',
                'descripcionProcedimiento': 'Estudio y proyecto para la solución del conflicto vial en el Distribuidor Colonias, en el municipio de Pachuca de Soto; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }7/N43/N43.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }7/N43/JAN43.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }7/N43/APN43.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }7/N43/FAN43.pdf`,
                    },
                ],
            },
            // Licitación N42
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N42-2024.',
                'vigencia': 'Vigencia de venta de bases: del 24 de junio al 8 de julio de 2024.',
                'descripcionProcedimiento': 'Reconstrucción asfáltica de circuito calle 14 y calle 15, en la col. Piracantos, Tercera Sección, en el municipio de Pachuca de Soto.; ubicada en Varias localidades del Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }7/N42/N42.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }7/N42/JAN42.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }7/N42/APN42.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }7/N42/FAN42.pdf`,
                    },
                ],
            },
            // Licitación N41
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N41-2024.',
                'vigencia': 'Vigencia de venta de bases: del 24 de junio al 8 de julio de 2024.',
                'descripcionProcedimiento': 'Construcción de pavimentación hidráulica de la C.E. Cuautepec - Tulancingo.; ubicada en la localidad de La Esperanza, Municipio de Cuautepec de Hinojosa, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }7/N41/N41.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }7/N41/JAN41.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }7/N41/APN41.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }7/N41/FAN41.pdf`,
                    },
                ],
            },
            // Licitación N40
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N40-2024.',
                'vigencia': 'Vigencia de venta de bases: del 24 de junio al 8 de julio de 2024.',
                'descripcionProcedimiento': 'Rehabilitación asfáltica Cto. México, en el Fraccionamiento Geovillas, municipio de Pachuca de Soto.; ubicada en Varias localidades del Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }7/N40/N40.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }7/N40/JAN40.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }7/N40/APN40.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }7/N40/FAN40.pdf`,
                    },
                ],
            },
            // Licitación N39
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N39-2024.',
                'vigencia': 'Vigencia de venta de bases: del 24 de junio al 8 de julio de 2024.',
                'descripcionProcedimiento': 'Terminación de pavimentación hidráulica en la calle Zafiro, de la col. Punta Krystal, municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }7/N39/N39.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }7/N39/JAN39.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }7/N39/APN39.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }7/N39/FAN39.pdf`,
                    },
                ],
            },
            // Licitación N38
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N38-2024.',
                'vigencia': 'Vigencia de venta de bases: del 24 de junio al 8 de julio de 2024.',
                'descripcionProcedimiento': 'Pavimentación de concreto hidráulico en calle de acceso a la comunidad de La Escondida, municipio de Chapulhuacán.; ubicada en la localidad de La Escondida, Municipio de Chapulhuacán, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }7/N38/N38.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }7/N38/JAN38.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }7/N38/APN38.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }7/N38/FAN38.pdf`,
                    },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 006
        'numConvocatoria': 'Convocatoria No. 006/2024.',
        'idConvocatoria': 'Convocatoria6',
        'procedimientos': [
            // Licitación N37
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N37-2024.',
                'vigencia': 'Vigencia de venta de bases: del 17 de junio al 1 de julio de 2024',
                'descripcionProcedimiento': 'Reconstrucción con concreto hidráulico de calle Antiguo Camino FFCC a entroncar con Blvd. Nuevo Hidalgo en la col. Villas de Pachuca, en el municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }6/N37/N37.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }6/N37/JAN37.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }6/N37/APN37.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }6/N37/FAN37.pdf`,
                    },
                ],
            },
            // Licitación N36
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N36-2024.',
                'vigencia': 'Vigencia de venta de bases: del 17 de junio al 1 de julio de 2024.',
                'descripcionProcedimiento': 'Rehabilitación de la Av. Miguel Hidalgo en la localidad de Santiago Tlapacoya, en el municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }6/N36/N36.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }6/N36/JAN36.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }6/N36/APN36.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }6/N36/FAN36.pdf`,
                    },
                ],
            },
            // Licitación N35
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N35-2024.',
                'vigencia': 'Vigencia de venta de bases: del 17 de junio al 1 de julio de 2024.',
                'descripcionProcedimiento': 'Rehabilitación de Calle 14 de Febrero, Col. San Antonio El Desmonte, municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }6/N35/N35.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }6/N35/JAN35.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }6/N35/APN35.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }6/N35/FAN35.pdf`,
                    },
                ],
            },
            // Licitación N34
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N34-2024.',
                'vigencia': 'Vigencia de venta de bases: del 17 de junio al 1 de julio de 2024.',
                'descripcionProcedimiento': 'Reconstrucción de carpeta asfáltica en acceso principal Av. Rojo Gómez Ampliación El Palmar, municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }6/N34/N34.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }6/N34/JAN34.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }6/N34/APN34.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }6/N34/FAN34.pdf`,
                    },
                ],
            },
            // Licitación N33
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N33-2024.',
                'vigencia': 'Vigencia de venta de bases: del 17 de junio al 1 de julio de 2024.',
                'descripcionProcedimiento': 'Rehabilitación de calles de Altamirano a Observatorio, Barrio El Atorón, La Palma, en el municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }6/N33/N33.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }6/N33/JAN33.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }6/N33/APN33.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }6/N33/FAN33.pdf`,
                    },
                ],
            },
            // Licitación N32
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N32-2024.',
                'vigencia': 'Vigencia de venta de bases: del 17 de junio al 1 de julio de 2024.',
                'descripcionProcedimiento': 'Rehabilitación de calle Terreristas en la Col. Cubitos, municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }6/N32/N32.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }6/N32/JAN32.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }6/N32/APN32.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }6/N32/FAN32.pdf`,
                    },
                ],
            },
            // Licitación N31
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N31-2024.',
                'vigencia': 'Vigencia de venta de bases: del 17 de junio al 1 de julio de 2024.',
                'descripcionProcedimiento': 'Rehabilitación de callejón Quintana Roo; Barrio El Mosco, en el municipio de Pachuca de Soto .; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }6/N31/N31.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }6/N31/JAN31.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }6/N31/APN31.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }6/N31/FAN31.pdf`,
                    },
                ],
            },
            // Licitación N30
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N30-2024.',
                'vigencia': 'Vigencia de venta de bases: del 17 al 28 de junio de 2024.',
                'descripcionProcedimiento': 'Rehabilitación de callejón Rafael Lavista, San Clemente- Patoni, municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }6/N30/N30.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }6/N30/JAN30.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }6/N30/APN30.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }6/N30/FAN30.pdf`,
                    },
                ],
            },
            // Licitación N29
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N29-2024.',
                'vigencia': 'Vigencia de venta de bases: del 17 al 28 de junio de 2024.',
                'descripcionProcedimiento': 'Rehabilitación de calle 1, Col. Javier Rojo Gómez, municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }6/N29/N29.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }6/N29/JAN29.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }6/N29/APN29.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }6/N29/FAN29.pdf`,
                    },
                ],
            },
            // Licitación N28
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N28-2024.',
                'vigencia': 'Vigencia de venta de bases: del 17 al 28 de junio de 2024.',
                'descripcionProcedimiento': 'Rehabilitación de calle Hermenegildo Galeana entronque con Neptuno, Bo. El Arbolito, municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }6/N28/N28.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }6/N28/JAN28.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }6/N28/APN28.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }6/N28/FAN28.pdf`,
                    },
                ],
            },
            // Licitación N27
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N27-2024.',
                'vigencia': 'Vigencia de venta de bases: del 17 al 28 de junio de 2024.',
                'descripcionProcedimiento': 'Rehabilitación de calle Prolongación Santiago, Barrio La Alcantarilla, en el municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }6/N27/N27.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }6/N27/JAN27.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }6/N27/APN27.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }6/N27/FAN27.pdf`,
                    },
                ],
            },
            // Licitación N26
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N26-2024.',
                'vigencia': 'Vigencia de venta de bases: del 17 al 28 de junio de 2024.',
                'descripcionProcedimiento': 'Pavimentación asfáltica de Av. de La Plata y Av. de las Torres, en la colonia El Palmar, municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }6/N26/N26.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }6/N26/JAN26.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }6/N26/APN26.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }6/N26/FAN26.pdf`,
                    },
                ],
            },
            // Licitación N25
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N25-2024.',
                'vigencia': 'Vigencia de venta de bases: del 17 al 28 de junio de 2024.',
                'descripcionProcedimiento': 'Construcción de huellas de concreto hidráulico y empedrado, en el municipio de Zimapán, en la localidad de Plutarco Elías Calles (Santiago), Manzana Las Lindas, en distintas calles.; ubicada en la localidad de Plutarco Elías Calles (Santiago), Municipio de Zimapán, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }6/N25/N25.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }6/N25/JAN25.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }6/N25/APN25.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }6/N25/FAN25.pdf`,
                    },
                ],
            },
            // Licitación N24
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N24-2024.',
                'vigencia': 'Vigencia de venta de bases: del 17 al 28 de junio de 2024.',
                'descripcionProcedimiento': 'Reconstrucción de concreto hidráulico en calle Venustiano Carranza, en la col. Buenos Aires, municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }6/N24/N24.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }6/N24/JAN24.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }6/N24/APN24.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }6/N24/FAN24.pdf`,
                    },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 005
        'numConvocatoria': 'Convocatoria No. 005/2024.',
        'idConvocatoria': 'Convocatoria5',
        'procedimientos': [
            // Licitación N23
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N23-2024.',
                'vigencia': 'Vigencia de venta de bases: del 10 al 21 de junio de 2024',
                'descripcionProcedimiento': 'Rehabilitación de calle Flor de Alhelí en la localidad de Santa Gertrudis, en el municipio de Pachuca de Soto.; ubicada en la localidad de Santa Gertrudis, Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }5/N23/N23.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }5/N23/JAN23.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }5/N23/APN23.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }5/N23/FAN23.pdf`,
                    },
                ],
            },
            // Licitación N22
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N22-2024.',
                'vigencia': 'Vigencia de venta de bases: del 10 al 21 de junio de 2024.',
                'descripcionProcedimiento': 'Alumbrado público en zona metropolitana.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }5/N22/N22.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }5/N22/JAN22.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }5/N22/APN22.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }5/N22/FAN22.pdf`,
                    },
                ],
            },
            // Licitación N21
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N21-2024.',
                'vigencia': 'Vigencia de venta de bases: del 10 al 21 de junio de 2024.',
                'descripcionProcedimiento': 'Rehabilitación de calle Campo Deportivo, Col Santa Julia, municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }5/N21/N21.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }5/N21/JAN21.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }5/N21/APN21.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }5/N21/FAN21.pdf`,
                    },
                ],
            },
            // Licitación N20
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N20-2024.',
                'vigencia': 'Vigencia de venta de bases: del 10 al 21 de junio de 2024.',
                'descripcionProcedimiento': 'Rehabilitación de calle Nevado de Popocatépetl, Col. San Cayetano, municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }5/N20/N20.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }5/N20/JAN20.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }5/N20/APN20.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }5/N20/FAN20.pdf`,
                    },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 004
        'numConvocatoria': 'Convocatoria No. 004/2024.',
        'idConvocatoria': 'Convocatoria4',
        'procedimientos': [
            // Licitación N19
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N19-2024.',
                'vigencia': 'Vigencia de venta de bases: del 30 de mayo al 5 de junio de 2024',
                'descripcionProcedimiento': 'Fabricación, colocación y montaje de cubierta ligera con membrana arquitectónica especial tipo “Velaría”; con soportes a base de estructuras de acero en arco, ubicada en las Instalaciones de la Feria San Francisco, en la localidad y municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }4/N19/N19.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }4/N19/JAN19.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }4/N19/APN19.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }4/N19/FAN19.pdf`,
                    },
                ],
            },
            // Licitación N18
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N18-2024.',
                'vigencia': 'Vigencia de venta de bases: del 30 de mayo al 5 de junio de 2024.',
                'descripcionProcedimiento': 'Modernización de instalaciones de la Feria San Francisco. Segunda Etapa; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }4/N18/N18.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }4/N18/JAN18.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }4/N18/APN18.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }4/N18/FAN18.pdf`,
                    },
                ],
            },
            // Licitación N17
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N17-2024.',
                'vigencia': 'Vigencia de venta de bases: del 30 de mayo al 5 de junio de 2024.',
                'descripcionProcedimiento': 'Rehabilitación de piso de la explanada "Plaza Juárez"; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }4/N17/N17.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }4/N17/JAN17.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }4/N17/APN17.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }4/N17/FAN17.pdf`,
                    },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 003
        'numConvocatoria': 'Convocatoria No. 003/2024.',
        'idConvocatoria': 'Convocatoria3',
        'procedimientos': [
            // Licitación N16
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N16-2024.',
                'vigencia': 'Vigencia de venta de bases: del 3 al 11 de junio de 2024',
                'descripcionProcedimiento': 'Construcción de sanitario con biodigestor en el municipio de Huejutla de Reyes; ubicada en Varias localidades del Municipio de Huejutla de Reyes, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }3/N16/N16.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }3/N16/JAN16.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }3/N16/APN16.pdf`,
                    },
                    //    {
                    //        'resultado' : 'Fallo',
                    //        'urlresultado' : `${ ligabase }3/N16/FAN16.pdf`,
                    //    },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 002
        'numConvocatoria': 'Convocatoria No. 002/2024.',
        'idConvocatoria': 'Convocatoria2',
        'procedimientos': [
            // Licitación N15
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N15-2024.',
                'vigencia': 'Vigencia de venta de bases: del 27 de mayo al 10 de junio de 2024',
                'descripcionProcedimiento': 'Arco de Bienvenida Omitlán de Juárez; ubicado en la localidad y Municipio de Omitlán de Juárez, Estado de Hidalgo',
                'urlAnexos': `${ ligabase }2/N15/N15.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }2/N15/JAN15.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }2/N15/APN15.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }2/N15/FAN15.pdf`,
                    },
                ],
            },
            // Licitación N14
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N14-2024.',
                'vigencia': 'Vigencia de venta de bases: del 27 de mayo al 10 de junio de 2024.',
                'descripcionProcedimiento': 'Iluminación de calle principal de Omitlán de Juárez; ubicada en la localidad y Municipio de Omitlán de Juárez, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }2/N14/N14.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }2/N14/JAN14.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }2/N14/APN14.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }2/N14/FAN14.pdf`,
                    },
                ],
            },
            // Licitación N13
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N13-2024.',
                'vigencia': 'Vigencia de venta de bases: del 27 de mayo al 10 de junio de 2024.',
                'descripcionProcedimiento': 'Construcción de pavimentación concreto hidráulico en calle Guillermo Prieto, colonia Francisco I. Madero (La Surtidora), municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }2/N13/N13.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }2/N13/JAN13.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }2/N13/APN13.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }2/N13/FAN13.pdf`,
                    },
                ],
            },
            // Licitación N12
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N12-2024.',
                'vigencia': 'Vigencia de venta de bases: del 27 de mayo al 10 de junio de 2024.',
                'descripcionProcedimiento': 'Construcción de pavimentación concreto hidráulico en calle Colonias, Venecia en el municipio de Pachuca de Soto.; ubicada en Varias localidades del Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }2/N12/N12.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }2/N12/JAN12.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }2/N12/APN12.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }2/N12/FAN12.pdf`,
                    },
                ],
            },
            // Licitación N11
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N11-2024.',
                'vigencia': 'Vigencia de venta de bases: del 27 de mayo al 10 de junio de 2024.',
                'descripcionProcedimiento': 'Rehabilitación calle C. Quetzalcóatl y calle Atlantes, Col Aquiles Serdán, Municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }2/N11/N11.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }2/N11/JAN11.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }2/N11/APN11.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }2/N11/FAN11.pdf`,
                    },
                ],
            },
            // Licitación N10
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N10-2024.',
                'vigencia': 'Vigencia de venta de bases: del 27 de mayo al 10 de junio de 2024.',
                'descripcionProcedimiento': 'Construcción de pavimentación en calle Hatsheput (Sinai), colonia Faraona, Pachuca, Hidalgo.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }2/N10/N10.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }2/N10/JAN10.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }2/N10/APN10.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }2/N10/FAN10.pdf`,
                    },
                ],
            },
            // Licitación N9
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N9-2024.',
                'vigencia': 'Vigencia de venta de bases: del 27 de mayo al 10 de junio de 2024.',
                'descripcionProcedimiento': 'Rehabilitación asfáltica del Boulevard Panorámico, en el municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }2/N9/N9.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }2/N9/JAN9.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }2/N9/APN9.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }2/N9/FAN9.pdf`,
                    },
                ],
            },
            // Licitación N8
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N8-2024.',
                'vigencia': 'Vigencia de venta de bases: del 27 de mayo al 7 de junio de 2024.',
                'descripcionProcedimiento': 'Rehabilitación de las calles Emiliano Zapata y Juan de Dios Peza, Col. Cuauhtémoc, en el municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }2/N8/N8.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }2/N8/JAN8.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }2/N8/APN8.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }2/N8/FAN8.pdf`,
                    },
                    {
                        'resultado': 'Anexo modificatorio',
                        'urlresultado': `${ ligabase }2/N8/AMDFAN8.pdf`,
                    },
                ],
            },
            // Licitación N7
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N7-2024.',
                'vigencia': 'Vigencia de venta de bases: del 27 de mayo al 7 de junio de 2024.',
                'descripcionProcedimiento': 'Reconstrucción de Circuito Cardenal en la colonia Campo de Tiro, en el municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }2/N7/N7.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }2/N7/JAN7.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }2/N7/APN7.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }2/N7/FAN7.pdf`,
                    },
                ],
            },
            // Licitación N6
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N6-2024.',
                'vigencia': 'Vigencia de venta de bases: del 27 de mayo al 7 de junio de 2024.',
                'descripcionProcedimiento': 'Construcción de Pavimentación Concreto Hidráulico en calle Ejido 10, Matilde, municipio de Pachuca de Soto.; ubicada en Varias localidades del Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }2/N6/N6.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }2/N6/JAN6.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }2/N6/APN6.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }2/N6/FAN6.pdf`,
                    },
                ],
            },
            // Licitación N5
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N5-2024.',
                'vigencia': 'Vigencia de venta de bases: del 27 de mayo al 7 de junio de 2024.',
                'descripcionProcedimiento': 'Construcción de Pavimentación Hidráulica en calle Prolongación Esmeralda, Independencia, municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }2/N5/N5.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }2/N5/JAN5.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }2/N5/APN5.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }2/N5/FAN5.pdf`,
                    },
                ],
            },
            // Licitación N4
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N4-2024.',
                'vigencia': 'Vigencia de venta de bases: del 27 de mayo al 7 de junio de 2024.',
                'descripcionProcedimiento': 'Rehabilitación Asfáltica Avenida Principal de la 3ra de Pitahayas, Fraccionamiento Pitahayas, municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }2/N4/N4.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }2/N4/JAN4.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }2/N4/APN4.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }2/N4/FAN4.pdf`,
                    },
                ],
            },
            // Licitación N3
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N3-2024.',
                'vigencia': 'Vigencia de venta de bases: del 27 de mayo al 7 de junio de 2024.',
                'descripcionProcedimiento': 'Construcción de Pavimentación Hidráulica en calle Evita Perón, calle Josefa O. de Domínguez, calle Leona Vicario, La Condesa, municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }2/N3/N3.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }2/N3/JAN3.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }2/N3/APN3.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }2/N3/FAN3.pdf`,
                    },
                ],
            },
            // Licitación N2
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N2-2024.',
                'vigencia': 'Vigencia de venta de bases: del 27 de mayo al 7 de junio de 2024.',
                'descripcionProcedimiento': 'Reconstrucción de Pavimento de Concreto Hidráulico en calle Lago de Guadalupe y calle Lago de Zumpango, Anáhuac, municipio de Pachuca de Soto; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }2/N2/N2.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }2/N2/JAN2.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }2/N2/APN2.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }2/N2/FAN2.pdf`,
                    },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 001
        'numConvocatoria': 'Convocatoria No. 001/2024.',
        'idConvocatoria': 'Convocatoria1',
        'procedimientos': [
            // Licitación N1
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N1-2024.',
                'vigencia': 'Vigencia de venta de bases: del 15 al 19 de abril de 2024',
                'descripcionProcedimiento': ' Reconstrucción de empedrados de calles principales del centro de Huasca y construcción de pasos peatonales; ubicada en la localidad y Municipio de Huasca de Ocampo, Estado de Hidalgo.',
                'urlAnexos': `${ ligabase }1/N1/N1.rar`,
                'resultados': [{
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ ligabase }1/N1/JAN1.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ ligabase }1/N1/APN1.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ ligabase }1/N1/FAN1.pdf`,
                    },
                ],
            },
        ],
    },
]